var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polyline, _polyline2, _polygon, _path19, _polygon2, _polygon3, _polygon4, _path20, _path21, _path22, _polygon5, _path23, _path24, _path25, _path26, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path27, _polygon11, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon12, _path35, _polygon13, _path36, _path37, _polygon14, _path38, _polygon15, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon16, _polygon17, _path52, _path53, _path54, _polygon18, _path55, _path56, _path57, _path58, _path59, _polygon19, _polygon20, _path60, _polygon21, _polygon22, _path61, _polygon23, _polygon24, _polygon25, _path62, _path63, _polygon26, _polygon27, _path64, _polygon28, _polygon29, _polygon30, _path65, _path66, _path67, _polygon31, _path68, _path69, _path70, _polygon32, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _polygon33, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _g, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _ellipse, _path202, _path203, _path204, _path205;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 658.4 599.8",
    style: {
      enableBackground: "new 0 0 658.4 599.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:none;}\n\t.st10{fill:#806C2D;}\n\t.st11{fill:#85702F;}\n\t.st12{fill:url(#SVGID_10_);}\n\t.st13{fill:url(#SVGID_11_);}\n\t.st14{fill:url(#SVGID_12_);}\n\t.st15{fill:url(#SVGID_13_);}\n\t.st16{display:none;opacity:0.67;}\n\t.st17{fill:#455164;}\n\t.st18{fill:#434E61;}\n\t.st19{fill:#404B5D;}\n\t.st20{fill:#3E485A;}\n\t.st21{fill:url(#SVGID_14_);}\n\t.st22{fill:url(#SVGID_15_);}\n\t.st23{fill:url(#SVGID_16_);}\n\t.st24{fill:url(#SVGID_17_);}\n\t.st25{fill:url(#SVGID_18_);}\n\t.st26{fill:url(#SVGID_19_);}\n\t.st27{fill:url(#SVGID_20_);}\n\t.st28{fill:url(#SVGID_21_);}\n\t.st29{fill:url(#SVGID_22_);}\n\t.st30{fill:url(#SVGID_23_);}\n\t.st31{fill:url(#SVGID_24_);}\n\t.st32{fill:url(#SVGID_25_);}\n\t.st33{fill:url(#SVGID_26_);}\n\t.st34{fill:url(#SVGID_27_);}\n\t.st35{fill:url(#SVGID_28_);}\n\t.st36{fill:#949494;}\n\t.st37{fill:url(#SVGID_29_);}\n\t.st38{fill:url(#SVGID_30_);}\n\t.st39{fill:#858585;}\n\t.st40{fill:url(#SVGID_31_);}\n\t.st41{fill:url(#SVGID_32_);}\n\t.st42{fill:url(#SVGID_33_);}\n\t.st43{fill:url(#SVGID_34_);}\n\t.st44{fill:url(#SVGID_35_);}\n\t.st45{fill:url(#SVGID_36_);}\n\t.st46{fill:url(#SVGID_37_);}\n\t.st47{fill:url(#SVGID_38_);}\n\t.st48{fill:url(#SVGID_39_);}\n\t.st49{fill:url(#SVGID_40_);}\n\t.st50{fill:url(#SVGID_41_);}\n\t.st51{fill:url(#SVGID_42_);}\n\t.st52{fill:url(#SVGID_43_);}\n\t.st53{display:none;}\n\t.st54{fill:#A13154;}\n\t.st55{fill:#C2385E;}\n\t.st56{fill:#FF4F4F;}\n\t.st57{fill:#FFC900;}\n\t.st58{fill:none;stroke:#FFE571;stroke-width:1.8982;stroke-miterlimit:10;}\n\t.st59{fill:#FFE571;}\n\t.st60{fill:url(#SVGID_44_);}\n\t.st61{fill:url(#SVGID_45_);}\n\t.st62{fill:#399668;}\n\t.st63{fill:#65EFAD;}\n\t.st64{fill:#41681F;}\n\t.st65{fill:url(#SVGID_46_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 584.7281,
    y1: 125.6478,
    x2: 584.7281,
    y2: 125.6478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9F1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01090964,
    style: {
      stopColor: "#FFA62F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03165415,
    style: {
      stopColor: "#FFB14E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05515078,
    style: {
      stopColor: "#FFBB6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08169074,
    style: {
      stopColor: "#FFC380"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1127,
    style: {
      stopColor: "#FFC990"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    style: {
      stopColor: "#FFCD9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2047,
    style: {
      stopColor: "#FFCFA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3532,
    style: {
      stopColor: "#FFD0A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD04F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.7,125.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.2841,
    y1: 304.0154,
    x2: 628.6448,
    y2: 304.0154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0787727,
    style: {
      stopColor: "#E59532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    style: {
      stopColor: "#AA5F0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6194,
    style: {
      stopColor: "#E59532"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M628.6,229.2c0,0.3,0,0.5,0,0.8c0,0.4,0,0.9-0.1,1.3c0,0.2,0,0.4,0,0.6l0,0.4c0,0.4-0.1,0.7-0.1,1.1 c0,0.3-0.1,0.6-0.1,0.8c0,0.2-0.1,0.5-0.1,0.7l-0.1,0.4l0,0.1c-0.1,0.3-0.1,0.5-0.2,0.8l-0.1,0.3c-0.1,0.4-0.2,0.8-0.3,1.2l-0.1,0.2 l0,0.1l0,0.1c-0.2,0.7-0.4,1.3-0.7,2c-0.1,0.2-0.1,0.3-0.2,0.5l-0.1,0.1c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.3-0.2,0.5-0.4,0.8 c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.2-0.2,0.4-0.3,0.7l-0.2,0.4l-0.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,0.4-0.5,0.8-0.8,1.3 c-0.1,0.2-0.3,0.4-0.4,0.6l-0.1,0.2l0,0c-0.3,0.5-0.7,0.9-1,1.4l-0.1,0.2c-0.2,0.3-0.5,0.6-0.7,0.8l-0.4,0.4l-0.3,0.3l-0.1,0.1 c-0.6,0.7-1.2,1.3-1.9,2l-113.2,108v18.9l113.2-108c0.7-0.7,1.4-1.4,2-2.1l0.3-0.3l0.4-0.4c0.7-0.8,1.3-1.6,1.9-2.4l0,0 c0.6-0.8,1.1-1.7,1.6-2.6c0.1-0.2,0.2-0.3,0.3-0.5l0.2-0.4c0.4-0.7,0.7-1.4,1-2.1c0.1-0.2,0.1-0.3,0.2-0.5c0.4-0.9,0.7-1.8,1-2.7 l0.1-0.3c0.1-0.5,0.3-1,0.4-1.5c0.1-0.4,0.2-0.7,0.3-1.1l0.1-0.4c0.2-0.9,0.3-1.8,0.4-2.7c0-0.2,0-0.4,0.1-0.6 c0.1-0.9,0.1-1.8,0.1-2.8v-18.9L628.6,229.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.8556,
    y1: 304.0212,
    x2: 131.2824,
    y2: 304.0212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0787727,
    style: {
      stopColor: "#E59532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    style: {
      stopColor: "#AA5F0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6194,
    style: {
      stopColor: "#E59532"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.8,249.9c-0.2-0.2-0.4-0.4-0.6-0.7c-0.5-0.6-1-1.3-1.5-1.9c-0.1-0.2-0.3-0.4-0.4-0.5 c-0.6-0.8-1.1-1.7-1.5-2.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.4-0.7-0.7-1.4-1-2.1c-0.1-0.2-0.2-0.5-0.3-0.7c-0.4-0.9-0.7-1.8-1-2.7l0-0.1 c-0.3-0.9-0.5-1.7-0.7-2.6c-0.1-0.3-0.1-0.5-0.1-0.8c-0.1-0.7-0.2-1.5-0.3-2.2c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.9-0.1-1.8-0.1-2.7 l0-0.2v18.9c0,8.2,3.2,16.6,10.1,23.3l113.3,108v-18.9L18,252.2C17.2,251.4,16.5,250.7,15.8,249.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.6726,
    y1: 550.55,
    x2: 522.9272,
    y2: 550.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0787727,
    style: {
      stopColor: "#E59532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    style: {
      stopColor: "#AA5F0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6194,
    style: {
      stopColor: "#E59532"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M522.9,548.4c0,0.5,0,1.1,0,1.6l0,0.3c0,0.4-0.1,0.8-0.1,1.2l0,0.4l0,0.3c0,0.2-0.1,0.4-0.1,0.5 c-0.1,0.4-0.1,0.9-0.2,1.3c0,0.2-0.1,0.5-0.1,0.7c0,0.2-0.1,0.3-0.1,0.5c0,0.2-0.1,0.4-0.1,0.7l0,0.1c-0.1,0.2-0.1,0.4-0.2,0.7 c-0.1,0.3-0.2,0.7-0.3,1l-0.1,0.4l-0.1,0.4l0,0c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.3-0.2,0.6-0.4,0.9l0,0.1 l0,0.1c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.3-0.3,0.6-0.4,0.9l-0.1,0.2l-0.3,0.4c-0.1,0.2-0.2,0.5-0.4,0.7l0,0l-0.2,0.3 c-0.1,0.2-0.3,0.4-0.4,0.7c-0.2,0.3-0.4,0.6-0.6,1c-0.1,0.2-0.3,0.4-0.4,0.6l-0.2,0.2c-0.2,0.2-0.4,0.5-0.5,0.7 c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.3-0.5,0.6-0.8,0.9l-0.2,0.3l-0.1,0.1l-0.1,0.1c-0.2,0.2-0.4,0.4-0.6,0.7c-0.2,0.2-0.4,0.4-0.6,0.6 c-0.2,0.2-0.4,0.3-0.5,0.5l-0.3,0.3l-0.4,0.4c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2,0.2-0.4,0.4-0.6,0.5l-0.4,0.3l-0.3,0.3l0,0 c-0.2,0.2-0.4,0.3-0.7,0.5c-0.2,0.2-0.5,0.4-0.8,0.5c-0.2,0.2-0.5,0.3-0.7,0.5l-0.2,0.1l-0.2,0.1l-0.4,0.3c-0.2,0.1-0.5,0.3-0.7,0.4 c-0.3,0.2-0.5,0.3-0.8,0.5c-0.2,0.1-0.4,0.3-0.7,0.4l-0.1,0l0,0c-0.3,0.1-0.6,0.3-0.8,0.4c-0.3,0.1-0.5,0.2-0.7,0.4 c-0.3,0.1-0.6,0.2-0.9,0.4l-0.2,0.1l-0.3,0.1l-0.3,0.1c-0.3,0.1-0.6,0.2-0.9,0.3c-0.3,0.1-0.5,0.2-0.8,0.3c-0.2,0.1-0.5,0.2-0.7,0.2 l-0.4,0.1c-0.2,0.1-0.3,0.1-0.5,0.2c-0.3,0.1-0.6,0.2-1,0.2c-0.3,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1 c-0.2,0-0.3,0.1-0.5,0.1l-0.1,0c-0.3,0-0.5,0.1-0.8,0.1c-0.3,0.1-0.7,0.1-1,0.1c-0.3,0-0.5,0.1-0.8,0.1l-0.2,0l-0.3,0 c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0.1c-0.6,0-1.2,0-1.8,0c-5.2,0-10.5-1.2-15.6-3.9l-140-72c-4.9-2.5-10.2-3.8-15.5-3.8 c-5.3,0-10.7,1.3-15.5,3.8l-140.1,72c-5.1,2.7-10.4,3.9-15.6,3.9c-1,0-2-0.1-3.1-0.2l-0.3,0c-1-0.1-1.9-0.2-2.8-0.4 c-0.2,0-0.3-0.1-0.5-0.1c-0.9-0.2-1.8-0.4-2.7-0.7c-0.2,0-0.3-0.1-0.5-0.1c-0.9-0.3-1.8-0.6-2.6-0.9l-0.4-0.2 c-0.9-0.4-1.8-0.8-2.6-1.2l-0.2-0.1c-0.9-0.5-1.7-0.9-2.5-1.5l-0.2-0.1c-0.8-0.5-1.6-1.1-2.3-1.7l-0.3-0.3c-0.7-0.6-1.4-1.2-2.1-1.8 l-0.3-0.3c-0.7-0.6-1.3-1.3-1.9-2l-0.3-0.3c-0.6-0.7-1.2-1.5-1.7-2.2l-0.2-0.3c-0.6-0.8-1.1-1.6-1.6-2.5l0,0 c-0.5-0.9-0.9-1.7-1.3-2.6l-0.2-0.3c-0.4-0.9-0.7-1.8-1-2.7l-0.2-0.5c-0.3-0.9-0.5-1.8-0.7-2.7c0-0.2-0.1-0.3-0.1-0.5 c-0.2-0.9-0.4-1.9-0.5-2.9l0-0.4c-0.1-1-0.2-2-0.2-3.1l0,0v18.9c0,18.4,15.8,32.6,33.4,32.6c5.1,0,10.5-1.2,15.6-3.9l140.1-72 c4.9-2.5,10.2-3.8,15.5-3.8c5.3,0,10.7,1.3,15.5,3.8l140,72c5.1,2.7,10.5,3.9,15.6,3.9c1,0,2-0.1,3-0.2l0.4,0c1-0.1,1.9-0.2,2.8-0.4 c0.2,0,0.3-0.1,0.5-0.1c0.9-0.2,1.8-0.4,2.7-0.7c0.2,0,0.3-0.1,0.5-0.1c0.9-0.3,1.8-0.6,2.7-0.9l0.3-0.1c0.9-0.4,1.8-0.8,2.7-1.2 l0.1,0c0.9-0.5,1.7-1,2.5-1.5l0.3-0.2c0.8-0.5,1.5-1.1,2.3-1.6l0.4-0.3c0.7-0.6,1.4-1.2,2.1-1.8l0.3-0.3c0.6-0.6,1.2-1.2,1.8-1.9 l0.1-0.1l0.2-0.3c0.6-0.6,1.1-1.3,1.6-2l0.3-0.4c0.5-0.8,1-1.5,1.5-2.3c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.3,0.3-0.6,0.5-0.9 c0.3-0.5,0.6-1.1,0.8-1.6l0-0.1c0.4-0.9,0.7-1.8,1-2.7l0.1-0.4c0.2-0.7,0.4-1.5,0.6-2.2c0-0.2,0.1-0.4,0.2-0.6 c0-0.2,0.1-0.4,0.1-0.5c0.2-0.9,0.4-1.9,0.5-2.9c0-0.2,0-0.3,0-0.5c0.1-1,0.2-2.1,0.2-3.1L522.9,548.4L522.9,548.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.9785,
    y1: 289.4191,
    x2: 604.6214,
    y2: 289.4191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD04F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5129,
    style: {
      stopColor: "#FFCE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6976,
    style: {
      stopColor: "#FFC846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8293,
    style: {
      stopColor: "#FFBD3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#FFAD2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9F1B"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32,233.6c0,0.8,0,1.7,0.1,2.5c0,0.2,0,0.4,0.1,0.5c0.1,0.7,0.2,1.4,0.3,2.1c0,0.2,0.1,0.5,0.1,0.7 c0.2,0.8,0.4,1.6,0.6,2.4l0,0.1c0.3,0.8,0.6,1.6,0.9,2.5c0.1,0.2,0.2,0.4,0.3,0.7c0.3,0.6,0.6,1.3,0.9,1.9 c0.1,0.2,0.2,0.4,0.3,0.5c0.4,0.8,0.9,1.6,1.4,2.3c0.1,0.2,0.2,0.3,0.4,0.5c0.4,0.6,0.9,1.2,1.4,1.8c0.2,0.2,0.3,0.4,0.5,0.6 c0.6,0.7,1.3,1.4,2,2.1l104.5,99.6c0.7,0.6,1.3,1.3,1.9,2l0.3,0.4c0.6,0.7,1.1,1.4,1.6,2.1l0.3,0.4c0.5,0.7,1,1.5,1.4,2.3l0,0.1 c0.4,0.8,0.8,1.6,1.2,2.4c0.1,0.2,0.1,0.3,0.2,0.5c0.3,0.8,0.6,1.6,0.9,2.4c0,0.2,0.1,0.3,0.1,0.5c0.2,0.8,0.5,1.7,0.6,2.5l0,0.2 c0.2,0.9,0.3,1.8,0.4,2.6c0,0.2,0,0.4,0.1,0.5c0.1,0.9,0.1,1.7,0.1,2.6c0,1.7-0.1,3.5-0.4,5.2l-0.7,4.2L130,522 c-0.3,1.8-0.5,3.6-0.5,5.3c0,1,0.1,1.9,0.2,2.9l0,0.4c0.1,0.9,0.2,1.8,0.4,2.7c0,0.1,0.1,0.3,0.1,0.4c0.2,0.9,0.4,1.7,0.7,2.5 l0.1,0.4c0.3,0.8,0.6,1.6,0.9,2.4l0.1,0.3c0.4,0.8,0.8,1.6,1.2,2.4l0,0c0.5,0.8,0.9,1.5,1.5,2.3l0.2,0.2c0.5,0.7,1,1.4,1.6,2 l0.3,0.3c0.6,0.6,1.2,1.3,1.8,1.8l0.3,0.3c0.6,0.6,1.3,1.1,1.9,1.7l0.3,0.2c0.7,0.5,1.4,1.1,2.2,1.5l0.2,0.1 c0.8,0.5,1.5,0.9,2.3,1.3l0.1,0.1c0.8,0.4,1.6,0.8,2.4,1.1l0.3,0.1c0.8,0.3,1.6,0.6,2.4,0.9c0.1,0,0.3,0.1,0.4,0.1 c0.8,0.2,1.7,0.5,2.5,0.6c0.1,0,0.3,0.1,0.4,0.1c0.9,0.2,1.7,0.3,2.6,0.4l0.3,0c0.9,0.1,1.9,0.1,2.8,0.1c4.7,0,9.6-1.1,14.4-3.6 L304,487.4c4.5-2.3,9.4-3.5,14.3-3.5s9.9,1.2,14.3,3.5l129.1,66.4c4.7,2.4,9.6,3.6,14.4,3.6c0.6,0,1.1,0,1.7,0c0.2,0,0.4,0,0.6,0 c0.2,0,0.4,0,0.5,0l0.3,0l0.2,0c0.2,0,0.5-0.1,0.7-0.1c0.3,0,0.6-0.1,0.9-0.1c0.2,0,0.5-0.1,0.7-0.1l0,0c0.1,0,0.3-0.1,0.4-0.1 c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3-0.1,0.6-0.1,0.9-0.2c0.3-0.1,0.6-0.2,0.9-0.3c0.2-0.1,0.5-0.1,0.7-0.2 c0.2-0.1,0.5-0.2,0.7-0.3c0.3-0.1,0.6-0.2,0.8-0.3c0.2-0.1,0.5-0.2,0.7-0.3c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.5-0.2,0.7-0.3 c0.3-0.1,0.5-0.2,0.8-0.4c0.2-0.1,0.4-0.2,0.7-0.4c0.3-0.1,0.5-0.3,0.8-0.4c0.2-0.1,0.4-0.3,0.7-0.4l0.4-0.2l0.2-0.1l0.2-0.1 c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.2,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.3,0.6-0.5l0,0l0.3-0.2l0.3-0.3c0.2-0.2,0.4-0.3,0.6-0.5 c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.4-0.4,0.5-0.6c0.2-0.2,0.4-0.4,0.6-0.6 c0.1-0.2,0.3-0.3,0.4-0.5c0.2-0.3,0.5-0.6,0.7-0.8c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.2,0.3-0.4,0.5-0.7c0.2-0.3,0.4-0.5,0.5-0.8 c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.2,0.2-0.4,0.4-0.6l0.2-0.3l0,0c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.2-0.3,0.2-0.4 c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.3,0.3-0.5,0.4-0.8c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.3,0.2-0.6,0.3-0.8c0.1-0.2,0.2-0.5,0.3-0.7 c0.1-0.3,0.2-0.6,0.3-0.9c0,0,0,0,0,0c0.1-0.2,0.2-0.5,0.2-0.7c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.1-0.5,0.2-0.7 c0-0.2,0.1-0.4,0.1-0.6c0.1-0.4,0.2-0.7,0.2-1.1c0.1-0.4,0.1-0.8,0.2-1.2c0-0.2,0.1-0.3,0.1-0.5l0-0.3l0-0.4 c0-0.4,0.1-0.7,0.1-1.1l0-0.3c0-0.5,0-1,0-1.5c0-1-0.1-2.1-0.2-3.1c-0.1-0.7-0.2-1.5-0.3-2.2l-24-136.6l-0.3-1.7l-0.4-2.5 c-0.3-1.7-0.4-3.5-0.4-5.2c0-0.9,0.1-1.8,0.2-2.8l0-0.4c0.1-1.2,0.4-2.5,0.7-3.7c0.1-0.5,0.3-1.1,0.4-1.6c0-0.1,0.1-0.3,0.1-0.4 c0.3-0.8,0.6-1.7,0.9-2.5c0.1-0.1,0.1-0.3,0.2-0.4c0.2-0.6,0.5-1.1,0.8-1.6c0.1-0.3,0.3-0.5,0.4-0.8l0,0c0.4-0.8,0.9-1.6,1.4-2.3 l0.3-0.4c0.5-0.8,1.1-1.5,1.7-2.2l0.2-0.3c0.6-0.7,1.2-1.4,1.9-2l104.4-99.6c0.6-0.6,1.2-1.2,1.7-1.8c0.5-0.5,0.9-1.1,1.3-1.6 l0.1-0.2c0.4-0.5,0.7-1,1.1-1.5c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.4,0.5-0.8,0.7-1.2c0.1-0.2,0.2-0.3,0.3-0.5 c0.2-0.4,0.5-0.9,0.7-1.3c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.4,0.4-0.9,0.6-1.3c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.6,0.4-1.2,0.6-1.8 l0-0.1l0-0.1l0.1-0.2c0.1-0.5,0.3-0.9,0.4-1.4c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.2-0.8,0.2-1.2c0-0.3,0.1-0.5,0.1-0.8 c0.1-0.5,0.1-0.9,0.2-1.4c0-0.2,0-0.4,0-0.5c0-0.4,0-0.8,0.1-1.2c0-0.2,0-0.5,0-0.7c0.1-14.2-9.9-27.9-26.4-30.3l-144.5-20.5 c-10-1.4-18.7-7.6-23.2-16.5L346,38.3c-5.7-11.2-16.7-16.8-27.7-16.8c-11,0-22,5.6-27.7,16.8l-64.6,128.1 c-4.5,8.9-13.2,15.1-23.2,16.5l-74.1,10.5l-12.7,1.8l-57.7,8.2C41.9,205.7,31.9,219.5,32,233.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.4075,
    y1: 580.9003,
    x2: 265.4075,
    y2: 0.00002041781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9F1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    style: {
      stopColor: "#FFB936"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    style: {
      stopColor: "#FFCA48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD04F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.2,541.8L503.2,541.8l-0.2,0.3c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.3-0.4,0.6-0.6,0.9 c-0.2,0.3-0.3,0.5-0.5,0.8c-0.2,0.2-0.3,0.4-0.5,0.7c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.3-0.5,0.6-0.7,0.8c-0.1,0.2-0.3,0.3-0.4,0.5 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.4,0.4-0.5,0.6c-0.2,0.2-0.3,0.3-0.5,0.5c-0.2,0.2-0.4,0.4-0.7,0.6c-0.2,0.2-0.4,0.4-0.6,0.6 c-0.2,0.2-0.4,0.3-0.6,0.5l-0.3,0.3l-0.3,0.2l0,0c-0.2,0.2-0.4,0.3-0.6,0.5c-0.2,0.2-0.5,0.3-0.7,0.5c-0.2,0.1-0.4,0.3-0.6,0.4 l-0.2,0.1l-0.2,0.1l-0.4,0.2c-0.2,0.1-0.4,0.3-0.7,0.4c-0.2,0.1-0.5,0.3-0.8,0.4c-0.2,0.1-0.4,0.3-0.7,0.4 c-0.3,0.1-0.5,0.3-0.8,0.4c-0.2,0.1-0.5,0.2-0.7,0.3c-0.3,0.1-0.5,0.2-0.8,0.3c-0.2,0.1-0.5,0.2-0.7,0.3c-0.3,0.1-0.6,0.2-0.8,0.3 c-0.2,0.1-0.5,0.2-0.7,0.3c-0.2,0.1-0.5,0.1-0.7,0.2c-0.3,0.1-0.6,0.2-0.9,0.3c-0.3,0.1-0.6,0.1-0.9,0.2c-0.2,0.1-0.5,0.1-0.7,0.2 c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.1l0,0c-0.2,0-0.5,0.1-0.7,0.1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.5,0.1-0.7,0.1 l-0.2,0l-0.3,0c-0.2,0-0.4,0-0.5,0c-0.2,0-0.4,0-0.6,0c-0.6,0-1.1,0-1.7,0c-4.8,0-9.7-1.1-14.4-3.6l-129.1-66.4 c-4.5-2.3-9.4-3.5-14.3-3.5s-9.9,1.2-14.3,3.5l-129.2,66.4c-4.7,2.4-9.6,3.6-14.4,3.6c-0.9,0-1.9-0.1-2.8-0.1l-0.3,0 c-0.9-0.1-1.8-0.2-2.6-0.4c-0.1,0-0.3-0.1-0.4-0.1c-0.8-0.2-1.7-0.4-2.5-0.6c-0.1,0-0.3-0.1-0.4-0.1c-0.8-0.3-1.6-0.5-2.4-0.9 l-0.3-0.1c-0.8-0.3-1.6-0.7-2.4-1.1l-0.1-0.1c-0.8-0.4-1.6-0.9-2.3-1.3l-0.2-0.1c-0.7-0.5-1.5-1-2.2-1.5l-0.3-0.2 c-0.7-0.5-1.3-1.1-1.9-1.7l-0.3-0.3c-0.6-0.6-1.2-1.2-1.8-1.8l-0.3-0.3c-0.6-0.7-1.1-1.3-1.6-2l-0.2-0.2c-0.5-0.7-1-1.5-1.5-2.3 l0,0c-0.5-0.8-0.9-1.6-1.2-2.4l-0.1-0.3c-0.4-0.8-0.7-1.6-0.9-2.4l-0.1-0.4c-0.3-0.8-0.5-1.7-0.7-2.5c0-0.1-0.1-0.3-0.1-0.4 c-0.2-0.9-0.3-1.8-0.4-2.7l0-0.4c-0.1-0.9-0.2-1.9-0.2-2.9c0-1.7,0.1-3.5,0.5-5.3l24-136.5l0.7-4.2c0.3-1.7,0.4-3.5,0.4-5.2 c0-0.9-0.1-1.8-0.1-2.6c0-0.2,0-0.4-0.1-0.5c-0.1-0.9-0.2-1.8-0.4-2.6l0-0.2c-0.2-0.8-0.4-1.7-0.6-2.5c0-0.2-0.1-0.3-0.1-0.5 c-0.3-0.8-0.6-1.6-0.9-2.4c-0.1-0.2-0.1-0.3-0.2-0.5c-0.4-0.8-0.7-1.6-1.2-2.4l0-0.1c-0.4-0.8-0.9-1.5-1.4-2.3l-0.3-0.4 c-0.5-0.7-1-1.4-1.6-2.1l-0.3-0.4c-0.6-0.7-1.2-1.4-1.9-2L41.3,254.9c-0.7-0.7-1.4-1.4-2-2.1c-0.2-0.2-0.3-0.4-0.5-0.6 c-0.5-0.6-0.9-1.2-1.4-1.8c-0.1-0.2-0.2-0.3-0.4-0.5c-0.5-0.8-1-1.5-1.4-2.3c-0.1-0.2-0.2-0.4-0.3-0.5c-0.3-0.6-0.6-1.3-0.9-1.9 c-0.1-0.2-0.2-0.4-0.3-0.7c-0.3-0.8-0.6-1.6-0.9-2.5l0-0.1c-0.2-0.8-0.4-1.6-0.6-2.4c0-0.2-0.1-0.5-0.1-0.7 c-0.1-0.7-0.2-1.4-0.3-2.1c0-0.2,0-0.4-0.1-0.5c-0.1-0.8-0.1-1.7-0.1-2.5c-0.1-14.1,9.9-27.9,26.4-30.2l57.7-8.2 c-1.1-2.9-2.2-5.9-3.2-8.8l-76.3,10.8C18.7,199.7,7.8,214.6,7.9,230c0,0.9,0,1.8,0.1,2.7c0,0.2,0,0.4,0.1,0.6 c0.1,0.7,0.2,1.5,0.3,2.2c0,0.3,0.1,0.5,0.1,0.8c0.2,0.9,0.4,1.8,0.7,2.6l0,0.1c0.3,0.9,0.6,1.8,1,2.7c0.1,0.2,0.2,0.5,0.3,0.7 c0.3,0.7,0.6,1.4,1,2.1c0.1,0.2,0.2,0.4,0.3,0.6c0.5,0.8,1,1.7,1.5,2.5c0.1,0.2,0.3,0.4,0.4,0.5c0.5,0.7,1,1.3,1.5,1.9 c0.2,0.2,0.4,0.4,0.6,0.7c0.7,0.8,1.4,1.6,2.2,2.3l113.3,108c0.7,0.7,1.4,1.4,2.1,2.2l0.4,0.4c0.6,0.7,1.2,1.5,1.8,2.3l0.3,0.4 c0.5,0.8,1.1,1.6,1.5,2.5l0,0.1c0.5,0.9,0.9,1.7,1.3,2.6c0.1,0.2,0.2,0.3,0.2,0.5c0.4,0.9,0.7,1.8,1,2.7c0.1,0.2,0.1,0.3,0.1,0.5 c0.3,0.9,0.5,1.8,0.7,2.7l0,0.2c0.2,0.9,0.3,1.9,0.4,2.9c0,0.2,0,0.4,0.1,0.6c0.1,0.9,0.1,1.9,0.1,2.8c0,1.9-0.1,3.8-0.5,5.6 l-0.8,4.6l-26,148c-0.3,2-0.5,3.9-0.5,5.8c0,1,0.1,2.1,0.2,3.1l0,0.4c0.1,1,0.3,1.9,0.5,2.9c0,0.2,0.1,0.3,0.1,0.5 c0.2,0.9,0.5,1.8,0.7,2.7l0.2,0.5c0.3,0.9,0.6,1.8,1,2.7l0.2,0.3c0.4,0.9,0.9,1.8,1.3,2.6l0,0c0.5,0.8,1,1.7,1.6,2.5l0.2,0.3 c0.5,0.8,1.1,1.5,1.7,2.2l0.3,0.3c0.6,0.7,1.2,1.4,1.9,2l0.3,0.3c0.7,0.6,1.4,1.2,2.1,1.8l0.3,0.3c0.8,0.6,1.5,1.1,2.3,1.7 l0.2,0.1c0.8,0.5,1.7,1,2.5,1.5l0.2,0.1c0.9,0.4,1.7,0.8,2.6,1.2l0.4,0.2c0.9,0.3,1.8,0.7,2.6,0.9c0.2,0,0.3,0.1,0.5,0.1 c0.9,0.3,1.8,0.5,2.7,0.7c0.2,0,0.3,0.1,0.5,0.1c0.9,0.2,1.9,0.3,2.8,0.4l0.3,0c1,0.1,2,0.2,3.1,0.2c5.1,0,10.5-1.2,15.6-3.9 l140.1-72c4.9-2.5,10.2-3.8,15.5-3.8c5.3,0,10.7,1.3,15.5,3.8l140,72c5.1,2.7,10.5,3.9,15.6,3.9c0.6,0,1.2,0,1.8,0 c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4,0,0.6,0l0.3,0l0.2,0c0.3,0,0.5-0.1,0.8-0.1c0.3,0,0.7-0.1,1-0.1c0.3,0,0.5-0.1,0.8-0.1l0.1,0 c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.3-0.1,0.5-0.1c0.3-0.1,0.5-0.1,0.8-0.2c0.3-0.1,0.6-0.2,1-0.2c0.3-0.1,0.6-0.2,1-0.3 c0.2-0.1,0.5-0.1,0.7-0.2c0.3-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.2,0.9-0.4 c0.3-0.1,0.5-0.2,0.7-0.4c0.3-0.1,0.6-0.3,0.8-0.4c0.2-0.1,0.5-0.3,0.7-0.4c0.3-0.2,0.6-0.3,0.8-0.5c0.2-0.1,0.5-0.3,0.7-0.4 l0.4-0.3l0.2-0.1l0.2-0.1c0.2-0.2,0.5-0.3,0.7-0.5c0.3-0.2,0.5-0.3,0.8-0.5c0.2-0.2,0.4-0.3,0.7-0.5l0,0l0.3-0.3l0.4-0.3 c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.2,0.5-0.4,0.7-0.6c0.3-0.2,0.5-0.5,0.7-0.7c0.2-0.2,0.4-0.3,0.5-0.5c0.2-0.2,0.4-0.4,0.6-0.6 c0.2-0.2,0.4-0.4,0.6-0.7c0.2-0.2,0.3-0.4,0.5-0.5c0.3-0.3,0.5-0.6,0.8-0.9c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.4-0.5,0.5-0.7 c0.2-0.3,0.4-0.6,0.6-0.8c0.2-0.3,0.4-0.6,0.6-1c0.1-0.2,0.3-0.4,0.4-0.7l0.2-0.3l0,0c0.1-0.2,0.3-0.5,0.4-0.7 c0.1-0.2,0.2-0.4,0.4-0.7c0.1-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.2-0.5,0.4-0.8c0.1-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.2-0.5,0.3-0.8 c0.1-0.3,0.2-0.6,0.3-0.9c0,0,0,0,0,0c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.3,0.2-0.7,0.3-1c0.1-0.3,0.1-0.5,0.2-0.8 c0.1-0.2,0.1-0.4,0.1-0.7c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.4,0.1-0.9,0.2-1.3c0-0.2,0.1-0.4,0.1-0.5l0-0.3l0-0.4 c0-0.4,0.1-0.8,0.1-1.2l0-0.3c0-0.5,0-1.1,0-1.6c0-1.1-0.1-2.2-0.2-3.4c-6.5-1-13-2.2-19.4-3.4 C503.3,541.6,503.3,541.7,503.2,541.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.7633,
    y1: 580.9003,
    x2: 370.7633,
    y2: -6.82121e-13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9F1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    style: {
      stopColor: "#FFB936"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    style: {
      stopColor: "#FFCA48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD04F"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M600.1,197.2L443.5,175c-10.9-1.5-20.3-8.3-25.2-17.9l-70-138.9C342.2,6.1,330.2,0,318.3,0 c-11.9,0-23.8,6.1-30,18.2l-70,138.9c-4.9,9.6-14.3,16.4-25.2,17.9l-80.3,11.4c1,3,2.1,5.9,3.2,8.8l12.7-1.8l74.1-10.5 c10-1.4,18.7-7.6,23.2-16.5l64.6-128.1c5.7-11.2,16.7-16.8,27.7-16.8c11,0,22,5.6,27.7,16.8l64.6,128.1 c4.5,8.9,13.2,15.1,23.2,16.5l144.5,20.5c16.5,2.3,26.5,16.1,26.4,30.3c0,0.2,0,0.5,0,0.7c0,0.4,0,0.8-0.1,1.2c0,0.2,0,0.4,0,0.5 c0,0.5-0.1,0.9-0.2,1.4c0,0.3-0.1,0.5-0.1,0.8c-0.1,0.4-0.1,0.8-0.2,1.2c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.5-0.2,0.9-0.4,1.4 l-0.1,0.2l0,0.1l0,0.1c-0.2,0.6-0.4,1.2-0.6,1.8c-0.1,0.2-0.1,0.3-0.2,0.5c-0.2,0.4-0.4,0.9-0.6,1.3c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.2,0.4-0.4,0.9-0.7,1.3c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.4-0.5,0.8-0.7,1.2c-0.1,0.2-0.2,0.4-0.4,0.6c-0.3,0.5-0.7,1-1.1,1.5 l-0.1,0.2c-0.4,0.5-0.9,1.1-1.3,1.6c-0.6,0.6-1.1,1.2-1.7,1.8l-104.4,99.6c-0.7,0.6-1.3,1.3-1.9,2l-0.2,0.3 c-0.6,0.7-1.2,1.5-1.7,2.2l-0.3,0.4c-0.5,0.8-1,1.5-1.4,2.3l0,0c-0.1,0.3-0.3,0.5-0.4,0.8c-0.3,0.5-0.6,1.1-0.8,1.6 c-0.1,0.1-0.1,0.3-0.2,0.4c-0.3,0.8-0.7,1.7-0.9,2.5c0,0.1-0.1,0.3-0.1,0.4c-0.2,0.5-0.3,1.1-0.4,1.6c-0.3,1.2-0.5,2.4-0.7,3.7 l0,0.4c-0.1,0.9-0.1,1.8-0.2,2.8c0,1.7,0.1,3.5,0.4,5.2l0.4,2.5l0.3,1.7l24,136.6c0.1,0.7,0.2,1.5,0.3,2.2c0.1,1,0.2,2.1,0.2,3.1 c0,0.5,0,1,0,1.5l0,0.3c0,0.4-0.1,0.7-0.1,1.1l0,0.4l0,0.3c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2 c-0.1,0.4-0.1,0.7-0.2,1.1c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.2-0.2,0.5-0.2,0.7 c0,0,0,0,0,0c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.3-0.2,0.6-0.3,0.8c-0.1,0.2-0.2,0.5-0.3,0.7 c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.1-0.2,0.3-0.2,0.4c6.4,1.3,12.9,2.4,19.4,3.4 c-0.1-0.8-0.2-1.6-0.3-2.4l-26-148.1l-0.3-1.8l-0.5-2.7c-0.3-1.9-0.5-3.8-0.5-5.7c0-1,0.1-2,0.2-3l0-0.4c0.2-1.3,0.4-2.7,0.7-4 c0.1-0.6,0.3-1.2,0.4-1.8c0-0.2,0.1-0.3,0.1-0.5c0.3-0.9,0.6-1.8,1-2.7c0.1-0.2,0.1-0.3,0.2-0.5c0.3-0.6,0.6-1.2,0.9-1.8 c0.1-0.3,0.3-0.6,0.4-0.9l0,0c0.5-0.9,1-1.7,1.5-2.5l0.3-0.4c0.6-0.8,1.2-1.6,1.9-2.4l0.3-0.3c0.7-0.8,1.3-1.5,2.1-2.2l113.2-108 c0.7-0.6,1.3-1.3,1.9-2c0.5-0.6,1-1.1,1.5-1.7l0.1-0.2c0.4-0.5,0.8-1.1,1.2-1.6c0.1-0.2,0.3-0.4,0.4-0.6c0.3-0.4,0.5-0.8,0.8-1.3 c0.1-0.2,0.2-0.4,0.3-0.6c0.3-0.5,0.5-0.9,0.7-1.4c0.1-0.2,0.2-0.4,0.3-0.7c0.2-0.5,0.4-1,0.6-1.4c0.1-0.2,0.1-0.3,0.2-0.5 c0.2-0.6,0.5-1.3,0.7-2l0-0.1l0-0.1l0.1-0.2c0.1-0.5,0.3-1,0.4-1.5c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.4,0.2-0.8,0.2-1.3 c0-0.3,0.1-0.6,0.1-0.8c0.1-0.5,0.1-1,0.2-1.5c0-0.2,0-0.4,0-0.6c0-0.4,0.1-0.9,0.1-1.3c0-0.3,0-0.5,0-0.8 C628.8,214.7,617.9,199.7,600.1,197.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.6522,
    y1: 580.9003,
    x2: 267.6522,
    y2: 0.00002041781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9F1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04560977,
    style: {
      stopColor: "#FFAD2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1198,
    style: {
      stopColor: "#FFBD3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    style: {
      stopColor: "#FFC846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3417,
    style: {
      stopColor: "#FFCE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7015,
    style: {
      stopColor: "#FFD04F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32,233.6c0,0.8,0,1.7,0.1,2.5c0,0.2,0,0.4,0.1,0.5c0.1,0.7,0.2,1.4,0.3,2.1c0,0.2,0.1,0.5,0.1,0.7 c0.2,0.8,0.4,1.6,0.6,2.4l0,0.1c0.3,0.8,0.6,1.6,0.9,2.5c0.1,0.2,0.2,0.4,0.3,0.7c0.3,0.6,0.6,1.3,0.9,1.9c0.1,0.2,0.2,0.4,0.3,0.5 c0.4,0.8,0.9,1.6,1.4,2.3c0.1,0.2,0.2,0.3,0.4,0.5c0.4,0.6,0.9,1.2,1.4,1.8c0.2,0.2,0.3,0.4,0.5,0.6c0.6,0.7,1.3,1.4,2,2.1 l104.5,99.6c0.7,0.6,1.3,1.3,1.9,2l0.3,0.4c0.6,0.7,1.1,1.4,1.6,2.1l0.3,0.4c0.5,0.7,1,1.5,1.4,2.3l0,0.1c0.4,0.8,0.8,1.6,1.2,2.4 c0.1,0.2,0.1,0.3,0.2,0.5c0.3,0.8,0.6,1.6,0.9,2.4c0,0.2,0.1,0.3,0.1,0.5c0.2,0.8,0.5,1.7,0.6,2.5l0,0.2c0.2,0.9,0.3,1.8,0.4,2.6 c0,0.2,0,0.4,0.1,0.5c0.1,0.9,0.1,1.7,0.1,2.6c0,1.7-0.1,3.5-0.4,5.2l-0.7,4.2L130,522c-0.3,1.8-0.5,3.6-0.5,5.3 c0,1,0.1,1.9,0.2,2.9l0,0.4c0.1,0.9,0.2,1.8,0.4,2.7c0,0.1,0.1,0.3,0.1,0.4c0.2,0.9,0.4,1.7,0.7,2.5l0.1,0.4 c0.3,0.8,0.6,1.6,0.9,2.4l0.1,0.3c0.4,0.8,0.8,1.6,1.2,2.4l0,0c0.5,0.8,0.9,1.5,1.5,2.3l0.2,0.2c0.5,0.7,1,1.4,1.6,2l0.3,0.3 c0.6,0.6,1.2,1.3,1.8,1.8l0.3,0.3c0.6,0.6,1.3,1.1,1.9,1.7l0.3,0.2c0.7,0.5,1.4,1.1,2.2,1.5l0.2,0.1c0.8,0.5,1.5,0.9,2.3,1.3 l0.1,0.1c0.8,0.4,1.6,0.8,2.4,1.1l0.3,0.1c0.8,0.3,1.6,0.6,2.4,0.9c0.1,0,0.3,0.1,0.4,0.1c0.8,0.2,1.7,0.5,2.5,0.6 c0.1,0,0.3,0.1,0.4,0.1c0.9,0.2,1.7,0.3,2.6,0.4l0.3,0c0.9,0.1,1.9,0.1,2.8,0.1c4.7,0,9.6-1.1,14.4-3.6L304,487.4 c4.5-2.3,9.4-3.5,14.3-3.5s9.9,1.2,14.3,3.5l129.1,66.4c4.7,2.4,9.6,3.6,14.4,3.6c0.6,0,1.1,0,1.7,0c0.2,0,0.4,0,0.6,0 c0.2,0,0.4,0,0.5,0l0.3,0l0.2,0c0.2,0,0.5-0.1,0.7-0.1c0.3,0,0.6-0.1,0.9-0.1c0.2,0,0.5-0.1,0.7-0.1l0,0c0.1,0,0.3-0.1,0.4-0.1 c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.3-0.1,0.6-0.1,0.9-0.2c0.3-0.1,0.6-0.2,0.9-0.3c0.2-0.1,0.5-0.1,0.7-0.2 c0.2-0.1,0.5-0.2,0.7-0.3c0.3-0.1,0.6-0.2,0.8-0.3c0.2-0.1,0.5-0.2,0.7-0.3c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.5-0.2,0.7-0.3 c0.3-0.1,0.5-0.2,0.8-0.4c0.2-0.1,0.4-0.2,0.7-0.4c0.3-0.1,0.5-0.3,0.8-0.4c0.2-0.1,0.4-0.3,0.7-0.4l0.4-0.2l0.2-0.1l0.2-0.1 c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.2,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.3,0.6-0.5l0,0l0.3-0.2l0.3-0.3c0.2-0.2,0.4-0.3,0.6-0.5 c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.4-0.4,0.5-0.6c0.2-0.2,0.4-0.4,0.6-0.6 c0.1-0.2,0.3-0.3,0.4-0.5c0.2-0.3,0.5-0.6,0.7-0.8c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.2,0.3-0.4,0.5-0.7c0.2-0.3,0.4-0.5,0.5-0.8 c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.2,0.2-0.4,0.4-0.6l0.2-0.3l0,0c0-0.1,0.1-0.1,0.1-0.2c-176-34.7-321-167.8-387.3-346.4l-57.7,8.2 C41.9,205.7,31.9,219.5,32,233.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.3462,
    y1: 580.9003,
    x2: 360.3462,
    y2: 2.16005e-12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4842,
    style: {
      stopColor: "#FFD04F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    style: {
      stopColor: "#FFCE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    style: {
      stopColor: "#FFC846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    style: {
      stopColor: "#FFBD3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9665,
    style: {
      stopColor: "#FFAD2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9F1B"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M503.3,541.6c0.1-0.1,0.2-0.3,0.2-0.4c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.3,0.3-0.5,0.4-0.8 c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.3,0.2-0.6,0.3-0.8c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.3,0.2-0.6,0.3-0.9c0,0,0,0,0,0 c0.1-0.2,0.2-0.5,0.2-0.7c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.1-0.5,0.2-0.7c0-0.2,0.1-0.4,0.1-0.6c0.1-0.4,0.2-0.7,0.2-1.1 c0.1-0.4,0.1-0.8,0.2-1.2c0-0.2,0.1-0.3,0.1-0.5l0-0.3l0-0.4c0-0.4,0.1-0.7,0.1-1.1l0-0.3c0-0.5,0-1,0-1.5c0-1-0.1-2.1-0.2-3.1 c-0.1-0.7-0.2-1.5-0.3-2.2l-24-136.6l-0.3-1.7l-0.4-2.5c-0.3-1.7-0.4-3.5-0.4-5.2c0-0.9,0.1-1.8,0.2-2.8l0-0.4 c0.1-1.2,0.4-2.5,0.7-3.7c0.1-0.5,0.3-1.1,0.4-1.6c0-0.1,0.1-0.3,0.1-0.4c0.3-0.8,0.6-1.7,0.9-2.5c0.1-0.1,0.1-0.3,0.2-0.4 c0.2-0.6,0.5-1.1,0.8-1.6c0.1-0.3,0.3-0.5,0.4-0.8l0,0c0.4-0.8,0.9-1.6,1.4-2.3l0.3-0.4c0.5-0.8,1.1-1.5,1.7-2.2l0.2-0.3 c0.6-0.7,1.2-1.4,1.9-2l104.4-99.6c0.6-0.6,1.2-1.2,1.7-1.8c0.5-0.5,0.9-1.1,1.3-1.6l0.1-0.2c0.4-0.5,0.7-1,1.1-1.5 c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.4,0.5-0.8,0.7-1.2c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.5-0.9,0.7-1.3c0.1-0.2,0.2-0.4,0.3-0.6 c0.2-0.4,0.4-0.9,0.6-1.3c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.6,0.4-1.2,0.6-1.8l0-0.1l0-0.1l0.1-0.2c0.1-0.5,0.3-0.9,0.4-1.4 c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.2-0.8,0.2-1.2c0-0.3,0.1-0.5,0.1-0.8c0.1-0.5,0.1-0.9,0.2-1.4c0-0.2,0-0.4,0-0.5 c0-0.4,0-0.8,0.1-1.2c0-0.2,0-0.5,0-0.7c0.1-14.2-9.9-27.9-26.4-30.3l-144.5-20.5c-10-1.4-18.7-7.6-23.2-16.5L346,38.3 c-5.7-11.2-16.7-16.8-27.7-16.8c-11,0-22,5.6-27.7,16.8l-64.6,128.1c-4.5,8.9-13.2,15.1-23.2,16.5l-74.1,10.5l-12.7,1.8 C182.3,373.7,327.4,506.9,503.3,541.6z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M510.8,317c0.6-0.7,1.3-1.4,1.9-2c-0.7,0.7-1.4,1.4-2.1,2.2L510.8,317z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M628,204.9l0.3-0.3l0.4-0.4c0.2-0.3,0.5-0.6,0.7-0.8c-0.5,0.6-0.9,1.2-1.5,1.7L628,204.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M630.5,201.7L630.5,201.7l0.2-0.2c-0.4,0.5-0.8,1.1-1.2,1.6C629.8,202.6,630.2,202.1,630.5,201.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M632.4,198.6l0.2-0.4c0.1-0.2,0.2-0.4,0.3-0.7c-0.2,0.5-0.5,0.9-0.7,1.4L632.4,198.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M510.8,317v18.9c0.6-0.7,1.3-1.4,1.9-2V315C512.1,315.6,511.5,316.3,510.8,317z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M510.7,317.2l-0.3,0.3c-0.7,0.8-1.3,1.6-1.9,2.4l-0.3,0.4c-0.6,0.8-1.1,1.7-1.5,2.5l0,0 c-0.2,0.3-0.3,0.6-0.4,0.9v18.8c0.1-0.2,0.2-0.4,0.3-0.5s0.2-0.4,0.3-0.5c0.5-0.8,1-1.7,1.5-2.5l0.1-0.2c0.5-0.8,1.1-1.5,1.7-2.2 l0.3-0.4l0.2-0.3V317L510.7,317.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 503.5937,
    y1: 336.0678,
    x2: 506.2817,
    y2: 336.0678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD04F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#F9D055"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7D057"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M505.4,325.4c-0.1,0.2-0.1,0.3-0.2,0.5c-0.4,0.9-0.7,1.8-1,2.7c-0.1,0.2-0.1,0.3-0.1,0.5 c-0.2,0.6-0.3,1.2-0.4,1.8v15.8l0.3,1.8c0.1-0.2,0.1-0.5,0.2-0.7l0-0.1c0.3-0.9,0.6-1.8,1-2.7l0.2-0.4c0.3-0.7,0.6-1.3,0.9-2v-18.8 C506,324.3,505.7,324.9,505.4,325.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.642,
    y1: 338.7517,
    x2: 503.5937,
    y2: 338.7517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD04F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#F9D055"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7D057"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M502.8,335.3c-0.1,1-0.2,2-0.2,3c0,1.9,0.1,3.8,0.5,5.7l0.5,2.7v-15.8c-0.3,1.3-0.6,2.6-0.7,4L502.8,335.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.9,338.3c0-1-0.1-1.9-0.1-2.8c0-0.2,0-0.4-0.1-0.6c-0.1-1-0.2-1.9-0.4-2.9l0-0.2c-0.2-0.9-0.4-1.8-0.7-2.7 c0-0.2-0.1-0.3-0.1-0.5c-0.3-0.9-0.6-1.8-1-2.7c-0.1-0.2-0.2-0.3-0.2-0.5c-0.4-0.9-0.8-1.8-1.3-2.6l0-0.1c-0.5-0.8-1-1.7-1.5-2.5 l-0.3-0.4c-0.5-0.8-1.1-1.5-1.8-2.3l-0.4-0.4c-0.7-0.8-1.3-1.5-2.1-2.2v18.9c4.3,4.1,7.3,9.2,8.8,14.7l0.8-4.6 C148.7,342.1,148.9,340.2,148.9,338.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.1044,
    y1: 361.9926,
    x2: 503.3259,
    y2: 361.9926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#257D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    style: {
      stopColor: "#277E58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    style: {
      stopColor: "#2F8456"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#3D8C51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#51984B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9107,
    style: {
      stopColor: "#6AA843"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83B83B"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "477.1,350.7 500.7,373.3 503.3,354.9 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.0821,
    y1: 272.5746,
    x2: 508.5153,
    y2: 272.5746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#257D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    style: {
      stopColor: "#277E58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    style: {
      stopColor: "#2F8456"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#3D8C51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#51984B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9107,
    style: {
      stopColor: "#6AA843"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83B83B"
    }
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "491.1,281.8 508.5,263.4 507.7,281.1 "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 1721,
    height: 921,
    xlinkHref: "B9BF3625.png",
    transform: "matrix(0.4067 0 0 0.4246 -36.6952 170.5619)"
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "558.3,260.3 558.3,260.3 558.3,260.3  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M538.4,374c0.2-1,0.5-2.1,0.7-3.2c0-0.2,0.1-0.5,0.1-0.7C539,371.4,538.7,372.7,538.4,374z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "175.1,411.8 175.2,411.6 175.2,411.5  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "567.6,257.6 567.4,257.9 567.6,257.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "567.7,257.1 567.6,257.4 567.7,257.2  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.7,428.6c0.2-0.3,0.5-0.6,0.7-0.9l0.4-0.6l-0.1,0.2C168.3,427.7,168,428.2,167.7,428.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169.2,426.5c0.2-0.3,0.3-0.5,0.5-0.8c0.1-0.2,0.3-0.5,0.4-0.7l-0.1,0.2C169.7,425.6,169.5,426,169.2,426.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M174.6,414.3c0.1-0.5,0.2-1,0.4-1.5l0.1-0.2l0-0.1l-0.1,0.3C174.8,413.3,174.7,413.8,174.6,414.3z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "567.4,258 567.3,258 567.4,258  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M170.5,424.3l0.4-0.7c0.2-0.3,0.3-0.6,0.5-0.9l-0.1,0.1C171,423.3,170.8,423.8,170.5,424.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M173.7,417.1l0.1-0.4c0.2-0.5,0.3-1,0.5-1.5c-0.2,0.6-0.3,1.1-0.5,1.6L173.7,417.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.9,234.7l-0.2,0.2c0.2-0.2,0.5-0.3,0.7-0.5L116.9,234.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M114.6,236.9l-0.2,0.3l-0.2,0.4l0,0.1C114.3,237.4,114.4,237.2,114.6,236.9L114.6,236.9z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "161.6,244.5 161.5,244.1 161.5,244.2  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "160.9,242 160.9,241.4 160.9,241.8  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "113.9,238.2 113.9,238.5 113.9,238.4  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "115.3,236.1 115,236.4 114.9,236.6 115.4,236.1  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "116.1,235.4 115.7,235.7 115.7,235.7 116.3,235.2  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M381.4,340.5c-0.5,1-1.1,1.9-1.7,2.9c0.6-0.8,1.1-1.7,1.6-2.6L381.4,340.5z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "566.8,258.4 566.7,258.4 566.5,258.5 566.7,258.5  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M386.3,324.1l0-0.1c-0.1,0.8-0.2,1.6-0.3,2.4c0.1-0.4,0.1-0.9,0.2-1.3C386.2,324.8,386.2,324.4,386.3,324.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.9,430.7c0.3-0.4,0.6-0.7,0.9-1.1l0.1-0.2l0.2-0.2l-0.1,0.2C166.7,429.9,166.3,430.3,165.9,430.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M382.6,338.1l0.3-0.6c-0.3,0.7-0.6,1.4-1,2.1l0,0.1c0.2-0.5,0.5-0.9,0.7-1.4L382.6,338.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M384.3,333.9l-0.2,0.5c-0.2,0.7-0.5,1.3-0.7,2c0.3-0.6,0.5-1.3,0.7-1.9L384.3,333.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M385.5,329.3c0.1-0.6,0.2-1.1,0.3-1.7c-0.1,0.7-0.3,1.4-0.4,2.1l0,0.1l0.1-0.3L385.5,329.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M532.2,393.4c0.4-0.9,0.8-1.8,1.2-2.7c-0.4,1-0.8,2-1.3,3L532.2,393.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M528.2,400.2c0.2-0.2,0.3-0.5,0.5-0.7c-0.5,0.7-1,1.4-1.6,1.9C527.5,401.1,527.9,400.6,528.2,400.2z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "443.4,441.3 443.6,440.7 443.7,440.4 443.5,440.9  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M171.9,421.5l0.2-0.3l0.1-0.3c0.1-0.2,0.2-0.5,0.3-0.7c-0.3,0.6-0.6,1.3-0.9,1.9L171.9,421.5z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "440.9,445.9 440.9,445.8 441.1,445.5 441.4,445.2 441.1,445.6  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M160,436.6c0.3-0.2,0.6-0.5,0.9-0.7l0.2-0.2c-0.6,0.6-1.3,1.1-2,1.7C159.4,437.1,159.7,436.9,160,436.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.4,434.5c0.2-0.2,0.5-0.4,0.7-0.7l0.3-0.3c-0.7,0.7-1.3,1.3-2.1,2C161.7,435.2,162,434.8,162.4,434.5z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "439,447.8 439.4,447.4 439.6,447.3 439.3,447.5  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M444,439.1l0.1-0.3c-0.1,0.3-0.1,0.5-0.2,0.8L444,439.1z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "434.8,450.3 435.1,450.2 435.4,450 434.9,450.2  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M442.8,442.7l0.2-0.4c-0.1,0.2-0.2,0.5-0.3,0.7L442.8,442.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.6,439.3c0.3-0.2,0.6-0.5,0.9-0.7c0.3-0.2,0.6-0.4,0.9-0.7l-0.1,0.1C157.7,438.5,157.2,438.9,156.6,439.3z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M127.9,453.9c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.4-0.5,2.1-0.8c-0.9,0.3-1.7,0.7-2.6,1L127.9,453.9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M123.1,455.6c0.4-0.1,0.7-0.2,1.1-0.4c0.8-0.3,1.5-0.5,2.3-0.8c-0.9,0.3-1.8,0.6-2.7,0.9L123.1,455.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M154,441.2c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0.5-0.4,0.8-0.6l-0.1,0C155.1,440.4,154.6,440.8,154,441.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M118,457.2c0.4-0.1,0.9-0.3,1.3-0.4c0.9-0.3,1.7-0.6,2.6-0.8c-0.9,0.3-1.9,0.6-2.9,0.9 C118.7,457,118.3,457.1,118,457.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M144.5,446.7c0.4-0.2,0.8-0.4,1.2-0.6c0.4-0.2,0.8-0.4,1.1-0.6c-0.7,0.4-1.5,0.8-2.2,1.2L144.5,446.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M137,450.3c0.4-0.2,0.8-0.4,1.2-0.5c0.5-0.2,1.1-0.5,1.6-0.7c-1.1,0.5-2.3,1-3.5,1.5 C136.6,450.5,136.8,450.4,137,450.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M149,444.3c0.3-0.2,0.6-0.4,1-0.6c-0.6,0.4-1.2,0.7-1.9,1.1C148.4,444.6,148.7,444.5,149,444.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.8,448.5c0.5-0.2,0.9-0.4,1.3-0.6c0.5-0.2,0.9-0.4,1.4-0.7c-1.1,0.6-2.3,1.1-3.5,1.7 C140.3,448.8,140.6,448.7,140.8,448.5z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.6,458.8c0.5-0.1,0.9-0.3,1.3-0.4c1.1-0.3,2.1-0.6,3.2-1c-1.1,0.3-2.2,0.7-3.3,1 C113.4,458.6,113,458.7,112.6,458.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M152.1,442.4L152.1,442.4c0.3-0.2,0.5-0.4,0.8-0.5c-0.6,0.4-1.1,0.7-1.7,1.1 C151.5,442.8,151.8,442.6,152.1,442.4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133,451.9L133,451.9c0.7-0.3,1.4-0.6,2.1-0.9c-0.9,0.4-1.7,0.7-2.6,1.1L133,451.9z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "51.5,350.7 51.2,351.2 51.3,350.9  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "633.6,288.4 633.7,288.3 633.8,288.3 633.8,288.3  "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.9,234.1L117.9,234.1c0.3-0.2,0.6-0.4,1-0.5C118.6,233.7,118.2,233.9,117.9,234.1z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M45,360.8l-0.3,0.5c0.6-0.9,1.2-1.8,1.8-2.6C46,359.3,45.5,360.1,45,360.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M42.1,366.3c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.4-0.3,0.9-0.5,1.3c0.3-0.9,0.6-1.7,1-2.5L42.1,366.3z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "634.3,287.8 634.3,287.8 634.4,287.8 634.5,287.6 634.4,287.7  "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M40.8,369.8l-0.2,0.6c-0.2,0.8-0.4,1.6-0.6,2.3l0,0.1c0.3-1.2,0.6-2.3,0.9-3.4 C40.9,369.6,40.9,369.7,40.8,369.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M39.9,373.8c-0.1,0.7-0.3,1.4-0.4,2.1c-0.1,0.3-0.1,0.7-0.1,1c0,0.2-0.1,0.5-0.1,0.7c0.2-1.4,0.4-2.7,0.6-4.1 L39.9,373.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M39.1,379.4l0,0.5c-0.1,1-0.1,2.1-0.1,3.1l0,0.1c0-1.5,0.1-2.9,0.2-4.4C39.1,379,39.1,379.2,39.1,379.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M311.1,306.6c-15.4,0-31.7,9.1-40.7,19.5c-1.7,1.9-3.4,3.8-5,5.8l0,0c-1.4,1.8-2.8,3.7-4.1,5.6 c-0.4,0.6-0.8,1.2-1.2,1.8c-0.9,1.4-1.8,2.8-2.6,4.3c-0.4,0.7-0.8,1.3-1.1,2c-0.9,1.6-1.7,3.3-2.5,4.9c-0.2,0.5-0.5,0.9-0.7,1.4 l-0.2,0.4c-1,2.1-1.8,4.2-2.7,6.3c-0.2,0.5-0.3,1-0.5,1.5c-0.1,0.3-0.2,0.7-0.4,1h0c31.7-1.9,55.2,0,82.5-17 c5.1-3.2,8.6-8.4,10.5-14.2c-1-3.3-2.5-6.4-4.3-9C331,310.6,321.3,306.6,311.1,306.6z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M119.5,233.1c-0.2,0.2-0.4,0.3-0.6,0.4L119.5,233.1L119.5,233.1z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "119.9,232.8 120,232.6 119.7,233 119.6,233 119.8,232.8  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "120.1,232.3 120.2,232.2 120.2,232.1 120.2,232.1 120.2,232.1 120,232.4 120,232.5 120.1,232.5  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M579.5,431.4l0.1-0.2c-0.2,0.3-0.4,0.5-0.6,0.8L579.5,431.4z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "634.6,287.3 634.7,287.2 634.6,287.4  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "634.8,286.8 634.8,286.6 634.8,286.9  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44.1,362.4c-0.2,0.3-0.4,0.6-0.6,1c-0.2,0.3-0.3,0.6-0.5,0.9c-0.1,0.2-0.1,0.3-0.2,0.5l0.1-0.2 C43.3,363.9,43.7,363.1,44.1,362.4z"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "120.2,232.1 120.2,253 120.2,253.1 120.2,231.7 120.2,232 120.2,232.1  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "120.2,232.2 120.1,232.3 120.1,232.5 120.1,252.7 120.2,253 120.2,232.1  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "120,232.5 120,232.6 119.9,232.8 119.8,232.8 119.8,252.1 120.1,252.7 120.1,232.5  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M119.6,233l-0.1,0.1l-0.1,0.1l-0.6,0.4c-0.4,0.2-0.7,0.4-1.1,0.6l-0.2,0.1l-0.2,0.1c-0.2,0.2-0.5,0.3-0.7,0.5 l-0.1,0.1l-0.3,0.2l-0.6,0.5l-0.3,0.3l-0.5,0.5l-0.2,0.2v3.6c1.7,3.6,3.5,7.5,5.2,11.7v-19.3L119.6,233z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M114.6,236.9L114.6,236.9c-0.2,0.3-0.4,0.5-0.5,0.8l-0.1,0.2v1.4c0.2,0.4,0.4,0.8,0.6,1.3L114.6,236.9 L114.6,236.9z"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "114,237.9 113.9,238.2 113.9,238.4 113.9,238.6 113.9,239 114.1,239.2 114.1,237.8  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "113.9,238.5 113.9,238.6 113.9,238.4  "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M508.5,254.4l0-0.4c0-0.5,0-0.8-0.1-1.1v7.6c0-1.9,0.1-3.6,0.1-4.9C508.5,255.2,508.5,254.8,508.5,254.4z"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "567.7,257.2 567.7,281.1 567.8,280.9 567.8,256.8 567.7,256.9 567.7,257.1  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "558.1,260.8 558.1,272.8 558.1,284.9 558.1,284.8 558.1,260.8  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "624.7,289.4 624.7,289.4 624.6,289.7 624.6,313.7 624.7,313.5 624.7,313.5 624.7,313.5 624.7,289.4  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M386.3,324l0,0.1c0,0.3-0.1,0.7-0.1,1c-0.1,0.4-0.1,0.9-0.2,1.3c-0.1,0.4-0.1,0.8-0.2,1.2 c-0.1,0.6-0.2,1.1-0.3,1.7l0,0.2v24l0-0.1c0.3-1.4,0.5-2.8,0.7-4.3c0-0.3,0.1-0.7,0.1-1c0.1-1.5,0.2-2.9,0.2-4.4v-24.1l0,0.3 c0,1,0,2.1-0.1,3.1C386.4,323.3,386.3,323.7,386.3,324z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M385.4,329.8c-0.1,0.4-0.2,0.8-0.3,1.2c-0.2,0.7-0.4,1.3-0.6,2c-0.1,0.3-0.2,0.6-0.2,0.8l-0.2,0.5 c-0.2,0.7-0.5,1.3-0.7,1.9c-0.2,0.4-0.3,0.8-0.5,1.2l-0.3,0.6l0,0.1v13.6c0.7,1.2,1.5,2.3,2.5,3.4c0.1-0.4,0.2-0.8,0.3-1.2l0.1-0.5 v-24L385.4,329.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M381.8,339.6c-0.2,0.3-0.3,0.6-0.5,0.9l-0.2,0.3c-0.5,0.9-1,1.7-1.6,2.6c0,0,0,0,0,0.1l0,0 c0.2,2.9,1.3,5.7,2.9,8.4v-13.6C382.3,338.7,382.1,339.2,381.8,339.6z"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "52.6,371.6 52.6,347.5 52.6,347.5 52.6,371.6  "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M244.6,353.9c-0.3,1.3-0.6,2.6-0.8,3.9v0.9c0.1,0.7,0.4,1.3,0.8,1.8V353.9z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M51.9,349.5c-0.1,0.4-0.3,0.8-0.5,1.1l-0.1,0.3V375l0.1-0.3c0.2-0.4,0.3-0.8,0.5-1.1l0.2-0.5 c0.2-0.5,0.3-1,0.4-1.5v-24.1c-0.1,0.5-0.3,1-0.4,1.5L51.9,349.5z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M51.2,351.2c-0.2,0.5-0.5,1-0.8,1.5l-0.1,0.2c-0.3,0.6-0.7,1.1-1,1.7l-0.3,0.5c-0.3,0.4-0.5,0.9-0.8,1.3 l-0.3,0.5c-0.4,0.5-0.8,1.1-1.1,1.6v24.1c0.4-0.5,0.8-1,1.1-1.6l0.3-0.5c0.3-0.4,0.6-0.8,0.8-1.3l0.3-0.5c0.4-0.6,0.7-1.1,1-1.7 l0.1-0.2c0.3-0.5,0.5-1,0.8-1.5l0.1-0.3v-24.1L51.2,351.2z"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "46.7,358.4 46.7,382.5 46.8,382.5 46.8,358.4  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M46.6,358.6L46.6,358.6c-0.7,0.9-1.3,1.8-1.9,2.7l-0.2,0.3c-0.2,0.3-0.3,0.6-0.5,0.9 c-0.4,0.7-0.8,1.4-1.2,2.2l-0.1,0.2c-0.1,0.1-0.1,0.3-0.2,0.4v24l0.3-0.5c0.4-0.7,0.7-1.5,1.2-2.2c0.2-0.3,0.4-0.7,0.6-1 c0.6-1,1.2-1.9,1.9-2.8l0.1-0.2v-24.1L46.6,358.6z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M42.6,365.3l-0.2,0.4c-0.4,0.8-0.7,1.7-1,2.5l-0.1,0.2c-0.1,0.3-0.2,0.6-0.3,0.9c-0.4,1.1-0.7,2.3-0.9,3.4 l-0.1,0.4V394c0.1,0.6,0.2,1.2,0.4,1.8c0.2-0.8,0.4-1.5,0.6-2.3c0.1-0.4,0.3-0.7,0.4-1.1c0.3-0.9,0.6-1.7,1-2.6l0.3-0.7v-24 C42.6,365.2,42.6,365.3,42.6,365.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M39.9,373.5c-0.3,1.3-0.5,2.7-0.6,4.1c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.5-0.1,0.7c-0.1,1.4-0.2,2.9-0.2,4.4 c0,3.6,0.3,7.3,1,10.9v-20.8L39.9,373.5z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M175.6,409.3c0.1-0.5,0.1-1,0.2-1.5l0.1-0.6l-0.1,0.6C175.7,408.3,175.6,408.8,175.6,409.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M175.2,411.5L175.2,411.5c0.1-0.4,0.1-0.8,0.2-1.1l0.1-0.5l-0.1,0.4C175.3,410.7,175.3,411.1,175.2,411.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 611.7457,
    y1: 376.2652,
    x2: 541.071,
    y2: 335.4611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7889E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2385,
    style: {
      stopColor: "#7B84DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8178D6"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M534.8,439.3l0.1,0.2c0.1,0.3,0.3,0.6,0.4,0.9l0.1,0.2c0.1,0.2,0.3,0.4,0.5,0.7l0.2,0.2l0.5,0.4l0.3,0.2 l0.5,0.3l0.3,0.1c0.3,0.1,0.6,0.2,0.8,0.2c3.8,0.4,7.3,0.6,10.5,0.6c1.1,0,2.1,0,3.1-0.1c0.3,0,0.6,0,1-0.1c0.7,0,1.4-0.1,2-0.1 c0.4,0,0.7-0.1,1.1-0.1c0.6-0.1,1.2-0.1,1.7-0.2c0.3,0,0.7-0.1,1-0.1c0.6-0.1,1.1-0.2,1.6-0.3c0.3-0.1,0.6-0.1,0.9-0.2 c0.6-0.1,1.1-0.3,1.7-0.4c0.2-0.1,0.5-0.1,0.7-0.2c0.8-0.2,1.5-0.4,2.2-0.7l0.3-0.1c0.6-0.2,1.2-0.4,1.7-0.7 c0.2-0.1,0.5-0.2,0.7-0.3c0.4-0.2,0.9-0.4,1.3-0.6c0.2-0.1,0.5-0.2,0.7-0.4c0.4-0.2,0.8-0.4,1.1-0.6l0.7-0.4 c0.4-0.2,0.7-0.5,1.1-0.7l0.6-0.4c0.4-0.3,0.8-0.6,1.2-0.9l0.4-0.3c0.5-0.4,1-0.9,1.4-1.3l0.3-0.3c0.3-0.4,0.7-0.7,1-1.1l0.4-0.5 c0.2-0.3,0.4-0.5,0.6-0.8c0.9-1.1,1.7-2.3,2.4-3.5l0.2-0.2c0.8-1.3,1.5-2.7,2.2-4.2l0,0v0l0-0.1c0.5-1.1,0.9-2.2,1.4-3.3l0.2-0.5 c0.4-1.1,0.8-2.3,1.2-3.4l0.2-0.7c0.4-1.2,0.8-2.4,1.2-3.6l0.2-0.6c0.4-1.3,0.8-2.5,1.2-3.9l0-0.1c0.4-1.4,0.8-2.9,1.3-4.4 c0.4-1.4,0.8-2.7,1.2-4.1c0.1-0.3,0.2-0.6,0.3-0.9c0.4-1.4,0.8-2.8,1.3-4.2l0.2-0.7c0.5-1.5,1-3,1.5-4.6 c11.4-31.9,17.6-65.3,28.9-98.5l0.1-0.1l0.1-0.3l0,0l0,0l0,0c0.1-0.2,0.4-0.3,0.6-0.5l0.1-0.1c0.3-0.1,0.6-0.2,0.9-0.3l0.2-0.1 c0.4-0.1,0.7-0.2,1.2-0.2l0.2,0c0.4,0,0.9-0.1,1.4-0.1c1,0,2,0.1,2.9,0.3l0.6,0.1c0.3,0,0.5-0.1,0.8-0.2l0.1-0.1l0,0l0.5-0.5 l0.1-0.1l0.1-0.1l0.2-0.3l0.1-0.2l0,0l0-0.1l0-0.2l0-0.2l0-0.2l0,0c0-0.3,0-0.6-0.1-0.8c-2.5-3.8-7-7.8-11.9-11.5 c-9.8-7.3-19.4-10.7-27.4-10.7c-9.6,0-17.1,4.9-20.3,13.9c-6.7,42.6-14.6,83.4-23.8,127.2c-3.2,15.2-8.2,28.7-16.4,32.3 c-0.3,0.4-0.3,0.9-0.3,1.5l0,0.3L534.8,439.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.3279,
    y1: 432.1001,
    x2: 444.4719,
    y2: 432.1001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7889E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2385,
    style: {
      stopColor: "#7B84DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8178D6"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M409.5,431.2c0,0.2,0.1,0.5,0.1,0.7c0.1,0.4,0.2,0.8,0.3,1.2l0.1,0.6c0.2,0.6,0.4,1.2,0.6,1.9 c3.1,9.3,11.3,15.5,19.3,15.5c0.9,0,1.8-0.1,2.7-0.2c0.8-0.2,1.5-0.4,2.2-0.6l0.1,0l0.5-0.2c0.7-0.3,1.3-0.6,1.9-1l0.1-0.1l0.3-0.2 c0.5-0.3,0.9-0.6,1.3-1l0.3-0.3l0.3-0.2c0.5-0.4,0.9-0.9,1.3-1.4l0.2-0.3l0.3-0.4c0.2-0.2,0.3-0.5,0.5-0.7l0.3-0.6 c0.1-0.2,0.3-0.5,0.4-0.7l0.1-0.1l0-0.1c0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.3,0.3-0.6,0.4-1l0.1-0.4l0.2-0.5c0.1-0.3,0.2-0.6,0.2-0.9 c0.1-0.2,0.1-0.5,0.2-0.8c0-0.2,0.1-0.5,0.1-0.7l0.1-0.5c0-0.2,0.1-0.5,0.1-0.7c0-0.5,0.1-0.9,0.1-1.4l0-0.3c0-2-0.2-4.1-0.8-6.2 c-2.8-9.2-11.4-15.9-19.9-15.9c-1.1,0-2.2,0.1-3.3,0.3c-7.3,1.6-11.5,8.3-11.2,16c0,0.3,0,0.5,0,0.8 C409.4,430.5,409.5,430.9,409.5,431.2z"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "176.1,401.5 176.1,401.6 176.1,401.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 629.7927,
    y1: 313.4955,
    x2: 629.7927,
    y2: 286.3049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M634.9,286.4l0,0.2l0,0.2l0,0.1l0,0.2l0,0.1l0,0l0,0.1l0,0.1l-0.2,0.3l-0.1,0.1l0,0l0,0l-0.5,0.5l-0.1,0 l-0.1,0c-0.2,0.1-0.5,0.2-0.8,0.2l-0.6-0.1c-0.9-0.2-1.9-0.3-2.9-0.3c-0.5,0-0.9,0-1.4,0.1l-0.2,0c-0.4,0-0.8,0.1-1.2,0.2 l-0.2,0.1c-0.3,0.1-0.7,0.2-0.9,0.3l-0.1,0.1c-0.3,0.1-0.5,0.3-0.6,0.5l0,0v24.1l0,0c0.1-0.2,0.4-0.3,0.6-0.5l0.1-0.1 c0.3-0.1,0.6-0.2,0.9-0.3l0.2-0.1c0.4-0.1,0.7-0.2,1.2-0.2l0.2,0c0.4,0,0.9-0.1,1.4-0.1c1,0,2,0.1,2.9,0.3l0.6,0.1 c0.3,0,0.6-0.1,0.9-0.2l0.2-0.2l0.4-0.3l0,0l0.3-0.5l0.1-0.1l0.1-0.2l0.1-0.4l0.1-0.3L634.9,286.4L634.9,286.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 579.5632,
    y1: 467.368,
    x2: 579.5632,
    y2: 289.6903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M595.6,388.3c-0.5,1.5-1,3.1-1.5,4.6l-0.2,0.7c-0.4,1.4-0.9,2.8-1.3,4.2c-0.1,0.3-0.2,0.6-0.3,0.9 c-0.4,1.4-0.8,2.8-1.2,4.1c-0.4,1.5-0.8,2.9-1.3,4.4l0,0.1c-0.4,1.3-0.8,2.6-1.2,3.9l-0.2,0.6c-0.4,1.2-0.8,2.4-1.2,3.6l-0.2,0.7 c-0.4,1.2-0.8,2.3-1.2,3.4l-0.2,0.5c-0.4,1.1-0.9,2.2-1.4,3.3l0,0.1v0l0,0c-0.7,1.5-1.4,2.8-2.2,4.2l-0.2,0.2 c-0.7,1.2-1.5,2.4-2.4,3.5l-0.1,0.2l-0.5,0.6l-0.4,0.5c-0.3,0.4-0.7,0.7-1,1.1l-0.3,0.3c-0.5,0.5-0.9,0.9-1.4,1.3l-0.4,0.3 c-0.4,0.3-0.8,0.6-1.2,0.9l-0.6,0.4c-0.3,0.2-0.7,0.5-1.1,0.7l-0.7,0.4c-0.4,0.2-0.7,0.4-1.1,0.6c-0.2,0.1-0.5,0.3-0.7,0.4 c-0.4,0.2-0.8,0.4-1.3,0.6c-0.2,0.1-0.4,0.2-0.7,0.3c-0.6,0.2-1.1,0.5-1.7,0.7l-0.3,0.1c-0.7,0.2-1.5,0.5-2.2,0.7 c-0.2,0.1-0.5,0.1-0.7,0.2c-0.6,0.1-1.1,0.3-1.7,0.4c-0.3,0.1-0.6,0.1-0.9,0.2c-0.5,0.1-1.1,0.2-1.6,0.3c-0.3,0.1-0.7,0.1-1,0.1 c-0.6,0.1-1.1,0.1-1.7,0.2c-0.4,0-0.7,0.1-1.1,0.1c-0.7,0.1-1.3,0.1-2,0.1c-0.3,0-0.6,0-1,0.1c-1,0-2.1,0.1-3.1,0.1 c-3.2,0-6.7-0.2-10.5-0.6c-0.3,0-0.6-0.1-0.8-0.2l-0.3-0.1l-0.5-0.3l-0.3-0.2l-0.5-0.4l-0.2-0.2c-0.2-0.2-0.3-0.4-0.5-0.7 l-0.1-0.2c-0.2-0.3-0.3-0.6-0.4-0.9l-0.1-0.2l-0.2-0.7l0-0.3l0-0.3v24.1c0,2,1.9,4.7,3.9,4.7c3.8,0.4,7.3,0.6,10.5,0.6 c1.1,0,2.1,0,3.1-0.1c0.3,0,0.6,0,1-0.1c0.7,0,1.4-0.1,2-0.1c0.4,0,0.7-0.1,1.1-0.1c0.6-0.1,1.2-0.1,1.7-0.2c0.3,0,0.7-0.1,1-0.1 c0.6-0.1,1.1-0.2,1.6-0.3c0.3-0.1,0.6-0.1,0.9-0.2c0.6-0.1,1.1-0.3,1.7-0.4c0.2-0.1,0.5-0.1,0.7-0.2c0.8-0.2,1.5-0.4,2.2-0.7 l0.3-0.1c0.6-0.2,1.2-0.4,1.7-0.7c0.2-0.1,0.5-0.2,0.7-0.3c0.4-0.2,0.9-0.4,1.3-0.6c0.2-0.1,0.5-0.2,0.7-0.4 c0.4-0.2,0.8-0.4,1.1-0.6l0.7-0.4c0.4-0.2,0.7-0.5,1.1-0.7l0.6-0.4c0.4-0.3,0.8-0.6,1.2-0.9l0.4-0.3c0.5-0.4,1-0.9,1.4-1.3 l0.3-0.3c0.3-0.4,0.7-0.7,1-1.1l0.4-0.5l0.5-0.7l0.1-0.1c0.9-1.1,1.7-2.3,2.4-3.5l0.2-0.2c0.8-1.3,1.5-2.7,2.2-4.2l0,0l0-0.1 c0.5-1.1,0.9-2.2,1.4-3.3l0.2-0.5c0.4-1.1,0.8-2.3,1.2-3.4l0.2-0.7c0.4-1.2,0.8-2.4,1.2-3.6l0.2-0.6c0.4-1.3,0.8-2.5,1.2-3.9 l0-0.1c0.4-1.4,0.8-2.9,1.3-4.4c0.4-1.4,0.8-2.7,1.2-4.1c0.1-0.3,0.2-0.6,0.3-0.9c0.4-1.4,0.8-2.8,1.3-4.2l0.2-0.7 c0.5-1.5,1-3,1.5-4.6c11.4-31.9,17.6-65.3,28.9-98.5l0.1-0.2v-24l-0.1,0.1C613.3,323,607,356.4,595.6,388.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.8969,
    y1: 475.246,
    x2: 426.8969,
    y2: 428.474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M444.4,436.8c0,0.2-0.1,0.5-0.1,0.7l-0.1,0.5c0,0.2-0.1,0.5-0.1,0.7l-0.1,0.3l-0.1,0.4 c-0.1,0.3-0.2,0.6-0.2,0.9l-0.1,0.3l-0.2,0.5c-0.1,0.3-0.2,0.7-0.4,1l-0.2,0.4l-0.1,0.2l0,0.1l-0.1,0.1c-0.1,0.2-0.3,0.5-0.4,0.7 l-0.3,0.6c-0.2,0.2-0.3,0.5-0.5,0.7l-0.3,0.4l-0.2,0.3l-0.1,0.1c-0.4,0.5-0.8,1-1.3,1.4l-0.2,0.2l-0.4,0.3c-0.4,0.4-0.9,0.7-1.3,1 l-0.3,0.2l-0.1,0.1c-0.6,0.4-1.2,0.7-1.9,1l-0.3,0.1l-0.3,0.1c-0.7,0.3-1.4,0.5-2.2,0.6c-0.9,0.2-1.8,0.2-2.7,0.2 c-8,0-16.2-6.2-19.3-15.5c-0.2-0.6-0.4-1.2-0.6-1.9l-0.1-0.6c-0.1-0.4-0.2-0.8-0.3-1.2c0-0.2-0.1-0.5-0.1-0.7 c-0.1-0.4-0.1-0.7-0.1-1.1c0-0.3,0-0.5,0-0.8c0-0.3,0-0.6,0-0.9v24.1c0,2.3,0.4,4.8,1.3,7.2c3.1,9.3,11.3,15.5,19.3,15.5 c0.9,0,1.8-0.1,2.7-0.2c0.9-0.2,1.7-0.4,2.5-0.8c0.3-0.1,0.5-0.3,0.8-0.4c0.5-0.2,1-0.5,1.5-0.8c0.3-0.2,0.5-0.4,0.8-0.6 c0.4-0.3,0.8-0.6,1.2-0.9c0.3-0.2,0.5-0.5,0.7-0.8c0.3-0.3,0.6-0.6,0.8-0.9l0.2-0.2l0.3-0.5c0.4-0.5,0.7-1.1,1-1.6l0.3-0.5 l0.1-0.4c0.3-0.6,0.5-1.2,0.7-1.9l0.1-0.5c0.1-0.5,0.2-1,0.3-1.4l0.1-0.6c0-0.2,0.1-0.5,0.1-0.7c0.1-0.9,0.2-1.7,0.2-2.6v-24.1 l0,0.5C444.4,435.9,444.4,436.4,444.4,436.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 570.1443,
    y1: 248.9826,
    x2: 546.8575,
    y2: 319.7746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2206,
    style: {
      stopColor: "#021355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#09185C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    style: {
      stopColor: "#152168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4185,
    style: {
      stopColor: "#262F79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4622,
    style: {
      stopColor: "#3C4190"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    style: {
      stopColor: "#5756AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5356,
    style: {
      stopColor: "#776FCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#716BC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    style: {
      stopColor: "#5252A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7104,
    style: {
      stopColor: "#3A3F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#29327D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    style: {
      stopColor: "#1F2A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M567.6,257.4L567.6,257.4L567.6,257.4l-0.1,0.2l0,0.1l-0.2,0.3l0,0l0,0l0,0l0,0l-0.1,0.1l-0.4,0.3l-0.1,0.1 l-0.1,0c-0.2,0.1-0.5,0.1-0.8,0.1c-0.5,0-1,0-1.5,0l-0.4,0c-0.3,0-0.6,0-0.9,0.1l-0.5,0.1c-0.3,0-0.5,0.1-0.7,0.1l-0.4,0.1 l-0.6,0.1l-0.4,0.1l-0.5,0.2l-0.3,0.1l-0.5,0.2l-0.2,0.1l-0.4,0.4l0,0l0,0l-0.1,0.3l-0.1,0.2v24.1l0.1-0.2l0.1-0.2l0,0l0,0 l0.4-0.4l0.2-0.1l0.5-0.2l0.3-0.1l0.5-0.2l0.4-0.1l0.6-0.1l0.4-0.1c0.2,0,0.5-0.1,0.7-0.1l0.5-0.1c0.3,0,0.6,0,0.9-0.1l0.4,0 c0.5,0,1,0,1.5,0c0.4,0,0.7-0.1,0.9-0.2l0.2-0.2l0.4-0.3l0.1-0.1l0.2-0.4l0-0.1l0-0.1l0.1-0.4v-23.9L567.6,257.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.7433,
    y1: 174.8375,
    x2: 321.4565,
    y2: 245.6295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2206,
    style: {
      stopColor: "#021355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#09185C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    style: {
      stopColor: "#152168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4185,
    style: {
      stopColor: "#262F79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4622,
    style: {
      stopColor: "#3C4190"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    style: {
      stopColor: "#5756AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5356,
    style: {
      stopColor: "#776FCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#716BC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    style: {
      stopColor: "#5252A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7104,
    style: {
      stopColor: "#3A3F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#29327D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    style: {
      stopColor: "#1F2A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M557.4,262.3c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.4-0.3,0.9-0.5,1.3c-0.2,0.6-0.4,1.1-0.6,1.7 c-0.2,0.5-0.3,1-0.4,1.5c-0.2,0.6-0.3,1.3-0.5,1.9c-0.1,0.6-0.3,1.1-0.4,1.7c-0.2,0.7-0.3,1.4-0.5,2.1c-0.1,0.3-0.2,0.7-0.2,1 c-0.1,0.2-0.1,0.5-0.2,0.7c-0.2,0.9-0.4,1.9-0.6,2.9c-0.1,0.5-0.2,1.1-0.3,1.6c-0.2,1.2-0.4,2.4-0.6,3.6 c-0.1,0.4-0.1,0.8-0.2,1.2c-0.3,1.6-0.5,3.3-0.8,5.1c-0.1,0.5-0.1,1-0.2,1.4c-0.2,1.3-0.4,2.6-0.6,4c-0.1,0.7-0.2,1.4-0.3,2.1 c-0.2,1.2-0.3,2.4-0.5,3.6c-0.1,0.8-0.2,1.5-0.3,2.3c-0.2,1.2-0.3,2.4-0.5,3.6c-0.1,0.8-0.2,1.6-0.3,2.3 c-0.2,1.3-0.3,2.6-0.5,3.9c-0.1,0.8-0.2,1.5-0.3,2.3c-0.2,1.8-0.5,3.6-0.7,5.4c-0.3,2-0.5,4-0.8,6.1c-0.1,0.5-0.1,1-0.2,1.5 c-0.2,1.5-0.4,3-0.6,4.5c-0.1,0.7-0.2,1.4-0.3,2.1c-0.2,1.3-0.4,2.6-0.5,4c-0.1,0.8-0.2,1.5-0.3,2.3c-0.2,1.3-0.4,2.5-0.5,3.8 c-0.1,0.8-0.2,1.5-0.3,2.3c-0.2,1.3-0.4,2.6-0.6,3.9c-0.1,0.7-0.2,1.3-0.3,2c-0.3,1.7-0.5,3.3-0.8,4.9c0,0.3-0.1,0.6-0.1,0.8 c-0.3,1.9-0.7,3.7-1,5.5c-0.1,0.5-0.2,1.1-0.3,1.6c-0.3,1.3-0.5,2.5-0.8,3.7c0,0.2-0.1,0.5-0.1,0.7c-0.2,1.1-0.5,2.1-0.7,3.2 l0,0.1c-0.3,1.4-0.7,2.7-1,4c-0.1,0.3-0.2,0.7-0.3,1c-0.3,1.1-0.6,2.1-0.9,3.2l-0.2,0.7c-0.4,1.2-0.7,2.4-1.1,3.5 c-0.1,0.3-0.2,0.5-0.3,0.8c-0.3,0.9-0.6,1.8-1,2.6c-0.1,0.3-0.2,0.5-0.3,0.8c-0.4,0.9-0.8,1.9-1.2,2.7l-0.1,0.2l-0.2,0.4 c-0.4,0.8-0.8,1.6-1.2,2.4l-0.2,0.4c-0.5,0.8-0.9,1.5-1.4,2.2l-0.3,0.4c-0.2,0.2-0.3,0.5-0.5,0.7c-0.3,0.4-0.7,0.9-1.1,1.3 c-6.7,8-16.7,10.4-27.5,10.4c-4.5,0-9.2-0.4-13.8-1.1c-4.3-0.6-8.5-1.4-12.6-2.2c-1.6-0.3-3.2-0.8-4.8-1.4 c-2.2-0.8-4.3-1.7-6.4-2.7c-12.8-5.7-24.3-13.1-29.2-24c-7,3.6-15.7,6.4-24.7,8.1c-2.7,0.5-5.5,0.9-8.2,1.2 c-1.1,0.1-2.1,0.2-3.2,0.2c-4.7,0-9.5-1-13.8-2.9c-10.7-4.7-20.9-11.2-27.2-18.6c-0.9-1.1-1.7-2.1-2.5-3.2 c-41.4,19.3-88.8,17.3-134.8,22.5c-5.5,0.6-11,1.3-16.4,2.2c-4.4,0.7-8.8,1.1-13.3,1.1c-5.3-0.1-9.8-0.3-13.8-1 c0.6,4.1,0.9,7.9,0.9,11.7l0-0.1v0.1l0,0.4c0,0.7,0,1.4-0.1,2.1l0,0.1l0,0.1c0,0.2,0,0.5-0.1,0.7c0,0.6-0.1,1.1-0.1,1.7l0,0.4 l-0.1,0.6c-0.1,0.5-0.1,1-0.2,1.5l-0.1,0.6l-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2l0,0.2c0,0.2-0.1,0.5-0.1,0.7l0,0.1l-0.1,0.2 c-0.1,0.5-0.2,1-0.4,1.5c-0.1,0.3-0.2,0.6-0.2,0.9c-0.1,0.5-0.3,1-0.5,1.5l-0.1,0.4l-0.1,0.4c-0.3,0.8-0.6,1.5-0.9,2.3l-0.2,0.3 c-0.1,0.2-0.2,0.5-0.3,0.7l-0.1,0.3l-0.2,0.3l-0.3,0.5l-0.3,0.7c-0.2,0.3-0.3,0.6-0.5,0.9l-0.4,0.7c-0.1,0.2-0.3,0.5-0.4,0.7 c-0.1,0.2-0.3,0.5-0.4,0.7c-0.2,0.3-0.3,0.5-0.5,0.8c-0.2,0.2-0.3,0.5-0.5,0.7l-0.4,0.6c-0.2,0.3-0.4,0.6-0.7,0.9l-0.5,0.7 l-0.2,0.2l-0.1,0.2c-0.3,0.4-0.6,0.7-0.9,1.1c-0.2,0.3-0.4,0.5-0.7,0.8c-0.4,0.5-0.9,0.9-1.3,1.4l-0.6,0.6l-0.3,0.3 c-0.2,0.2-0.5,0.4-0.7,0.7c-0.3,0.3-0.7,0.7-1,1l-0.2,0.2l-0.2,0.2c-0.3,0.2-0.6,0.5-0.9,0.7c-0.3,0.3-0.6,0.5-0.9,0.8l-0.7,0.5 c-0.3,0.2-0.6,0.4-0.9,0.7c-0.3,0.2-0.6,0.5-0.9,0.7c-0.3,0.2-0.6,0.5-0.9,0.7c-0.3,0.2-0.5,0.4-0.8,0.6 c-0.3,0.2-0.6,0.4-0.9,0.6c-0.4,0.2-0.7,0.5-1.1,0.7c-0.3,0.2-0.5,0.4-0.8,0.5l0,0c-0.3,0.2-0.6,0.4-0.9,0.6 c-0.4,0.2-0.8,0.5-1.2,0.7c-0.3,0.2-0.6,0.4-1,0.6c-0.3,0.2-0.6,0.3-0.9,0.5c0,0,0,0,0,0l0,0c-0.4,0.2-0.8,0.4-1.2,0.7 c-0.4,0.2-0.8,0.4-1.1,0.6c-0.4,0.2-0.8,0.4-1.2,0.6c-0.3,0.2-0.6,0.3-0.9,0.5c-0.5,0.2-0.9,0.5-1.4,0.7 c-0.4,0.2-0.9,0.4-1.3,0.6c-0.3,0.1-0.5,0.2-0.8,0.4l-0.2,0.1c-0.5,0.2-1.1,0.5-1.6,0.7c-0.4,0.2-0.8,0.4-1.2,0.5 c-0.2,0.1-0.4,0.2-0.7,0.3c-0.4,0.2-0.9,0.4-1.3,0.5c-0.7,0.3-1.3,0.6-2,0.8l0,0l-0.6,0.2c-0.5,0.2-1.1,0.4-1.6,0.6 c-0.7,0.3-1.4,0.5-2.1,0.8c-0.3,0.1-0.5,0.2-0.8,0.3c-0.5,0.2-1,0.4-1.5,0.5c-0.7,0.3-1.5,0.5-2.3,0.8c-0.4,0.1-0.7,0.2-1.1,0.4 c-0.4,0.1-0.8,0.3-1.2,0.4c-0.8,0.3-1.7,0.6-2.6,0.8c-0.4,0.1-0.9,0.3-1.3,0.4c-0.3,0.1-0.6,0.2-0.9,0.3c-1,0.3-2.1,0.6-3.2,1 c-0.5,0.1-0.9,0.3-1.3,0.4l-0.4,0.1c-1.7,0.5-3.4,1-5.2,1.5c-11.5,3.3-22.7,5-33.3,5c-26.5,0-49.6-10.6-66.3-32.9 c-0.6-1-1.2-2.1-1.8-3.1c-0.2-0.3-0.3-0.7-0.5-1c-0.3-0.7-0.7-1.4-1-2c-0.2-0.4-0.3-0.8-0.5-1.2c-0.3-0.6-0.5-1.2-0.8-1.8 c-0.2-0.4-0.3-0.8-0.4-1.3c-0.2-0.6-0.4-1.1-0.6-1.7c-0.1-0.4-0.2-0.9-0.3-1.3c-0.1-0.5-0.3-1.1-0.4-1.6 c-0.1-0.4-0.2-0.9-0.3-1.3c-0.1-0.5-0.2-1-0.3-1.6c-0.1-0.4-0.1-0.9-0.2-1.3c-0.1-0.5-0.1-1-0.2-1.5c0-0.4,0-0.9-0.1-1.3 c0-0.5-0.1-1-0.1-1.5l0-0.2V433c0,7.4,2.2,15.2,7.4,23.7c16.7,22.3,39.8,32.9,66.3,32.9c10.6,0,21.8-1.7,33.3-5 c1.8-0.5,3.6-1,5.4-1.5c0.6-0.2,1.1-0.3,1.6-0.5c1.2-0.3,2.4-0.7,3.5-1.1c0.6-0.2,1.2-0.4,1.8-0.6c1.1-0.3,2.1-0.7,3.1-1 c0.6-0.2,1.2-0.4,1.7-0.6c1.1-0.4,2.1-0.7,3.1-1.1c0.5-0.2,1-0.3,1.4-0.5c1.5-0.5,2.9-1.1,4.3-1.6l0,0c1.4-0.6,2.7-1.1,4-1.7 c0.4-0.2,0.8-0.4,1.2-0.5c0.9-0.4,1.8-0.8,2.6-1.2c0.5-0.2,0.9-0.4,1.3-0.6c0.8-0.4,1.5-0.8,2.3-1.1c0.4-0.2,0.9-0.4,1.3-0.7 c0.8-0.4,1.5-0.8,2.3-1.2c0.3-0.2,0.7-0.4,1-0.6c2.1-1.2,4.1-2.5,5.9-3.7c0.3-0.2,0.6-0.4,0.9-0.6c0.6-0.4,1.2-0.9,1.8-1.3 c0.3-0.2,0.6-0.5,0.9-0.7c0.5-0.4,1-0.8,1.6-1.3c0.3-0.2,0.6-0.5,0.9-0.7c0.5-0.5,1-0.9,1.5-1.4l0.7-0.6c1.4-1.4,2.6-2.8,3.8-4.2 l0.1-0.2c0.2-0.2,0.4-0.5,0.5-0.7c0.3-0.4,0.5-0.7,0.8-1.1c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.4,0.5-0.7,0.7-1.1 c0.2-0.3,0.4-0.6,0.6-1c0.2-0.4,0.4-0.7,0.6-1.1c0.2-0.3,0.3-0.7,0.5-1c0.2-0.4,0.4-0.7,0.6-1.1l0.2-0.4l0.1-0.3 c0.6-1.2,1-2.5,1.5-3.7l0.2-0.5c0.4-1.3,0.8-2.6,1.1-3.9l0.1-0.2l0.1-0.6c0.1-0.5,0.2-1.1,0.3-1.6c0.1-0.3,0.1-0.7,0.2-1 c0.1-0.5,0.1-1.1,0.2-1.6c0-0.3,0.1-0.6,0.1-1c0.1-0.6,0.1-1.2,0.1-1.8c0-0.3,0-0.6,0.1-0.8c0-0.9,0.1-1.8,0.1-2.7v-11.5 c3.7,0.6,7.9,0.8,12.9,0.9c4.4,0,8.9-0.4,13.3-1.1c5.4-0.8,10.8-1.5,16.4-2.2c45.9-5.2,93.3-3.2,134.8-22.5 c5.9,8.7,17.5,16.4,29.7,21.8c4.3,1.9,9.1,2.9,13.8,2.9c1.1,0,2.1-0.1,3.2-0.2c2.8-0.3,5.5-0.7,8.2-1.2 c9.1-1.7,17.7-4.5,24.7-8.1c4.9,10.9,16.4,18.3,29.2,24c2.1,0.9,4.3,1.8,6.4,2.7c1.6,0.6,3.1,1,4.8,1.4c4.1,0.8,8.3,1.6,12.6,2.2 c4.6,0.6,9.3,1.1,13.8,1.1c10.8,0,20.8-2.5,27.5-10.4c0.4-0.4,0.7-0.9,1.1-1.3l0.5-0.6l0.3-0.4c0.5-0.7,1-1.4,1.4-2.2l0.2-0.4 c0.4-0.7,0.8-1.5,1.2-2.4l0.2-0.4l0.1-0.3c0.4-0.9,0.8-1.8,1.2-2.7c0.1-0.2,0.2-0.5,0.3-0.8c0.3-0.8,0.7-1.7,1-2.6 c0.1-0.3,0.2-0.5,0.3-0.8c0.4-1.1,0.8-2.3,1.1-3.5l0.2-0.7c0.3-1,0.6-2.1,0.9-3.2c0.1-0.3,0.2-0.7,0.3-1c0.3-1.3,0.7-2.6,1-4 l0-0.1c0.2-1.1,0.5-2.1,0.7-3.2l0.1-0.6c0.3-1.2,0.5-2.5,0.8-3.7c0.1-0.5,0.2-1.1,0.3-1.6c0.3-1.8,0.7-3.7,1-5.5 c0-0.3,0.1-0.6,0.1-0.8c0.3-1.6,0.6-3.3,0.8-4.9c0.1-0.7,0.2-1.3,0.3-2c0.2-1.3,0.4-2.6,0.6-3.9c0.1-0.8,0.2-1.5,0.3-2.3 c0.2-1.3,0.4-2.5,0.5-3.8c0.1-0.8,0.2-1.5,0.3-2.3c0.2-1.3,0.4-2.6,0.5-4c0.1-0.7,0.2-1.4,0.3-2.1c0.2-1.5,0.4-2.9,0.6-4.4 c0.1-0.6,0.1-1.1,0.2-1.7c0.3-2,0.5-4,0.8-6c0.2-1.8,0.5-3.6,0.7-5.4c0.1-0.8,0.2-1.5,0.3-2.3c0.2-1.3,0.3-2.6,0.5-3.9 c0.1-0.8,0.2-1.5,0.3-2.3c0.2-1.2,0.3-2.5,0.5-3.7c0.1-0.7,0.2-1.5,0.3-2.2c0.2-1.2,0.3-2.4,0.5-3.6c0.1-0.7,0.2-1.3,0.3-2 c0.2-1.4,0.4-2.7,0.6-4c0.1-0.5,0.1-0.9,0.2-1.4c0.3-1.7,0.5-3.4,0.8-5.1c0.1-0.4,0.1-0.8,0.2-1.2c0.2-1.2,0.4-2.4,0.6-3.6 c0.1-0.6,0.2-1.1,0.3-1.6c0.2-1,0.4-1.9,0.6-2.9c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.3,0.1-0.6,0.2-1c0.2-0.7,0.3-1.4,0.5-2.1 c0.1-0.6,0.3-1.1,0.4-1.7c0.2-0.7,0.3-1.3,0.5-1.9c0.1-0.5,0.3-1,0.4-1.5c0.2-0.6,0.4-1.2,0.6-1.7c0.2-0.4,0.3-0.9,0.5-1.3 c0.2-0.5,0.4-1,0.6-1.5c0.1-0.3,0.2-0.6,0.3-0.8c0.1-0.2,0.2-0.5,0.3-0.7v0v-12v-12c-0.1,0.2-0.2,0.5-0.3,0.7 C557.6,261.8,557.5,262,557.4,262.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.9608,
    y1: 349.0188,
    x2: 452.9608,
    y2: 290.9076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M454.9,315v-24.1c0,1.8-0.1,3.5-0.2,5.2c0,0.5-0.1,0.9-0.1,1.4c-0.1,1.4-0.2,2.9-0.3,4.3 c0,0.3,0,0.6-0.1,0.9c-0.2,1.7-0.3,3.4-0.5,5.1c-0.1,0.5-0.1,1.1-0.2,1.6c-0.2,1.4-0.3,2.9-0.5,4.3c-0.2,1.8-0.5,3.7-0.7,5.5 c0,0.3-0.1,0.6-0.1,0.8c-0.2,1.5-0.3,2.9-0.5,4.4c0,0.5-0.1,1-0.1,1.5c-0.3,3.5-0.5,7.1-0.5,10.8c0,3.9,0.1,8,0.6,12.2 C452.8,337.4,454.8,326.6,454.9,315z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.3267,
    y1: 355.506,
    x2: 411.3267,
    y2: 300.4062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.5,330.5c0,4,0.7,9.6,1.5,15.7c0.2,1.7,0.5,3.5,0.7,5.4c0.2,1.3,0.3,2.7,0.5,4c0.8-2.6,1.1-5.9,1.1-9.5 c0-0.8,0-1.5,0-2.3c0-0.3,0-0.5,0-0.8c0-0.5,0-1.1-0.1-1.6c0-0.3,0-0.6-0.1-1c0-0.5-0.1-1-0.1-1.5c0-0.3-0.1-0.7-0.1-1 c0-0.5-0.1-1-0.1-1.5c0-0.3-0.1-0.7-0.1-1c-0.1-0.5-0.1-1.1-0.2-1.6c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.7-0.2-1.3-0.2-1.9l-0.1-0.6 c-0.1-0.8-0.2-1.7-0.3-2.5c0-0.3-0.1-0.7-0.1-1c-0.1-0.5-0.1-1-0.2-1.6c-0.1-0.5-0.1-1.1-0.2-1.6c-0.1-0.5-0.1-1.1-0.2-1.6 c-0.1-0.5-0.1-1-0.2-1.6c0-0.4-0.1-0.7-0.1-1.1c-0.1-0.5-0.1-1-0.2-1.5c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.6-0.1-1.1-0.2-1.7l-0.1-0.6 c-0.1-0.7-0.2-1.5-0.2-2.1l0-0.4c0-0.4-0.1-0.8-0.1-1.1l0-0.5l0-0.6c0-0.4-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.7c0-0.4,0-0.7,0-1.1 c0-1.4,0-2.5,0.2-3.5c-0.2-0.6-0.3-1.2-0.4-1.8l0-0.5l0-0.5v24.1c0,0.6,0.1,1.2,0.2,1.9V330.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.1132,
    y1: 360.8152,
    x2: 185.1132,
    y2: 239.3152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M205.2,360.8c0.2-0.2,0.5-0.3,0.7-0.5c1.1-0.9,2-1.9,2.7-3c0.7-1.2,1-2.4,1-3.8c0-0.4-0.1-0.8-0.2-1.2 l-0.1-0.6c-0.2-0.6-0.4-1.2-0.7-1.9c-9-38.4-23.9-71.5-44.7-100.9c-0.5-0.7-0.9-1.4-1.2-2.1l-0.3-0.6c-0.3-0.6-0.5-1.2-0.7-1.8 l-0.1-0.3l0-0.1c-0.2-0.7-0.4-1.4-0.5-2.2l0-0.2l0-0.4c-0.1-0.6-0.1-1.2-0.1-1.8l0-0.3v24.1c0,3.3,1,6.6,3.1,9.7 C182.2,299.1,196,327.9,205.2,360.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.7004,
    y1: 354.5457,
    x2: 267.7283,
    y2: 304.5736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2206,
    style: {
      stopColor: "#021355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#09185C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    style: {
      stopColor: "#152168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4185,
    style: {
      stopColor: "#262F79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4622,
    style: {
      stopColor: "#3C4190"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    style: {
      stopColor: "#5756AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5356,
    style: {
      stopColor: "#776FCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#716BC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    style: {
      stopColor: "#5252A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7104,
    style: {
      stopColor: "#3A3F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#29327D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    style: {
      stopColor: "#1F2A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M249.4,361.1c0.1-0.3,0.2-0.7,0.4-1c0.2-0.5,0.3-1,0.5-1.5c0.8-2.1,1.7-4.2,2.7-6.3l0.2-0.4 c0.2-0.5,0.5-0.9,0.7-1.4c0.8-1.7,1.7-3.3,2.5-4.9c0.4-0.7,0.7-1.3,1.1-2c0.8-1.4,1.7-2.9,2.6-4.3c0.4-0.6,0.8-1.2,1.2-1.8 c1.3-1.9,2.6-3.8,4.1-5.6l0,0c1.6-2,3.2-4,5-5.8c9.1-10.4,25.3-19.5,40.7-19.5c10.1,0,19.9,4,26.9,14.2c1.9,2.6,3.3,5.7,4.3,9 c1.5-4.5,2.1-9.4,1.8-14.3l0-0.4c-0.1-1.1-0.2-2.1-0.3-3.1c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.7-0.3-1.4-0.4-2.2 c-0.1-0.4-0.2-0.8-0.3-1.1c-0.2-0.6-0.3-1.3-0.5-1.9c-0.1-0.4-0.2-0.8-0.4-1.1c-0.2-0.6-0.4-1.2-0.7-1.8c-0.1-0.4-0.3-0.7-0.4-1.1 c-0.3-0.6-0.6-1.2-0.9-1.8c-0.1-0.3-0.3-0.6-0.4-0.9c-0.5-0.9-1-1.7-1.5-2.5c-7.1-10.2-16.8-14.2-26.9-14.2 c-15.4,0-31.7,9.1-40.7,19.5c-1.7,1.9-3.4,3.8-5,5.8l0,0c-1.4,1.8-2.8,3.7-4.1,5.6c-0.4,0.6-0.8,1.2-1.2,1.8 c-0.9,1.4-1.8,2.8-2.6,4.3c-0.4,0.7-0.8,1.3-1.1,2c-0.9,1.6-1.7,3.3-2.5,4.9c-0.2,0.5-0.5,0.9-0.7,1.4l-0.2,0.4 c-0.9,2.1-1.9,4.1-2.7,6.3c-0.2,0.5-0.3,1-0.5,1.5c-0.7,1.8-1.3,3.6-1.9,5.5c-0.3,0.8-0.5,1.7-0.8,2.5c-0.5,1.6-0.9,3.1-1.3,4.7 c-0.2,0.9-0.5,1.9-0.7,2.8c-0.2,0.8-0.4,1.6-0.5,2.5v6.6c0.4,0.5,1,0.8,1.6,0.8C247.3,361.2,248.3,361.1,249.4,361.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.465,
    y1: 419.2467,
    x2: 104.465,
    y2: 250.5469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M132.2,396.6c3.1,5.9,6.6,14.1,8.6,22.7c1.2-3.4,1.7-7.2,1.7-11.1c0-1.5-0.1-3-0.2-4.5l0-0.3 c-0.2-1.5-0.4-3.1-0.7-4.7l-0.1-0.3c-0.3-1.5-0.6-3-1-4.5l-0.1-0.3c-0.4-1.5-0.8-3.1-1.3-4.5l-0.1-0.2c-0.5-1.5-1-2.9-1.5-4.3 l-0.1-0.3c-0.5-1.4-1.1-2.8-1.7-4.1l0-0.1c-0.6-1.3-1.1-2.6-1.7-3.8l-0.1-0.3c-0.6-1.2-1.2-2.4-1.7-3.4 c-21-39.9-41.4-76.7-64.2-114.2c-0.3-0.9-0.6-1.8-0.8-2.7l-0.1-0.6c-0.2-0.9-0.3-1.8-0.4-2.6l0-0.3c0-0.5-0.1-1-0.1-1.4v24.1 c0,2.5,0.5,5.1,1.5,7.7C90.8,319.9,111.1,356.7,132.2,396.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.4468,
    y1: 464.3978,
    x2: 78.0343,
    y2: 225.7139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7889E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2385,
    style: {
      stopColor: "#7B84DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8178D6"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M0.1,411.9c0,0.5,0.1,1,0.2,1.5c0.1,0.4,0.1,0.9,0.2,1.3c0.1,0.5,0.2,1,0.3,1.6c0.1,0.4,0.2,0.9,0.3,1.3 c0.1,0.5,0.3,1.1,0.4,1.6c0.1,0.4,0.2,0.9,0.3,1.3c0.2,0.6,0.4,1.1,0.6,1.7c0.1,0.4,0.3,0.8,0.4,1.3c0.2,0.6,0.5,1.2,0.8,1.8 c0.2,0.4,0.3,0.8,0.5,1.2c0.3,0.7,0.7,1.4,1,2c0.2,0.3,0.3,0.7,0.5,1c0.6,1,1.1,2.1,1.8,3.1c16.7,22.4,39.8,32.9,66.3,32.9 c10.6,0,21.8-1.7,33.3-5c1.8-0.5,3.5-1,5.2-1.5l0.4-0.1c0.4-0.1,0.8-0.2,1.2-0.4c1.1-0.3,2.3-0.7,3.3-1c0.3-0.1,0.6-0.2,0.9-0.3 c0.3-0.1,0.7-0.2,1-0.3c1-0.3,1.9-0.6,2.9-0.9c0.4-0.1,0.8-0.3,1.2-0.4l0.7-0.2c0.9-0.3,1.8-0.6,2.7-0.9c0.5-0.2,1-0.3,1.5-0.5 l0.3-0.1c0.9-0.3,1.7-0.7,2.6-1c0.5-0.2,1.1-0.4,1.6-0.6c0.9-0.4,1.8-0.7,2.6-1.1c0.4-0.2,0.9-0.4,1.3-0.5c1.2-0.5,2.4-1,3.5-1.5 l0.2-0.1c1.2-0.6,2.4-1.1,3.5-1.7c0.3-0.2,0.6-0.3,0.9-0.5l0.1-0.1c0.8-0.4,1.5-0.8,2.2-1.2c0.4-0.2,0.8-0.4,1.2-0.7l0,0 c0,0,0,0,0,0c0.6-0.4,1.3-0.7,1.9-1.1c0.4-0.2,0.8-0.5,1.2-0.7c0.6-0.4,1.2-0.7,1.7-1.1c0.4-0.2,0.8-0.5,1.1-0.7 c0.6-0.4,1.1-0.8,1.6-1.1l0.1,0c0.3-0.2,0.6-0.5,0.9-0.7c0.6-0.4,1.1-0.8,1.6-1.2l0.1-0.1l0.7-0.5c0.7-0.6,1.4-1.1,2-1.7l0.2-0.2 c0.7-0.6,1.4-1.3,2.1-2l0.6-0.6c0.4-0.5,0.9-0.9,1.3-1.4c0.2-0.3,0.4-0.5,0.7-0.8c0.4-0.4,0.7-0.9,1.1-1.3l0.1-0.2l0.5-0.7 c0.3-0.4,0.6-0.9,0.9-1.3l0.1-0.2c0.2-0.2,0.3-0.5,0.5-0.7c0.3-0.4,0.6-0.9,0.8-1.3l0.1-0.2c0.1-0.2,0.3-0.4,0.4-0.7 c0.3-0.5,0.5-1,0.8-1.4l0.1-0.1l0.3-0.7c0.3-0.6,0.6-1.3,0.9-1.9l0.2-0.3c0.3-0.8,0.6-1.5,0.9-2.3l0.1-0.4l0.1-0.3 c0.2-0.5,0.4-1.1,0.5-1.6c0.1-0.3,0.2-0.6,0.2-0.9c0.1-0.5,0.3-1,0.4-1.5l0.1-0.3c0.1-0.2,0.1-0.5,0.1-0.7l0-0.3 c0.1-0.4,0.2-0.8,0.2-1.2l0.1-0.4l0.1-0.6c0.1-0.5,0.1-1,0.2-1.5l0.1-0.6l0-0.4c0.1-0.5,0.1-1.1,0.1-1.7c0-0.2,0-0.5,0.1-0.7l0-0.1 l0-0.1c0-0.7,0-1.4,0.1-2.1l0-0.4l0,0c0-3.7-0.3-7.6-0.9-11.7c4,0.7,8.5,1,13.8,1c4.4,0,8.9-0.4,13.3-1.1 c5.4-0.8,10.8-1.5,16.4-2.2c45.9-5.2,93.3-3.2,134.8-22.5c0.7,1.1,1.6,2.2,2.5,3.2c6.3,7.4,16.5,13.8,27.2,18.6 c4.3,1.9,9.1,2.9,13.8,2.9c1.1,0,2.1-0.1,3.2-0.2c2.8-0.3,5.5-0.7,8.2-1.2c9.1-1.7,17.7-4.5,24.7-8.1c4.9,10.9,16.4,18.3,29.2,24 c2.1,0.9,4.3,1.8,6.4,2.7c1.6,0.6,3.1,1,4.8,1.4c4.1,0.8,8.3,1.6,12.6,2.2c4.6,0.6,9.3,1.1,13.8,1.1c10.8,0,20.8-2.5,27.5-10.4 c0.5-0.6,1.1-1.2,1.6-1.9l0.3-0.4c0.5-0.7,1-1.4,1.4-2.2l0.2-0.4c0.4-0.7,0.8-1.5,1.2-2.4l0.2-0.4c0.4-0.9,0.9-1.9,1.3-3 c0.1-0.2,0.2-0.5,0.3-0.8c0.3-0.9,0.7-1.7,1-2.6c0.1-0.3,0.2-0.5,0.3-0.8c0.4-1.1,0.8-2.3,1.1-3.5l0.2-0.7c0.3-1,0.6-2.1,0.9-3.2 c0.1-0.3,0.2-0.7,0.3-1c0.3-1.3,0.7-2.6,1-4l0-0.1c0.3-1.3,0.6-2.6,0.9-3.9c0.3-1.2,0.5-2.5,0.8-3.7c0.1-0.5,0.2-1.1,0.3-1.6 c0.3-1.8,0.7-3.7,1-5.5c0-0.3,0.1-0.6,0.1-0.8c0.3-1.6,0.6-3.3,0.8-4.9c0.1-0.7,0.2-1.3,0.3-2c0.2-1.3,0.4-2.6,0.6-3.9 c0.1-0.8,0.2-1.5,0.3-2.3c0.2-1.3,0.4-2.5,0.5-3.8c0.1-0.8,0.2-1.5,0.3-2.3c0.2-1.3,0.4-2.6,0.5-4c0.1-0.7,0.2-1.4,0.3-2.1 c0.2-1.5,0.4-3,0.6-4.5c0.1-0.5,0.1-1,0.2-1.5c0.3-2,0.5-4.1,0.8-6.1c0.2-1.8,0.5-3.6,0.7-5.4c0.1-0.8,0.2-1.5,0.3-2.3 c0.2-1.3,0.3-2.6,0.5-3.9c0.1-0.8,0.2-1.6,0.3-2.3c0.2-1.2,0.3-2.4,0.5-3.6c0.1-0.8,0.2-1.5,0.3-2.3c0.2-1.2,0.3-2.4,0.5-3.6 c0.1-0.7,0.2-1.4,0.3-2.1c0.2-1.3,0.4-2.7,0.6-4c0.1-0.5,0.1-1,0.2-1.4c0.3-1.7,0.5-3.4,0.8-5.1c0.1-0.4,0.1-0.8,0.2-1.2 c0.2-1.2,0.4-2.4,0.6-3.6c0.1-0.6,0.2-1.1,0.3-1.6c0.2-1,0.4-1.9,0.6-2.9c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.3,0.1-0.7,0.2-1 c0.2-0.7,0.3-1.4,0.5-2.1c0.1-0.6,0.3-1.1,0.4-1.7c0.2-0.7,0.3-1.3,0.5-1.9c0.1-0.5,0.3-1,0.4-1.5c0.2-0.6,0.4-1.2,0.6-1.7 c0.2-0.5,0.3-0.9,0.5-1.3c0.2-0.5,0.4-1,0.6-1.5c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.2,0.2-0.5,0.3-0.7l0,0l0.1-0.2l0.1-0.3l0,0l0,0l0,0 l0.4-0.4l0.2-0.1l0.5-0.2l0.3-0.1l0.5-0.2l0.4-0.1l0.6-0.1l0.4-0.1c0.2,0,0.5-0.1,0.7-0.1l0.5-0.1c0.3,0,0.6,0,0.9-0.1l0.4,0 c0.5,0,1,0,1.5,0c0.3,0,0.6-0.1,0.8-0.1l0.2-0.1l0,0l0.4-0.3l0.1-0.1l0,0l0,0l0,0l0.2-0.4l0-0.1l0-0.1l0,0l0.1-0.3l0-0.2v0 c0-0.5-0.1-1-0.4-1.4c-2.7-3.8-7.5-7.3-12.8-10.3c-9.5-5.6-18.3-8.3-25.6-8.3c-10.7,0-18.3,5.7-20.5,16c0,0.3,0,0.7,0.1,1.1l0,0.4 c0,0.4,0,0.7,0,1.2c0,1.3,0,3-0.1,4.9v0c-0.6,24.8-4.9,96.7-6,96.7c-0.9,14.1-3.7,26.9-20.6,26.9c-2.4,0-5.1-0.3-8.2-0.8 c-1.7-0.3-3.3-0.9-4.8-1.8c-7.3-4.4-12-11.1-15.6-22.6c-0.8-3.4-1.3-6.8-1.7-10c-0.5-4.2-0.6-8.3-0.6-12.2c0-3.7,0.2-7.3,0.5-10.8 c0-0.5,0.1-1,0.1-1.5c0.1-1.5,0.3-2.9,0.5-4.4c0-0.3,0.1-0.6,0.1-0.8c0.2-1.9,0.4-3.7,0.7-5.5c0.2-1.4,0.4-2.9,0.5-4.3 c0.1-0.5,0.1-1.1,0.2-1.6c0.2-1.7,0.4-3.4,0.5-5.1c0-0.3,0-0.6,0.1-0.9c0.1-1.4,0.2-2.8,0.3-4.3c0-0.5,0.1-0.9,0.1-1.4 c0.1-1.7,0.2-3.5,0.2-5.2c-3.1-6.3-9.7-8.9-16.9-8.9c-13.5,0-29.1,8.9-28.6,18.9l0,0.5c0.1,0.6,0.2,1.2,0.4,1.8 c-0.2,1-0.2,2.2-0.2,3.5c0,0.3,0,0.7,0,1.1c0,0.2,0,0.4,0,0.7c0,0.4,0,0.8,0.1,1.2l0,0.6l0,0.5c0,0.4,0.1,0.7,0.1,1.1l0,0.4 c0.1,0.7,0.1,1.4,0.2,2.1l0.1,0.6c0.1,0.5,0.1,1.1,0.2,1.7c0,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.1,1,0.2,1.5c0,0.4,0.1,0.7,0.1,1.1 c0.1,0.5,0.1,1,0.2,1.6c0.1,0.5,0.1,1.1,0.2,1.6c0.1,0.5,0.1,1.1,0.2,1.6c0.1,0.5,0.1,1,0.2,1.6c0,0.3,0.1,0.7,0.1,1 c0.1,0.8,0.2,1.7,0.3,2.5l0.1,0.6c0.1,0.7,0.2,1.3,0.2,1.9c0,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.1,1.1,0.2,1.6c0,0.3,0.1,0.7,0.1,1 c0,0.5,0.1,1,0.1,1.5c0,0.3,0.1,0.7,0.1,1c0,0.5,0.1,1,0.1,1.5c0,0.3,0,0.6,0.1,1c0,0.6,0.1,1.1,0.1,1.6c0,0.3,0,0.5,0,0.8 c0,0.8,0,1.6,0,2.3c0,3.6-0.3,6.9-1.1,9.5v0c-0.8,3-2.3,5.2-4.5,6.1c-2.3,1-4.8,1.5-7.3,1.5c-4.7,0-9.3-1.7-12.7-4.8 c-1-1-1.9-1.9-2.8-3l0,0c-0.9-1.1-1.7-2.3-2.5-3.4c-1.6-2.7-2.7-5.5-2.9-8.4l0,0c0,0,0,0,0-0.1c0.6-0.9,1.2-1.9,1.7-2.9 c0.2-0.3,0.3-0.6,0.5-0.9l0-0.1c0.3-0.7,0.7-1.4,1-2.1c0.2-0.4,0.3-0.8,0.5-1.2c0.3-0.7,0.5-1.3,0.7-2l0.2-0.5 c0.1-0.3,0.2-0.5,0.2-0.8c0.2-0.7,0.4-1.3,0.6-2c0.1-0.4,0.2-0.8,0.3-1.2l0-0.1c0.2-0.7,0.3-1.4,0.4-2.1c0.1-0.4,0.2-0.8,0.2-1.2 c0.1-0.8,0.2-1.6,0.3-2.4c0-0.3,0.1-0.6,0.1-0.9c0.1-1,0.1-2,0.1-3.1c0.2-30.6-28.2-65.2-70.5-65.2c-3.2,0-6.6,0.2-10,0.6 c-40.1,5.5-60.2,27.9-70,54.2c-0.4,1.1-2.5,2.5-4.3,2.1c-4.7-31.2-17.4-70.1-28.9-93.7c-1-2.8-2.8-4.4-5-5.1l-0.5-0.2l-0.1,0 c-0.8-0.2-1.6-0.3-2.5-0.3c-8.2,0-19.8,7.6-25.4,11.7c-5.3,3.7-8.5,9.6-8.4,15.6c0,0.6,0.1,1.2,0.1,1.8l0.1,0.5 c0.1,0.7,0.3,1.4,0.5,2.2l0.1,0.4c0.2,0.6,0.4,1.2,0.7,1.8l0.3,0.6c0.4,0.7,0.8,1.4,1.2,2.1c20.8,29.4,35.8,62.5,44.7,100.9 c0.3,0.7,0.5,1.3,0.7,1.9l0.1,0.6c0.1,0.4,0.1,0.8,0.2,1.2c0.1,1.4-0.3,2.7-1,3.8c-0.6,1.1-1.5,2.1-2.7,3c-0.2,0.2-0.5,0.3-0.7,0.5 c-3.1,2.2-7,3.3-10.9,3.3c-2.1,0-4.3-0.3-6.3-0.9c-37-10.9-52.1-71.2-67.8-110.1l0-0.1l-0.1-0.3l-0.2-0.6 c-1.7-4.2-3.4-8.1-5.2-11.7c-0.2-0.4-0.4-0.8-0.6-1.3l-0.1-0.3l0-0.3l0-0.1l0.1-0.2l0.1-0.4l0,0l0.1-0.2l0-0.1l0.2-0.4l0.2-0.3l0,0 l0.2-0.2l0.1-0.2l0.3-0.3l0.1-0.1l0.3-0.3l0,0l0.3-0.3l0.2-0.2l0.3-0.2l0.1-0.1l0.2-0.2l0.5-0.3l0.2-0.1l0.2-0.1l0.1-0.1 c0.3-0.2,0.7-0.4,1-0.5c0.3-0.1,0.5-0.3,0.6-0.4l0.1-0.1l0,0l0.3-0.3l0.1-0.1l0-0.1l0.1-0.3l0-0.1l0-0.1l0-0.1 c0.1-0.9-0.5-1.8-1.3-2.1c-4.3-1.8-10.5-2.2-16.3-2.2c-23.6,0.2-37,10.7-36,24.4l0,0.3c0.1,0.9,0.2,1.7,0.4,2.6l0.1,0.6 c0.2,0.9,0.5,1.8,0.8,2.7c22.8,37.5,43.2,74.3,64.2,114.2c0.6,1.1,1.1,2.2,1.7,3.4l0.1,0.3c0.6,1.2,1.1,2.4,1.7,3.8l0,0.1 c0.6,1.3,1.1,2.7,1.7,4.1l0.1,0.3c0.5,1.4,1,2.8,1.5,4.3l0.1,0.2c0.5,1.5,0.9,3,1.3,4.5l0.1,0.3c0.4,1.5,0.7,3,1,4.5l0.1,0.3 c0.3,1.6,0.5,3.1,0.7,4.7l0,0.3c0.1,1.5,0.2,3,0.2,4.5c0,3.9-0.5,7.7-1.7,11.1c-1.3,3.6-3.4,6.9-6.5,9.5 c-10.1,8.6-23.9,12.3-36.9,12.3c-11.7,0-22.8-3-30.1-8.1c-13.7-6.5-23.5-21.4-27-37.1c-0.1-0.6-0.3-1.2-0.4-1.8 c-0.7-3.6-1.1-7.3-1-10.9l0-0.1c0-1,0-2.1,0.1-3.1l0-0.5c0-0.2,0.1-0.5,0.1-0.7c0-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.3,0-0.4 c0-0.2,0-0.5,0.1-0.7c0-0.3,0.1-0.7,0.1-1c0.1-0.7,0.2-1.4,0.4-2.1l0-0.2l0.1-0.3l0.1-0.4l0-0.1c0.2-0.8,0.4-1.6,0.6-2.3l0.2-0.6 c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.6,0.3-0.9l0.1-0.2c0.2-0.4,0.3-0.9,0.5-1.3c0.1-0.2,0.2-0.5,0.3-0.7l0.2-0.5l0.2-0.4 c0,0,0-0.1,0.1-0.1c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.4-0.6,0.6-1 c0.2-0.3,0.3-0.6,0.5-0.9l0.2-0.3l0.3-0.5c0.5-0.7,1-1.5,1.5-2.2l0,0l0.1-0.2l0-0.1c0.4-0.5,0.8-1,1.1-1.6l0.3-0.5 c0.3-0.4,0.6-0.8,0.8-1.3l0.3-0.5c0.4-0.6,0.7-1.1,1-1.7l0.1-0.2c0.3-0.5,0.5-1,0.8-1.5l0.2-0.5c0.2-0.4,0.3-0.8,0.5-1.1l0.2-0.5 c0.2-0.5,0.3-1,0.4-1.5c0.1-0.6-0.9-0.9-2.1-0.9c-0.9,0-1.9,0.2-2.6,0.5C28,358.3,14.4,370.7,5.4,388.6C2,395.2,0,402,0,409.1 c0,0.5,0,1,0.1,1.5C0.1,411,0.1,411.5,0.1,411.9z M243.7,357.8c0.2-1.3,0.6-2.6,0.8-3.9c0.2-0.8,0.3-1.6,0.5-2.5 c0.2-0.9,0.4-1.9,0.7-2.8c0.4-1.6,0.9-3.1,1.3-4.7c0.2-0.8,0.5-1.7,0.8-2.5c0.6-1.9,1.3-3.7,1.9-5.5c0.2-0.5,0.3-1,0.5-1.5 c0.8-2.1,1.7-4.2,2.7-6.3l0.2-0.4c0.2-0.5,0.5-0.9,0.7-1.4c0.8-1.7,1.7-3.3,2.5-4.9c0.4-0.7,0.7-1.3,1.1-2c0.8-1.4,1.7-2.9,2.6-4.3 c0.4-0.6,0.8-1.2,1.2-1.8c1.3-1.9,2.6-3.8,4.1-5.6l0,0c1.6-2,3.2-4,5-5.8c9.1-10.4,25.3-19.5,40.7-19.5c10.1,0,19.9,4,26.9,14.2 c0.6,0.8,1.1,1.6,1.5,2.5c0.2,0.3,0.3,0.6,0.4,0.9c0.3,0.6,0.6,1.2,0.9,1.8c0.2,0.3,0.3,0.7,0.4,1.1c0.2,0.6,0.5,1.2,0.7,1.8 c0.1,0.4,0.3,0.8,0.4,1.1c0.2,0.6,0.4,1.3,0.5,1.9c0.1,0.4,0.2,0.7,0.3,1.1c0.2,0.7,0.3,1.4,0.4,2.2c0.1,0.3,0.1,0.6,0.2,0.9 c0.2,1,0.3,2.1,0.3,3.1l0,0.4c0.3,4.9-0.3,9.8-1.8,14.3c-1.9,5.9-5.3,11-10.5,14.2c-27.2,17-50.8,15.1-82.5,17h0 c-1.1,0.1-2.2,0.1-3.3,0.2c-0.6,0-1.2-0.3-1.6-0.8c-0.5-0.5-0.7-1.2-0.8-1.8V357.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.1044,
    y1: 324.7029,
    x2: 658.4073,
    y2: 324.7029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05555556,
    style: {
      stopColor: "#23863B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2255,
    style: {
      stopColor: "#83B83B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#86C045"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3966,
    style: {
      stopColor: "#89CA50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5564,
    style: {
      stopColor: "#8BD057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CD259"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M491.1,281.8l146.9-6.7c12.6-0.6,22.4,10.8,20.1,23.1l-11.4,60.2c-2,10.4-11.8,17.3-22.3,15.7l-147.3-23.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 809,
    height: 559,
    xlinkHref: "B9BF3627.png",
    transform: "matrix(0.24 0 0 0.24 469.56 254.44)"
  })), /*#__PURE__*/React.createElement("g", null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M551.3,310c0-0.1,0-0.2,0.1-0.3c-0.1,0.3-0.2,0.7-0.3,1C551.1,310.5,551.2,310.3,551.3,310 C551.2,310.1,551.3,310,551.3,310z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M537.4,307c0.1,0.5,0.2,1.1,0.4,1.6C537.6,308.1,537.4,307.6,537.4,307z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M550.7,311.5c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.2,0.4-0.3,0.7-0.5,1.1c0.1-0.1,0.1-0.2,0.2-0.4 C550.6,311.6,550.7,311.6,550.7,311.5z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M549.8,312.9C549.8,312.8,549.8,312.8,549.8,312.9c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.2,0.3-0.3,0.4-0.5 c-0.2,0.3-0.5,0.6-0.8,0.9c0,0,0,0,0,0C549.6,313,549.7,312.9,549.8,312.9z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M613.2,307.5c0.1,0.3,0.1,0.6,0.1,0.9C613.3,308.1,613.2,307.8,613.2,307.5z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.1,297.8c0,0.1,0,0.2,0,0.3C558.1,298,558.1,297.9,558.1,297.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M575.8,291.2c0.2,0,0.3-0.1,0.5-0.1C576.1,291.1,576,291.2,575.8,291.2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M576.6,290.8c-0.1,0.1-0.2,0.2-0.3,0.2c0,0,0.1,0,0.1-0.1C576.5,290.9,576.5,290.9,576.6,290.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M576.8,290.7C576.8,290.6,576.8,290.6,576.8,290.7C576.8,290.6,576.8,290.6,576.8,290.7 c0.1-0.1,0.1-0.1,0.1-0.2c0,0.1-0.1,0.2-0.2,0.3c0,0,0,0,0,0C576.7,290.7,576.8,290.7,576.8,290.7z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.3,301.9c0,0.2,0,0.4,0,0.6C558.3,302.3,558.3,302.1,558.3,301.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.2,299.7c0,0.1,0,0.2,0,0.3C558.2,299.9,558.2,299.8,558.2,299.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.5,304.2C558.5,304.3,558.5,304.3,558.5,304.2C558.5,304.3,558.5,304.3,558.5,304.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.9,311.7c0,0.7,0,1.4,0,2.2C558.9,313.1,558.9,312.4,558.9,311.7z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M522.8,311c0-0.1,0-0.3,0-0.4C522.8,310.7,522.8,310.9,522.8,311z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.5,304.3c0,0.7,0.1,1.3,0.1,2C558.6,305.7,558.5,305,558.5,304.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.7,306.8c0,0.7,0.1,1.4,0.1,2.1C558.8,308.2,558.7,307.5,558.7,306.8z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.8,309.3c0,0.7,0.1,1.4,0.1,2C558.9,310.7,558.8,310,558.8,309.3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M506.9,313.5c0-0.5-0.1-1-0.1-1.5C506.8,312.4,506.9,313,506.9,313.5z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M620.8,330.6c0.3-0.3,0.5-0.6,0.8-0.9c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.2,0.3-0.4,0.5-0.6 C621.9,329.4,621.4,330,620.8,330.6z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M507.9,318.8c-0.1-0.5-0.2-0.9-0.4-1.4C507.7,317.9,507.8,318.4,507.9,318.8z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M507.3,316.2c-0.1-0.5-0.2-1-0.2-1.5C507.1,315.2,507.2,315.7,507.3,316.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M622.8,328.2C622.8,328.2,622.8,328.2,622.8,328.2c0.2-0.3,0.4-0.5,0.5-0.8c0.1-0.2,0.2-0.3,0.3-0.5 C623.4,327.3,623.1,327.7,622.8,328.2z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M626,321.8c0.1-0.3,0.2-0.7,0.3-1c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2C626.3,320.8,626.2,321.3,626,321.8z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M624.2,326.1c0,0,0-0.1,0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0-0.1,0.1-0.1c0.1-0.2,0.2-0.3,0.2-0.5 C624.6,325.3,624.4,325.7,624.2,326.1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M572.8,294c0-0.4,0.1-0.7,0.2-1.1C572.9,293.2,572.9,293.6,572.8,294z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M626.9,317.6c0-0.1,0-0.3,0-0.4c0-0.4,0.1-0.9,0.1-1.3C627,316.5,627,317.1,626.9,317.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M573,292.8c0.1-0.2,0.1-0.4,0.2-0.6C573.2,292.4,573.1,292.6,573,292.8z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M625.2,324c0.1-0.3,0.3-0.6,0.4-0.9c0-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0,0C625.5,323.1,625.4,323.6,625.2,324z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M613.5,309.8c0,0.3,0,0.7,0,1C613.5,310.4,613.5,310.1,613.5,309.8z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M508.8,321.3c-0.2-0.4-0.3-0.9-0.5-1.3C508.4,320.4,508.6,320.9,508.8,321.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M612.6,305.3c0.1,0.2,0.1,0.5,0.2,0.7C612.8,305.8,612.7,305.5,612.6,305.3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M601.8,298.2c0.1-0.1,0.2-0.2,0.2-0.2C602,298,601.9,298.1,601.8,298.2z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M603.1,297.3c0.1,0,0.1-0.1,0.2-0.1C603.3,297.3,603.2,297.3,603.1,297.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M523.5,305.7c-0.1,0.2-0.1,0.4-0.1,0.7c0,0,0,0,0-0.1C523.4,306.1,523.5,305.9,523.5,305.7z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M602.5,297.7c0.1-0.1,0.2-0.1,0.3-0.2C602.6,297.6,602.5,297.6,602.5,297.7z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M599.3,302.5c0.2-0.5,0.4-1.1,0.7-1.6c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2c0.4-0.7,0.8-1.3,1.2-1.9 C600.6,299.7,599.9,301,599.3,302.5z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M598.1,307.8c-0.1,1-0.2,1.9-0.2,2.9c0-0.9,0.1-1.9,0.2-2.8C598.1,307.9,598.1,307.8,598.1,307.8z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M604.2,304.8c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.7,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1-0.1,0.1-0.1,0.2 c-0.5,0.6-0.9,1.2-1.2,1.9c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,1-0.7,1.6c0,0,0,0.1-0.1,0.1 c-0.2,0.6-0.4,1.2-0.6,1.8c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0,0.2c-0.2,0.7-0.3,1.4-0.4,2.2c0.3,2.2,0.9,4.2,1.7,5.8 c0.7,1.4,4.1,4.7,6.2,4.7c0.2,0,0.3,0,0.5-0.1c2-0.7,3.5-2.1,4.7-3.9c1-1.6,1.6-3.5,2-5.6c-0.3-1.7-0.7-3.2-1.4-4.7 C610.3,307.5,607.7,305,604.2,304.8z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M598.6,304.7C598.6,304.7,598.6,304.6,598.6,304.7c-0.2,0.9-0.4,1.8-0.5,2.8c0.1-0.9,0.3-1.8,0.5-2.6 C598.6,304.8,598.6,304.8,598.6,304.7z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M598.7,304.4c0.1-0.5,0.3-1,0.4-1.5C599,303.4,598.9,303.9,598.7,304.4z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M526,298.7c-0.5,0.9-0.9,1.9-1.3,2.9c0,0,0-0.1,0-0.1C525.1,300.6,525.6,299.6,526,298.7z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M526.4,298c0.3-0.6,0.7-1.2,1.1-1.8C527.1,296.8,526.7,297.4,526.4,298z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M527.9,295.6c0.5-0.7,1-1.4,1.6-2.1C528.9,294.2,528.4,294.9,527.9,295.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M523.7,304.8c0.2-0.9,0.5-1.8,0.9-2.7C524.3,303,524,303.9,523.7,304.8z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M523.1,308c0,0.2-0.1,0.4-0.1,0.6c0-0.2,0-0.3,0.1-0.5C523.1,308,523.1,308,523.1,308z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M537.4,287.3c0.1-0.1,0.2-0.2,0.2-0.3c-0.2,0.2-0.4,0.4-0.5,0.6C537.2,287.5,537.4,287.4,537.4,287.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M530.7,292.2c0.1-0.1,0.2-0.2,0.3-0.3C531,292,530.8,292.1,530.7,292.2z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M536.3,288.3c0.2-0.2,0.4-0.3,0.5-0.5C536.6,288,536.5,288.2,536.3,288.3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M532.6,290.7c-0.1,0.1-0.3,0.2-0.4,0.3C532.3,290.9,532.4,290.9,532.6,290.7 C532.5,290.8,532.5,290.7,532.6,290.7z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M534,289.8c0.3-0.2,0.6-0.4,0.9-0.6C534.6,289.5,534.3,289.7,534,289.8z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M535.3,289.1c0.2-0.1,0.4-0.3,0.7-0.5C535.7,288.8,535.5,288.9,535.3,289.1z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M570.5,328c-0.1,0.2-0.3,0.4-0.4,0.7C570.2,328.5,570.4,328.3,570.5,328z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M567.9,331.9c-0.2,0.2-0.4,0.5-0.6,0.7C567.5,332.4,567.7,332.2,567.9,331.9z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M532.4,339.7c-1-0.2-2-0.5-3-0.7C530.4,339.2,531.4,339.4,532.4,339.7z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M550.7,341.6c-0.2,0-0.4,0-0.6,0C550.4,341.7,550.6,341.6,550.7,341.6z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M569.2,330.1c-0.2,0.3-0.3,0.5-0.5,0.7C568.9,330.6,569.1,330.3,569.2,330.1z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M626.8,318.2c-0.1,0.4-0.1,0.9-0.2,1.3C626.7,319.1,626.7,318.7,626.8,318.2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M549.1,313.5c0.1-0.1,0.2-0.2,0.3-0.3c-0.3,0.3-0.6,0.5-0.9,0.7c0.1-0.1,0.2-0.2,0.4-0.2 C548.9,313.6,549,313.6,549.1,313.5z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M566.5,333.6C566.5,333.6,566.5,333.6,566.5,333.6c0,0-0.1,0.1-0.1,0.1C566.4,333.7,566.5,333.7,566.5,333.6z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M557.8,340C557.7,340,557.7,340,557.8,340C557.7,340,557.7,340,557.8,340z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M555.6,340.7c-0.2,0.1-0.4,0.1-0.5,0.1C555.3,340.8,555.5,340.8,555.6,340.7z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M553,341.4C552.9,341.4,552.9,341.4,553,341.4C552.9,341.4,552.9,341.4,553,341.4z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M562.3,337.5c0,0-0.1,0-0.1,0.1C562.2,337.5,562.3,337.5,562.3,337.5z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M564.7,335.5c-0.2,0.1-0.3,0.3-0.5,0.4C564.4,335.8,564.5,335.7,564.7,335.5z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M520.4,335c-0.4-0.3-0.9-0.5-1.3-0.8C519.5,334.5,519.9,334.7,520.4,335z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M518.1,333.5c-0.4-0.3-0.8-0.6-1.2-0.9C517.3,332.9,517.7,333.2,518.1,333.5z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M516,331.8c-0.4-0.3-0.7-0.6-1-1C515.3,331.2,515.7,331.5,516,331.8z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M560.3,338.8c-0.2,0.1-0.3,0.2-0.5,0.3C560,339,560.1,338.9,560.3,338.8z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M514.2,330c-0.3-0.3-0.6-0.7-0.9-1C513.5,329.3,513.9,329.7,514.2,330z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M511.1,325.9c-0.2-0.4-0.5-0.8-0.7-1.2C510.6,325.2,510.8,325.5,511.1,325.9z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M512.5,328c-0.3-0.4-0.6-0.7-0.8-1.1C512,327.3,512.2,327.7,512.5,328z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M522.8,336.4c-0.5-0.2-1-0.5-1.4-0.7C521.8,335.9,522.3,336.1,522.8,336.4z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M509.8,323.7c-0.2-0.4-0.4-0.8-0.6-1.3C509.4,322.9,509.6,323.3,509.8,323.7z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M528.4,338.6c-0.6-0.2-1.3-0.4-1.9-0.6C527.2,338.2,527.8,338.4,528.4,338.6z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M525.5,337.6c-0.5-0.2-1.1-0.4-1.6-0.7C524.4,337.1,524.9,337.3,525.5,337.6z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M548.3,314C548.3,314,548.3,314,548.3,314c-0.3,0.2-0.7,0.4-1.1,0.5c0.3-0.1,0.6-0.2,0.9-0.3 C548.1,314.1,548.2,314.1,548.3,314z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.2593,
    y1: 306.7478,
    x2: 551.4874,
    y2: 306.7478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBEB"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M537.3,306.5c0,0.2,0,0.3,0,0.5c0.1,0.5,0.2,1.1,0.4,1.6c1.3,3.7,4.5,6.1,7.7,6.1c0.6,0,1.1-0.1,1.6-0.2 c0.4-0.1,0.8-0.3,1.2-0.5c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.9-0.7c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.5-0.6,0.8-0.9 c0,0,0,0,0-0.1c0.2-0.3,0.4-0.7,0.5-1.1c0-0.1,0.1-0.2,0.1-0.4c0.1-0.3,0.2-0.7,0.3-1c0-0.1,0-0.2,0.1-0.3c0.2-1.4,0.1-3-0.5-4.5 c-1.3-3.7-4.5-6.1-7.6-6.1c-0.6,0-1.1,0.1-1.7,0.2C538.6,299.8,536.9,303,537.3,306.5z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M537.7,294.5L537.7,294.5v-7.6c0,0,0,0,0,0.1L537.7,294.5C537.7,294.5,537.7,294.5,537.7,294.5z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M576.9,298v-7.6c0,0,0,0.1,0,0.1L576.9,298C576.9,298,576.9,298,576.9,298z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 572.8428,
    y1: 295.3963,
    x2: 576.866,
    y2: 295.3963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05555535,
    style: {
      stopColor: "#909193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5041,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M576.9,290.5C576.9,290.5,576.9,290.5,576.9,290.5c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c-0.1,0.1-0.3,0.1-0.5,0.1 c-0.7,0.2-1.7-0.1-2.3,0.5c0,0,0,0,0,0c-0.1,0.1-0.2,0.2-0.3,0.4c0,0,0,0,0,0c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0c0,0,0,0,0,0.1 c-0.1,0.3-0.1,0.7-0.2,1.1c0,1.8,0,3.8,0.2,5.9c0,0.2,0,0.3,0,0.5c0.1-0.2,0.1-0.4,0.2-0.5c0,0,0,0,0,0c0.1-0.1,0.2-0.3,0.3-0.4 c0,0,0,0,0,0c0.6-0.7,1.6-0.3,2.3-0.5c0.2,0,0.3-0.1,0.5-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0,0,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.2L576.9,290.5C576.9,290.5,576.9,290.5,576.9,290.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.9196,
    y1: 306.35,
    x2: 613.576,
    y2: 306.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05555535,
    style: {
      stopColor: "#909193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5041,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M613.5,309.8c0-0.5-0.1-0.9-0.2-1.4c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.5-0.2-1-0.4-1.5c-0.1-0.2-0.1-0.5-0.2-0.7 c-0.2-0.7-0.5-1.4-0.8-2.1c-1.6-3.4-4.1-5.9-7.7-6.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.7,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0-0.1,0.1-0.1,0.1c-0.5,0.6-0.9,1.2-1.2,1.9c0,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,1-0.7,1.6 c-0.1,0.1-0.1,0.3-0.1,0.4c-0.2,0.5-0.3,1-0.4,1.5c0,0.1,0,0.2-0.1,0.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2 c-0.2,0.9-0.4,1.7-0.5,2.6c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c-0.1,0.9-0.2,1.9-0.2,2.8c0,1.4,0.1,2.7,0.3,4 c0.1-0.7,0.2-1.5,0.4-2.2c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0.2-0.6,0.3-1.2,0.6-1.8c0,0,0-0.1,0.1-0.1 c0.2-0.5,0.4-1.1,0.7-1.6c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0.4-0.7,0.8-1.3,1.2-1.9c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.3-0.1,0.4-0.2 c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.4-0.1,0.7-0.1c0.1,0,0.1,0,0.2,0c3.5,0.2,6.1,2.7,7.7,6.1c0.7,1.4,1.1,3,1.4,4.7 c0.3-1.6,0.4-3.2,0.3-4.8C613.5,310.4,613.5,310.1,613.5,309.8z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M583.2,309.7v2.8c0-0.5,0-1,0-1.5C583.2,310.6,583.2,310.2,583.2,309.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.0345,
    y1: 306.8629,
    x2: 558.9393,
    y2: 306.8629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05555535,
    style: {
      stopColor: "#909193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5041,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M558.9,311.7c0-0.1,0-0.2,0-0.3c0-0.7-0.1-1.4-0.1-2c0-0.1,0-0.2,0-0.4c0-0.7-0.1-1.4-0.1-2.1 c0-0.2,0-0.3,0-0.5c0-0.7-0.1-1.4-0.1-2c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.6-0.1-1.2-0.1-1.7c0-0.2,0-0.4,0-0.6c0-0.7-0.1-1.3-0.1-1.9 c0-0.1,0-0.2,0-0.3c0-0.6-0.1-1.1-0.1-1.6c0-0.1,0-0.2,0-0.3c0-0.5,0-1.1,0-1.6c0-0.1,0-0.1,0-0.2v7.6c0,3.6,0.6,8.7,0.8,13.9 c0.1-1.3,0.1-2.5,0.1-3.8C558.9,313.1,558.9,312.4,558.9,311.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7462,
    y1: 327.8595,
    x2: 627.1028,
    y2: 327.8595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E9E9E"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M627.1,313.7c0,0.3,0,0.6,0,0.9c0,0.4-0.1,0.8-0.1,1.2c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.4-0.1,0.6 c-0.1,0.4-0.1,0.8-0.2,1.2c-0.1,0.3-0.1,0.5-0.2,0.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c-0.1,0.3-0.2,0.6-0.3,1 c-0.1,0.3-0.2,0.6-0.3,0.9c0,0,0,0,0,0c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.3,0.6-0.4,0.8c-0.1,0.3-0.2,0.6-0.4,0.9 c-0.1,0.1-0.1,0.3-0.2,0.4c0,0,0,0.1-0.1,0.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0,0,0.1-0.1,0.1c-0.2,0.3-0.3,0.5-0.5,0.8 c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.2-0.4,0.5-0.5,0.7c0,0,0,0,0,0c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.3,0.4-0.5,0.5 c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.3-0.5,0.6-0.8,0.8c-0.3,0.2-0.4,0.3-0.7,0.5c-3.2,2.1-6.6,3-10,3c-5.8,0-11.4-2.7-15.3-7.5 c-0.6-0.8-1.3-1.1-2.2-1.1c-1.6,0-3.7,0.9-6.7,1.7c-1.7,0.5-3.7,0.9-6,1.1c-0.4,0-0.7,0-1.1,0c-1.8,0-3.6-0.4-5.2-1.2 c-0.6-0.3-1.2-0.7-1.8-1c-0.4,0.8-0.8,1.5-1.3,2.2c-0.1,0.2-0.3,0.4-0.4,0.6c-0.3,0.4-0.6,0.9-0.9,1.3c-0.2,0.2-0.3,0.5-0.5,0.7 c-0.3,0.4-0.5,0.7-0.8,1.1c-0.2,0.2-0.4,0.5-0.6,0.7c-0.3,0.3-0.5,0.6-0.8,0.9c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c-0.6,0.6-1.1,1.2-1.7,1.7c-0.2,0.1-0.3,0.3-0.5,0.4c-0.6,0.5-1.3,1-1.9,1.5c0,0-0.1,0-0.1,0.1c-0.6,0.4-1.2,0.8-1.9,1.1 c-0.2,0.1-0.3,0.2-0.5,0.3c-0.7,0.3-1.3,0.7-2,0.9c0,0-0.1,0-0.1,0c-0.7,0.3-1.3,0.5-2,0.7c-0.2,0-0.4,0.1-0.5,0.1 c-0.7,0.2-1.4,0.3-2.1,0.5c0,0,0,0-0.1,0c-0.7,0.1-1.4,0.2-2.2,0.3c-0.2,0-0.4,0-0.6,0c-0.7,0-1.5,0.1-2.3,0.1 c-4.9,0-10.1-0.9-15.5-2c-1-0.2-2-0.4-3-0.7c-0.3-0.1-0.6-0.2-0.9-0.3c-0.6-0.2-1.3-0.4-1.9-0.6c-0.4-0.1-0.7-0.3-1.1-0.4 c-0.5-0.2-1.1-0.4-1.6-0.6c-0.4-0.2-0.7-0.3-1.1-0.5c-0.5-0.2-1-0.5-1.4-0.7c-0.4-0.2-0.7-0.4-1-0.6c-0.4-0.3-0.9-0.5-1.3-0.8 c-0.3-0.2-0.6-0.4-1-0.7c-0.4-0.3-0.8-0.6-1.2-0.8c-0.3-0.2-0.6-0.5-0.9-0.8c-0.4-0.3-0.7-0.6-1-0.9c-0.3-0.3-0.6-0.5-0.8-0.8 c-0.3-0.3-0.6-0.6-0.9-1c-0.3-0.3-0.5-0.6-0.7-0.9c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.3-0.4-0.6-0.6-1c-0.2-0.4-0.5-0.7-0.7-1.1 c-0.2-0.3-0.4-0.7-0.6-1c-0.2-0.4-0.4-0.8-0.6-1.2c-0.2-0.4-0.3-0.7-0.5-1.1c-0.2-0.4-0.3-0.8-0.5-1.3c-0.1-0.4-0.2-0.7-0.4-1.1 c-0.1-0.4-0.2-0.9-0.4-1.3c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.5-0.2-0.9-0.2-1.4c-0.1-0.4-0.1-0.8-0.2-1.2c0-0.5-0.1-1-0.1-1.5 c0-0.4,0-0.8-0.1-1.3c0-0.2,0-0.3,0-0.5v7.3c0,14.6,9.5,25,25.6,28.3c5.4,1.1,10.6,2,15.5,2c0.8,0,1.5,0,2.3-0.1 c0.2,0,0.4,0,0.6,0c0.7-0.1,1.5-0.1,2.2-0.3c0,0,0,0,0.1,0c0.7-0.1,1.4-0.3,2.1-0.5c0.2,0,0.4-0.1,0.5-0.1c0.7-0.2,1.4-0.4,2-0.7 c0,0,0.1,0,0.1,0c0.7-0.3,1.4-0.6,2-0.9c0.2-0.1,0.3-0.2,0.5-0.3c0.6-0.3,1.3-0.7,1.9-1.1c0,0,0.1,0,0.1-0.1 c0.6-0.4,1.3-0.9,1.9-1.5c0.2-0.1,0.3-0.3,0.5-0.4c0.6-0.5,1.2-1.1,1.7-1.7c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0 c0.3-0.3,0.5-0.6,0.8-0.9c0.2-0.2,0.4-0.4,0.6-0.7c0.3-0.3,0.5-0.7,0.8-1.1c0.2-0.2,0.4-0.5,0.5-0.7c0.3-0.4,0.6-0.9,0.8-1.3 c0.1-0.2,0.3-0.4,0.4-0.7c0.4-0.7,0.8-1.4,1.3-2.2c0.5,0.4,1.1,0.7,1.8,1c1.6,0.8,3.4,1.2,5.2,1.2c0.4,0,0.7,0,1.1,0 c2.3-0.2,4.3-0.6,6-1.1c3-0.8,5.1-1.7,6.7-1.7c0.9,0,1.6,0.3,2.2,1.1c3.9,4.8,9.6,7.5,15.3,7.5c3.4,0,6.8-0.9,10-3 c0.3-0.2,0.4-0.3,0.7-0.5c0.3-0.3,0.5-0.6,0.8-0.9c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.4,0.6-0.8,0.9-1.2c0.2-0.2,0.4-0.5,0.5-0.7 c0.3-0.4,0.6-0.9,0.8-1.3c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0-0.1,0.1-0.1c0.4-0.7,0.7-1.4,1-2.1c0-0.1,0.1-0.2,0.1-0.3 c0.2-0.6,0.4-1.3,0.6-1.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.4c0.2-0.7,0.3-1.3,0.4-2c0-0.2,0.1-0.5,0.1-0.7 c0.1-0.9,0.2-1.7,0.2-2.6v-7.3C627.1,313.4,627.1,313.6,627.1,313.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.7247,
    y1: 300.7392,
    x2: 537.7332,
    y2: 300.7392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E9E9E"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M523,314.4c0.1-0.3,0.1-0.7,0.2-1c0-0.2,0.1-0.5,0.2-0.7c0.1-0.3,0.1-0.6,0.2-0.9c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0.3-1.1,0.6-2.1,1-3.1c0-0.1,0.1-0.2,0.1-0.3c0.4-1,0.8-1.9,1.3-2.9c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2 c0.4-0.8,0.9-1.5,1.4-2.3c0.1-0.1,0.1-0.1,0.2-0.2c0.5-0.7,1.1-1.4,1.7-2.1c0,0,0,0,0,0c0.2-0.2,0.4-0.4,0.6-0.6 c0.1-0.1,0.3-0.3,0.4-0.4c0.2-0.2,0.4-0.4,0.7-0.6c0.1-0.1,0.3-0.3,0.4-0.4c0.3-0.2,0.5-0.4,0.8-0.6c0.1-0.1,0.2-0.2,0.3-0.2 c0.4-0.2,0.8-0.5,1.2-0.7c0.3-0.2,0.6-0.3,0.9-0.5c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.3,0.7-0.4c0.1-0.1,0.2-0.2,0.3-0.3 c0.2-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.3c0,0,0-0.1,0-0.1c0,0,0,0,0,0 v-7.3c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.4,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3,0.2-0.6,0.4-0.9,0.5 c-0.5,0.2-1,0.5-1.5,0.9c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.4,0.3-0.7,0.5-1.1,0.8c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.4,0.4-0.8,0.8-1.2,1.2c0,0,0,0-0.1,0.1c-0.6,0.6-1.1,1.3-1.6,2c-0.1,0.2-0.3,0.4-0.4,0.6c-0.4,0.6-0.7,1.1-1.1,1.7 c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1-0.1,0.2-0.1,0.2c-0.5,0.9-0.9,1.8-1.3,2.7c0,0,0,0.1,0,0.1c0,0.1-0.1,0.3-0.1,0.4 c-0.3,0.9-0.6,1.7-0.9,2.6c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.2-0.1,0.4c0,0.2-0.1,0.4-0.1,0.6c0,0,0,0,0,0.1 c-0.1,0.5-0.2,1-0.3,1.5c0,0,0,0.1,0,0.1c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.7-0.2,1.3-0.2,2c0,0.1,0,0.3,0,0.4c-0.1,1.6,0,3.2,0.3,4.7 C523,314.6,523,314.5,523,314.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.2296,
    y1: 312.7521,
    x2: 551.4958,
    y2: 312.7521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E9E9E"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M537.3,305.6c0-0.3-0.1-0.6-0.1-1v7.3c0,1,0.2,2,0.5,3c1.3,3.5,4.5,5.8,7.7,5.8c0.6,0,1.1-0.1,1.6-0.2 c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.3-0.3,0.5-0.4 c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.2-0.3,0.5-0.6,0.6-0.9c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0-0.1 c0.2-0.4,0.4-0.8,0.5-1.3c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.2,0.1-0.3c0-0.3,0.1-0.7,0.1-1v-7.3c0,0.3,0,0.7-0.1,1 c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.2-0.1,0.3c0,0,0,0.1,0,0.1c-0.1,0.2-0.1,0.4-0.2,0.5c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.1,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.2-0.2,0.4c0,0,0,0,0,0c-0.1,0.2-0.3,0.3-0.4,0.5 c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1 c-0.3,0.1-0.6,0.2-0.9,0.3c-0.5,0.1-1.1,0.2-1.6,0.2c-3.2,0-6.4-2.3-7.7-5.8c-0.2-0.5-0.3-1-0.4-1.5 C537.3,306,537.3,305.8,537.3,305.6z"
  }))), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M535.8,306.9c0,0.2,0,0.3,0,0.5c0.1,0.5,0.2,1.1,0.4,1.6c1.3,3.7,4.5,6.1,7.7,6.1c0.6,0,1.1-0.1,1.6-0.2 c0.4-0.1,0.8-0.3,1.2-0.5c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.9-0.7c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.5-0.6,0.8-0.9 c0,0,0,0,0-0.1c0.2-0.3,0.4-0.7,0.5-1.1c0-0.1,0.1-0.2,0.1-0.4c0.1-0.3,0.2-0.7,0.3-1c0-0.1,0-0.2,0.1-0.3c0.2-1.4,0.1-3-0.5-4.5 c-1.3-3.7-4.5-6.1-7.6-6.1c-0.6,0-1.1,0.1-1.7,0.2C537.1,300.2,535.4,303.4,535.8,306.9z"
  })), /*#__PURE__*/React.createElement("g", null, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M609.8,321.5c1-1.6,1.6-3.5,2-5.6c0.3-1.6,0.4-3.2,0.3-4.8c0-0.3,0-0.7,0-1c0-0.5-0.1-0.9-0.2-1.4 c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.5-0.2-1-0.4-1.5c-0.1-0.2-0.1-0.5-0.2-0.7c-0.2-0.7-0.5-1.4-0.8-2.1c-1.6-3.4-4.1-5.9-7.7-6.1 c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0-0.1,0.1-0.1,0.1c-0.9,1.1-1.6,2.5-2.2,3.9c-0.1,0.1-0.1,0.3-0.1,0.4c-0.2,0.5-0.3,1-0.4,1.5c0,0.1,0,0.2-0.1,0.3 c-0.2,0.9-0.4,1.9-0.5,2.9c0,0.1,0,0.2,0,0.3c-0.1,1-0.2,1.9-0.2,2.9c0,1.4,0.1,2.7,0.3,4c0.3,2.2,0.9,4.2,1.7,5.8 c0.7,1.3,3.9,4.5,6,4.6C607.5,324.4,608.8,323.1,609.8,321.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 311.5424,
    x2: 627.0883,
    y2: 311.5424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D6D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7181,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    style: {
      stopColor: "#A09F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#7D7B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    style: {
      stopColor: "#555252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9938,
    style: {
      stopColor: "#282425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M599.8,320.5c-0.8-1.6-1.3-3.6-1.7-5.8c-0.2-1.3-0.3-2.6-0.3-4c0-1,0.1-1.9,0.2-2.9c0-0.1,0-0.2,0-0.3 c0.1-1,0.3-2,0.5-2.9c0-0.1,0-0.2,0.1-0.3c0.1-0.5,0.3-1,0.4-1.5c0-0.1,0.1-0.3,0.1-0.4c0.5-1.4,1.2-2.8,2.2-3.9 c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2 c0,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.7,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.2 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c0,0-0.1,0.1-0.1,0.1c-0.9,1.1-1.6,2.5-2.2,3.9 c-0.1,0.1-0.1,0.3-0.1,0.4c-0.2,0.5-0.3,1-0.4,1.5c0,0.1,0,0.2-0.1,0.3c-0.2,0.9-0.4,1.9-0.5,2.9c0,0.1,0,0.2,0,0.3 c-0.1,1-0.2,1.9-0.2,2.9c0,1.4,0.1,2.7,0.3,4c0.3,2.2,0.9,4.2,1.7,5.8c0.7,1.4,4.1,4.7,6.2,4.7c0.2,0,0.3,0,0.5-0.1 c0.3-0.1,0.5-0.2,0.8-0.3C603.7,324.9,600.5,321.8,599.8,320.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 304.4,
    x2: 627.0883,
    y2: 304.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D6D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7181,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    style: {
      stopColor: "#A09F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#7D7B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    style: {
      stopColor: "#555252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9938,
    style: {
      stopColor: "#282425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M572,292.1c-0.1,0.1-0.2,0.2-0.3,0.4c0,0,0,0,0,0c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0c0,0,0,0,0,0.1 c-0.1,0.3-0.1,0.7-0.2,1.1c0,1.8,0,3.8,0.2,5.9c0,0.2,0,0.3,0,0.5c0.5,5.8,1.8,11.9,5.5,15.7c0.5,0.5,1.1,0.7,1.7,0.7 c0.5,0,0.9-0.1,1.3-0.4c-0.6,0-1.1-0.2-1.6-0.7c-3.7-3.8-5-9.9-5.5-15.7c0-0.2,0-0.3,0-0.5c-0.1-2.1-0.2-4-0.2-5.9 c0-0.4,0.1-0.7,0.2-1.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0,0,0,0c0.1-0.1,0.2-0.3,0.3-0.4c0,0,0,0,0,0 c0,0,0.1,0,0.1-0.1C573.1,291.7,572.5,291.7,572,292.1C572.1,292.1,572.1,292.1,572,292.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 288.1115,
    x2: 627.0883,
    y2: 288.1115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D6D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7181,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    style: {
      stopColor: "#A09F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#7D7B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    style: {
      stopColor: "#555252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9938,
    style: {
      stopColor: "#282425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M575.4,290.5c0.1,0.1,0.1,0.2,0,0.4c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.3c0,0,0,0-0.1,0.1c0,0-0.1,0-0.1,0.1 c0.3,0,0.5,0,0.7-0.1c0.2,0,0.3-0.1,0.5-0.1c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.3 c0,0,0,0,0,0c0-0.1,0-0.2,0-0.4c-1.6-3.5-5.2-5.2-8.8-5.2c-1.2,0-2.3,0.2-3.4,0.6c0.6-0.1,1.3-0.2,2-0.2 C570.2,285.3,573.8,287,575.4,290.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 333.6022,
    x2: 627.0883,
    y2: 333.6022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D6D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7181,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    style: {
      stopColor: "#A09F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#7D7B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    style: {
      stopColor: "#555252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9938,
    style: {
      stopColor: "#282425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M569,328.4c-0.1,0.2-0.3,0.4-0.4,0.7c-0.3,0.5-0.6,0.9-0.9,1.4c-0.2,0.3-0.3,0.5-0.5,0.7 c-0.3,0.4-0.5,0.8-0.8,1.1c-0.2,0.2-0.4,0.5-0.6,0.7c-0.3,0.3-0.5,0.6-0.8,0.9c0,0.1-0.1,0.1-0.1,0.2c-0.6,0.6-1.1,1.2-1.7,1.8 c-0.2,0.1-0.3,0.3-0.5,0.4c-0.6,0.6-1.3,1.1-1.9,1.5c0,0-0.1,0-0.1,0.1c-0.6,0.4-1.2,0.8-1.9,1.2c-0.2,0.1-0.3,0.2-0.5,0.3 c-0.7,0.4-1.3,0.7-2,1c0,0-0.1,0-0.1,0c-0.6,0.2-1.2,0.4-1.8,0.6c0.2-0.1,0.5-0.1,0.7-0.2c0.2,0,0.4-0.1,0.5-0.1 c0.7-0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1,0c0.7-0.3,1.4-0.6,2-1c0.2-0.1,0.3-0.2,0.5-0.3c0.6-0.4,1.3-0.8,1.9-1.2c0,0,0.1,0,0.1-0.1 c0.6-0.5,1.3-1,1.9-1.5c0.2-0.1,0.3-0.3,0.5-0.4c0.6-0.5,1.2-1.1,1.7-1.8c0-0.1,0.1-0.1,0.1-0.2c0.3-0.3,0.5-0.6,0.8-0.9 c0.2-0.2,0.4-0.5,0.6-0.7c0.3-0.4,0.5-0.7,0.8-1.1c0.2-0.2,0.4-0.5,0.5-0.7c0.3-0.4,0.6-0.9,0.9-1.4c0.1-0.2,0.3-0.4,0.4-0.7 c0.2-0.4,0.5-0.9,0.7-1.3c-0.3-0.2-0.7-0.4-0.9-0.6C569.9,327,569.5,327.7,569,328.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 310.7825,
    x2: 627.0883,
    y2: 310.7825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.518287e-7,
    style: {
      stopColor: "#404040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M619.1,295.8c-5.2-4.7-11.9-8.1-19.1-8.1c-0.5,0-1.1,0-1.6,0.1c-1.2,0.1-2.3,0.3-3.3,0.6 c0.6-0.1,1.2-0.2,1.8-0.3c0.5,0,1.1-0.1,1.6-0.1c7.2,0,13.9,3.4,19.1,8.1c5.3,4.8,8.1,12,7.9,19.1c0,0.3,0,0.7,0,1 c0,0.6-0.1,1.1-0.1,1.7c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.4-0.1,0.9-0.2,1.3c-0.1,0.3-0.1,0.5-0.2,0.8c-0.1,0.5-0.3,1-0.4,1.4 c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.4-0.3,0.8-0.5,1.2c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.4-0.4,0.8-0.7,1.2c-0.2,0.3-0.3,0.5-0.5,0.8 c-0.3,0.4-0.6,0.9-0.9,1.3c-0.2,0.2-0.3,0.4-0.5,0.6c-0.5,0.6-1,1.2-1.6,1.8c-0.3,0.2-0.4,0.3-0.7,0.5c-1.6,1.1-3.2,1.8-4.9,2.4 c2.2-0.5,4.3-1.4,6.4-2.7c0.3-0.2,0.4-0.3,0.7-0.5c0.6-0.6,1.1-1.2,1.6-1.8c0.2-0.2,0.3-0.4,0.5-0.6c0.3-0.4,0.6-0.8,0.9-1.3 c0.2-0.3,0.3-0.5,0.5-0.8c0.2-0.4,0.5-0.8,0.7-1.2c0.1-0.3,0.3-0.6,0.4-0.9c0.2-0.4,0.3-0.8,0.5-1.2c0.1-0.3,0.2-0.6,0.3-0.9 c0.1-0.5,0.3-1,0.4-1.4c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.4,0.2-0.9,0.2-1.3c0-0.2,0.1-0.4,0.1-0.6c0.1-0.6,0.1-1.1,0.1-1.7 c0-0.3,0-0.7,0-1C627.2,307.9,624.4,300.6,619.1,295.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 326.5491,
    x2: 627.0883,
    y2: 326.5491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBEB"
    }
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M585.8,327c1.5-0.4,2.8-0.9,3.9-1.2c-1.4,0.3-3.1,0.9-5.3,1.5C584.9,327.2,585.4,327.1,585.8,327z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 309.8043,
    x2: 627.0883,
    y2: 309.8043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBEB"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M536.2,287.3c-0.2,0.2-0.4,0.4-0.5,0.6c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.4,0.3-0.5,0.5 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.4,0.3-0.7,0.5c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3,0.2-0.6,0.4-0.9,0.6c-0.5,0.3-1,0.6-1.5,0.9 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.4,0.3-0.7,0.6-1.1,0.9c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.4-0.8,0.8-1.2,1.2c0,0,0,0-0.1,0.1 c-0.6,0.6-1.1,1.4-1.6,2.1c-0.1,0.2-0.3,0.4-0.4,0.6c-0.4,0.6-0.7,1.2-1.1,1.8c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.1-0.1,0.2-0.1,0.2 c-0.5,0.9-0.9,1.9-1.3,2.9c0,0.1-0.1,0.3-0.1,0.4c-0.3,0.9-0.6,1.8-0.9,2.7c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.3-0.1,0.4 c-0.1,0.2-0.1,0.4-0.1,0.7c-0.1,0.5-0.2,1.1-0.3,1.6c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.7-0.2,1.4-0.2,2.1c0,0.1,0,0.3,0,0.4 c-0.1,1.7,0,3.3,0.3,4.9c0.3,2,0.9,3.9,1.9,5.6c2,6,11.7,11.8,20.6,11.8c1.8,0,3.6-0.2,5.2-0.8c0.1,0,0.2-0.1,0.3-0.1 c-1.3,0.3-2.6,0.5-4,0.5c-8.9,0-18.6-5.8-20.6-11.8c-0.9-1.7-1.5-3.6-1.9-5.6c-0.3-1.6-0.3-3.2-0.3-4.9c0-0.1,0-0.3,0-0.4 c0-0.7,0.1-1.4,0.2-2.1c0-0.2,0.1-0.4,0.1-0.6c0.1-0.5,0.2-1.1,0.3-1.6c0-0.2,0.1-0.4,0.1-0.7c0-0.1,0.1-0.3,0.1-0.4 c0-0.2,0.1-0.3,0.1-0.5c0.2-0.9,0.5-1.8,0.9-2.7c0-0.1,0.1-0.3,0.1-0.4c0.4-1,0.8-2,1.3-2.9c0-0.1,0.1-0.2,0.1-0.2 c0.1-0.2,0.2-0.3,0.2-0.5c0.3-0.6,0.7-1.2,1.1-1.8c0.1-0.2,0.3-0.4,0.4-0.6c0.5-0.7,1-1.4,1.6-2.1c0,0,0,0,0.1-0.1 c0.4-0.4,0.8-0.9,1.2-1.2c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.3,0.7-0.6,1.1-0.9c0.1-0.1,0.3-0.2,0.4-0.3c0.5-0.3,1-0.6,1.5-0.9 c0.3-0.2,0.6-0.4,0.9-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.3,0.7-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.1,0.4-0.3,0.5-0.5 c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.4,0.5-0.6c0.3-0.3-0.5-1-1.2-1c-3.9,0.1-7.5,0.6-10.8,1.6c2.9-0.7,6-1.1,9.3-1.2 C535.7,286.3,536.5,287,536.2,287.3z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M582.1,315.8c0.6-0.8,1-1.9,1.1-3.3c0-0.5,0-1,0-1.5c-0.3-8.3,2.8-19.7,11.9-22.5 c-10.2,2-13.8,14.2-13.4,22.9c0,0.5,0,1.1,0,1.5c-0.1,1.4-0.5,2.5-1.1,3.3c-0.1,0.2-0.3,0.4-0.5,0.5c0.1,0,0.1,0,0.2,0 C581,316.7,581.7,316.4,582.1,315.8z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M574.3,291.6c0.2,0,0.3-0.1,0.5-0.1c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2c-0.5,0-1,0-1.4,0.4 C573.9,291.7,574.1,291.7,574.3,291.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.2841,
    y1: 314.8495,
    x2: 554.413,
    y2: 314.8495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D6D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7181,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    style: {
      stopColor: "#A09F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#7D7B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    style: {
      stopColor: "#555252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9938,
    style: {
      stopColor: "#282425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M552.9,341.4c-0.7,0.1-1.4,0.2-2.2,0.3c-0.2,0-0.4,0-0.6,0c-0.7,0.1-1.5,0.1-2.3,0.1c-4.9,0-10.1-1-15.5-2.1 c-1-0.2-2-0.5-3-0.7c-0.3-0.1-0.6-0.2-0.9-0.3c-0.6-0.2-1.3-0.4-1.9-0.6c-0.4-0.1-0.7-0.3-1.1-0.4c-0.5-0.2-1.1-0.4-1.6-0.7 c-0.4-0.2-0.7-0.4-1.1-0.5c-0.5-0.2-1-0.5-1.4-0.7c-0.4-0.2-0.7-0.4-1-0.6c-0.4-0.3-0.9-0.5-1.3-0.8c-0.3-0.2-0.6-0.5-1-0.7 c-0.4-0.3-0.8-0.6-1.2-0.9c-0.3-0.3-0.6-0.5-0.9-0.8c-0.4-0.3-0.7-0.6-1-1c-0.3-0.3-0.6-0.6-0.8-0.9c-0.3-0.3-0.6-0.7-0.9-1 c-0.3-0.3-0.5-0.6-0.7-0.9c-0.3-0.4-0.6-0.7-0.8-1.1c-0.2-0.3-0.4-0.7-0.6-1c-0.2-0.4-0.5-0.8-0.7-1.2c-0.2-0.3-0.4-0.7-0.6-1.1 c-0.2-0.4-0.4-0.8-0.6-1.3c-0.2-0.4-0.3-0.7-0.5-1.1c-0.2-0.4-0.3-0.9-0.5-1.3c-0.1-0.4-0.2-0.8-0.4-1.2c-0.1-0.5-0.2-0.9-0.4-1.4 c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.5-0.2-1-0.2-1.5c-0.1-0.4-0.1-0.9-0.2-1.3c0-0.5-0.1-1-0.1-1.5c0-0.4,0-0.9-0.1-1.3 c0-0.8,0-1.7,0-2.5c1.1-8.1,4.6-12.7,9.4-15.9c3.2-2.1,6.3-3.6,9.5-4.6c-3.8,1-7.4,2.5-11,5c-4.7,3.2-8.3,7.8-9.4,15.9 c0,0.9,0,1.7,0,2.5c0,0.4,0,0.9,0.1,1.3c0,0.5,0.1,1,0.1,1.5c0,0.4,0.1,0.9,0.2,1.3c0.1,0.5,0.1,1,0.2,1.5 c0.1,0.4,0.2,0.8,0.3,1.2c0.1,0.5,0.2,0.9,0.4,1.4c0.1,0.4,0.2,0.8,0.4,1.2c0.1,0.4,0.3,0.9,0.5,1.3c0.1,0.4,0.3,0.8,0.5,1.1 c0.2,0.4,0.4,0.8,0.6,1.3c0.2,0.4,0.4,0.7,0.6,1.1c0.2,0.4,0.5,0.8,0.7,1.2c0.2,0.3,0.4,0.7,0.6,1c0.3,0.4,0.5,0.7,0.8,1.1 c0.2,0.3,0.5,0.6,0.7,0.9c0.3,0.4,0.6,0.7,0.9,1c0.3,0.3,0.5,0.6,0.8,0.9c0.3,0.3,0.7,0.6,1,1c0.3,0.3,0.6,0.5,0.9,0.8 c0.4,0.3,0.8,0.6,1.2,0.9c0.3,0.2,0.6,0.5,1,0.7c0.4,0.3,0.8,0.5,1.3,0.8c0.3,0.2,0.7,0.4,1,0.6c0.5,0.3,0.9,0.5,1.4,0.7 c0.4,0.2,0.7,0.4,1.1,0.5c0.5,0.2,1.1,0.4,1.6,0.7c0.4,0.1,0.7,0.3,1.1,0.4c0.6,0.2,1.3,0.4,1.9,0.6c0.3,0.1,0.6,0.2,0.9,0.3 c1,0.3,2,0.5,3,0.7c5.4,1.1,10.6,2.1,15.5,2.1c0.8,0,1.5,0,2.3-0.1c0.2,0,0.4,0,0.6,0c0.7-0.1,1.5-0.1,2.2-0.3c0,0,0,0,0.1,0 c0.7-0.1,1.4-0.3,2.1-0.5c0.2,0,0.4-0.1,0.5-0.1c0.1,0,0.2-0.1,0.2-0.1C553.9,341.1,553.5,341.3,552.9,341.4 C552.9,341.4,552.9,341.4,552.9,341.4z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M558.8,317.6c0.1-1.3,0.1-2.5,0.1-3.8c0-0.7,0-1.4,0-2.2c0-0.1,0-0.2,0-0.3c0-0.7-0.1-1.4-0.1-2 c0-0.1,0-0.2,0-0.4c0-0.7-0.1-1.4-0.1-2.1c0-0.2,0-0.3,0-0.5c0-0.7-0.1-1.4-0.1-2c0,0,0,0,0-0.1c0,0,0,0,0,0 c0-0.6-0.1-1.2-0.1-1.7c0-0.2,0-0.4,0-0.6c0-0.7-0.1-1.3-0.1-1.9c0-0.1,0-0.2,0-0.3c0-0.6-0.1-1.1-0.1-1.6c0-0.1,0-0.2,0-0.3 c0-0.5,0-1.1,0-1.6c0-1,0-1.8,0.1-2.6c0.3-1.9,0.8-4.2,2-5.4c1.2-1.3,2.8-2.2,4.5-2.7c-2.3,0.4-4.4,1.4-6,3.1 c-1.1,1.2-1.7,3.6-2,5.4c-0.1,0.7-0.1,1.6-0.1,2.6c0,0.5,0,1,0,1.6c0,0.1,0,0.2,0,0.3c0,0.5,0,1.1,0.1,1.6c0,0.1,0,0.2,0,0.3 c0,0.6,0.1,1.3,0.1,1.9c0,0.2,0,0.4,0,0.6c0,0.6,0.1,1.1,0.1,1.7c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.7,0.1,1.3,0.1,2 c0,0.2,0,0.3,0,0.5c0,0.7,0.1,1.4,0.1,2.1c0,0.1,0,0.2,0,0.4c0,0.7,0.1,1.4,0.1,2c0,0.1,0,0.2,0,0.3c0,0.7,0,1.4,0,2.2 c0,1.3,0,2.6-0.1,3.8c-0.4,6.9-2.3,12.9-7.9,14.8c0.4-0.1,0.8-0.1,1.2-0.3C556.5,330.8,558.4,324.7,558.8,317.6z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M613.3,308.4c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.5-0.2-1-0.4-1.5c-0.1-0.2-0.1-0.5-0.2-0.7 c-0.2-0.7-0.5-1.4-0.8-2.1c-1.6-3.4-4.1-5.9-7.7-6.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.7,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0.1-0.3,0.1-0.4,0.2c0,0,0,0,0,0c0,0,0,0,0,0c3.5,0.2,6.1,2.7,7.7,6.1c0.3,0.7,0.6,1.3,0.8,2.1c0.1,0.2,0.1,0.5,0.2,0.7 c0.1,0.5,0.3,1,0.4,1.5c0.1,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.1,0.9,0.2,1.4c0,0.3,0,0.7,0,1c0.1,1.6,0,3.2-0.3,4.8 c-0.4,2.1-1,4-2,5.6c-1,1.6-2.3,2.8-3.9,3.6c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.5-0.1c2-0.7,3.5-2.1,4.7-3.9c1-1.6,1.6-3.5,2-5.6 c0.3-1.6,0.4-3.2,0.3-4.8c0-0.3,0-0.7,0-1C613.5,309.3,613.4,308.9,613.3,308.4z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M594.7,326.3c-0.6-0.8-1.3-1.1-2.2-1.1c-0.8,0-1.7,0.2-2.8,0.5c0.5-0.1,0.9-0.2,1.3-0.2 c0.9,0,1.6,0.3,2.2,1.1c3.9,5,9.6,7.9,15.3,7.9c1.7,0,3.4-0.3,5.2-0.8c-1.2,0.3-2.5,0.4-3.7,0.4 C604.3,334.2,598.6,331.4,594.7,326.3z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M578.8,328.1c-1.8,0-3.6-0.4-5.2-1.3c-0.6-0.3-1.2-0.7-1.8-1.1c-0.2,0.3-0.4,0.6-0.5,1 c0.3,0.2,0.5,0.3,0.8,0.5c1.6,0.9,3.4,1.3,5.2,1.3c0.4,0,0.7,0,1.1,0c2.3-0.2,4.3-0.7,6-1.1c0,0,0.1,0,0.1,0 c-1.4,0.3-2.9,0.6-4.6,0.8C579.5,328.1,579.1,328.1,578.8,328.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.7598,
    y1: 313.539,
    x2: 627.0883,
    y2: 313.539
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBEBEB"
    }
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M619.3,331c0.6-0.6,1.1-1.2,1.6-1.8c0.2-0.2,0.3-0.4,0.5-0.6c0.3-0.4,0.6-0.8,0.9-1.3 c0.2-0.3,0.3-0.5,0.5-0.8c0.2-0.4,0.5-0.8,0.7-1.2c0.1-0.3,0.3-0.6,0.4-0.9c0.2-0.4,0.3-0.8,0.5-1.2c0.1-0.3,0.2-0.6,0.3-0.9 c0.1-0.5,0.3-1,0.4-1.4c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.4,0.2-0.9,0.2-1.3c0-0.2,0.1-0.4,0.1-0.6c0.1-0.6,0.1-1.1,0.1-1.7 c0-0.3,0-0.7,0-1c0.1-7.1-2.7-14.3-7.9-19.1c-5.2-4.7-11.9-8.1-19.1-8.1c-0.5,0-1.1,0-1.6,0.1c-0.6,0-1.2,0.1-1.8,0.3 c-9.1,2.8-12.3,14.3-11.9,22.5c0,0.5,0,1.1,0,1.5c-0.1,1.4-0.5,2.5-1.1,3.3c-0.5,0.6-1.1,0.9-1.8,0.9c-0.1,0-0.1,0-0.2,0 c-0.4,0.3-0.9,0.4-1.3,0.4c-0.6,0-1.3-0.2-1.7-0.7c-3.7-3.8-5-9.9-5.5-15.7c0-0.2,0-0.3,0-0.5c-0.1-2.1-0.2-4-0.2-5.9 c0-0.4,0.1-0.7,0.2-1.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0,0,0,0c0.1-0.1,0.2-0.3,0.3-0.4c0,0,0,0,0,0 c0.4-0.5,1-0.4,1.6-0.4c0.4-0.4,0.9-0.4,1.4-0.4c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0,0,0,0,0,0 c0-0.1,0-0.2,0-0.4c-1.6-3.5-5.2-5.2-8.8-5.2c-0.7,0-1.3,0.1-2,0.2c-1.7,0.5-3.3,1.4-4.5,2.7c-1.1,1.2-1.7,3.6-2,5.4 c-0.1,0.7-0.1,1.6-0.1,2.6c0,0.5,0,1,0,1.6c0,0.1,0,0.2,0,0.3c0,0.5,0,1.1,0.1,1.6c0,0.1,0,0.2,0,0.3c0,0.6,0.1,1.3,0.1,1.9 c0,0.2,0,0.4,0,0.6c0,0.6,0.1,1.1,0.1,1.7c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.7,0.1,1.3,0.1,2c0,0.2,0,0.3,0,0.5 c0,0.7,0.1,1.4,0.1,2.1c0,0.1,0,0.2,0,0.4c0,0.7,0.1,1.4,0.1,2c0,0.1,0,0.2,0,0.3c0,0.7,0,1.4,0,2.2c0,1.3,0,2.6-0.1,3.8 c-0.4,7-2.4,13.1-8.2,14.9c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1,0-0.2,0.1-0.3,0.1c-1.7,0.5-3.4,0.8-5.2,0.8c-8.9,0-18.6-5.8-20.6-11.8 c-0.9-1.7-1.5-3.6-1.9-5.6c-0.3-1.6-0.3-3.2-0.3-4.9c0-0.1,0-0.3,0-0.4c0-0.7,0.1-1.4,0.2-2.1c0-0.2,0.1-0.4,0.1-0.6 c0.1-0.5,0.2-1.1,0.3-1.6c0-0.2,0.1-0.4,0.1-0.7c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0.1-0.3,0.1-0.5c0.2-0.9,0.5-1.8,0.9-2.7 c0-0.1,0.1-0.3,0.1-0.4c0.4-1,0.8-2,1.3-2.9c0-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.2-0.3,0.2-0.5c0.3-0.6,0.7-1.2,1.1-1.8 c0.1-0.2,0.3-0.4,0.4-0.6c0.5-0.7,1-1.4,1.6-2.1c0,0,0,0,0.1-0.1c0.4-0.4,0.8-0.9,1.2-1.2c0.1-0.1,0.2-0.2,0.3-0.3 c0.3-0.3,0.7-0.6,1.1-0.9c0.1-0.1,0.3-0.2,0.4-0.3c0.5-0.3,1-0.6,1.5-0.9c0.3-0.2,0.6-0.4,0.9-0.6c0.1-0.1,0.2-0.1,0.3-0.2 c0.2-0.1,0.4-0.3,0.7-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.4,0.5-0.6 c0.3-0.3-0.5-1-1.2-1c-3.4,0.1-6.4,0.5-9.3,1.2c-3.3,1-6.3,2.4-9.5,4.6c-4.7,3.2-8.3,7.8-9.4,15.9c0,0.9,0,1.7,0,2.5 c0,0.4,0,0.9,0.1,1.3c0,0.5,0.1,1,0.1,1.5c0,0.4,0.1,0.9,0.2,1.3c0.1,0.5,0.1,1,0.2,1.5c0.1,0.4,0.2,0.8,0.3,1.2 c0.1,0.5,0.2,0.9,0.4,1.4c0.1,0.4,0.2,0.8,0.4,1.2c0.1,0.4,0.3,0.9,0.5,1.3c0.1,0.4,0.3,0.8,0.5,1.1c0.2,0.4,0.4,0.8,0.6,1.3 c0.2,0.4,0.4,0.7,0.6,1.1c0.2,0.4,0.5,0.8,0.7,1.2c0.2,0.3,0.4,0.7,0.6,1c0.3,0.4,0.5,0.7,0.8,1.1c0.2,0.3,0.5,0.6,0.7,0.9 c0.3,0.4,0.6,0.7,0.9,1c0.3,0.3,0.5,0.6,0.8,0.9c0.3,0.3,0.7,0.6,1,1c0.3,0.3,0.6,0.5,0.9,0.8c0.4,0.3,0.8,0.6,1.2,0.9 c0.3,0.2,0.6,0.5,1,0.7c0.4,0.3,0.8,0.5,1.3,0.8c0.3,0.2,0.7,0.4,1,0.6c0.5,0.3,0.9,0.5,1.4,0.7c0.4,0.2,0.7,0.4,1.1,0.5 c0.5,0.2,1.1,0.4,1.6,0.7c0.4,0.1,0.7,0.3,1.1,0.4c0.6,0.2,1.3,0.4,1.9,0.6c0.3,0.1,0.6,0.2,0.9,0.3c1,0.3,2,0.5,3,0.7 c5.4,1.1,10.6,2.1,15.5,2.1c0.8,0,1.5,0,2.3-0.1c0.2,0,0.4,0,0.6,0c0.7-0.1,1.5-0.1,2.2-0.3c0,0,0,0,0.1,0c0.5-0.1,1-0.2,1.4-0.3 c0.6-0.2,1.2-0.4,1.8-0.6c0,0,0.1,0,0.1,0c0.7-0.3,1.4-0.6,2-1c0.2-0.1,0.3-0.2,0.5-0.3c0.6-0.4,1.3-0.8,1.9-1.2 c0,0,0.1,0,0.1-0.1c0.6-0.5,1.3-1,1.9-1.5c0.2-0.1,0.3-0.3,0.5-0.4c0.6-0.5,1.2-1.1,1.7-1.8c0-0.1,0.1-0.1,0.1-0.2 c0.3-0.3,0.5-0.6,0.8-0.9c0.2-0.2,0.4-0.5,0.6-0.7c0.3-0.4,0.5-0.7,0.8-1.1c0.2-0.2,0.4-0.5,0.5-0.7c0.3-0.4,0.6-0.9,0.9-1.4 c0.1-0.2,0.3-0.4,0.4-0.7c0.4-0.7,0.8-1.5,1.3-2.3c0.3,0.2,0.6,0.4,0.9,0.6c0.2-0.3,0.4-0.6,0.5-1c0.5,0.4,1.1,0.7,1.8,1.1 c1.6,0.9,3.4,1.3,5.2,1.3c0.4,0,0.7,0,1.1,0c1.7-0.2,3.2-0.4,4.6-0.8c2.2-0.6,3.9-1.3,5.3-1.5c1.1-0.3,2-0.5,2.8-0.5 c0.9,0,1.6,0.3,2.2,1.1c3.9,5,9.6,7.9,15.3,7.9c1.2,0,2.5-0.1,3.7-0.4c1.7-0.5,3.3-1.3,4.9-2.4C618.9,331.3,619.1,331.2,619.3,331 z M613.3,315.6c-0.4,2.1-1,4-2,5.6c-1.1,1.8-2.7,3.2-4.7,3.9c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.5,0.3-0.8,0.3 c-0.2,0-0.3,0.1-0.5,0.1c-2.1,0-5.6-3.3-6.2-4.7c-0.8-1.6-1.3-3.6-1.7-5.8c-0.2-1.3-0.3-2.6-0.3-4c0-1,0.1-1.9,0.2-2.9 c0-0.1,0-0.2,0-0.3c0.1-1,0.3-2,0.5-2.9c0-0.1,0-0.2,0.1-0.3c0.1-0.5,0.3-1,0.4-1.5c0-0.1,0.1-0.3,0.1-0.4 c0.5-1.4,1.2-2.8,2.2-3.9c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.4-0.3 c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.4-0.1,0.7-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0 c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.4-0.1,0.7-0.1c0.1,0,0.1,0,0.2,0c3.5,0.2,6.1,2.7,7.7,6.1 c0.3,0.7,0.6,1.3,0.8,2.1c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.5,0.3,1,0.4,1.5c0.1,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.1,0.9,0.2,1.4 c0,0.3,0,0.7,0,1C613.6,312.4,613.5,314,613.3,315.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st53"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 1499,
    height: 851,
    xlinkHref: "B9BF3622.png",
    transform: "matrix(0.24 0 0 0.24 57.96 362.68)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M376.3,473.9c-1.7-0.9-3.4-1.7-5.1-2.6c1.2-2.5,2-5.3,2.4-8.3c1.7-13,3.3-25.9,4.8-38.8 c1.7-13.6-7.8-25.2-20.8-25.4c-75.4-1.4-148.2,10.8-215.5,34.6c-6.5,0.8-13.1,1.8-19.6,2.9c-3.3,3.7-6.5,7.5-9.6,11.2 c-0.2,0.2-0.4,0.4-0.6,0.7c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-3.9,4.9-4.9,10.9-2.2,16c4,8,8,16.1,11.9,24.2 c4.2,8.5,15.5,13.2,25.5,10.6c64.7-17,133.3-22.4,203-14c4.2,0.5,8.2-0.6,11.8-3c0,0,0,0,0,0C366.8,479.4,371.5,476.6,376.3,473.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M171.2,489.9c3.2,10,6.3,20.2,9.3,30.5c7.9-13.8,16.7-28.1,26.5-42.8C194.8,481.3,182.8,485.5,171.2,489.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M142,433.4c-6.5,0.8-13.1,1.8-19.6,2.9c-3.3,3.7-6.5,7.5-9.6,11.2c-0.2,0.2-0.4,0.4-0.6,0.7 c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-3.9,4.9-4.9,10.9-2.2,16c4,8,8,16.1,11.9,24.2c1.5,3.1,3.9,5.6,6.9,7.5 c33.1-29.2,71.9-59.8,118.1-89.3C210.7,412.5,175.7,421.5,142,433.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M363,475.8c-70-8.9-139-4.2-204,12.1c-11.3,2.8-23.3-1.2-26.9-9.2c-4.1-9.5-8.4-18.8-12.7-28 c-3.8-7.8,3.3-18.4,16.2-23.3c73.2-27.4,153.2-41.2,236.2-38.7c14.7,0.4,25.4,11.3,23.6,23.8c-2,14.5-4.1,29.1-6.4,43.8 C386.9,469,375.2,477.5,363,475.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M175.9,482c3.1,10.2,6.1,20.4,9,30.8c8.2-14,17.4-28.5,27.5-43.4C199.9,473.3,187.8,477.5,175.9,482z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M170.3,445.7c-3.1,0.4-6.3,0.9-9.4,1.4c-2.5-3.1-5.1-6.1-7.7-9.1c-1.9,0.6-3.8,1.2-5.7,1.9 c-0.7,3.9-1.4,7.7-2,11.5c-4,1.9-8,3.8-12,5.8c4.1,1.4,8.1,2.8,12,4.4c0.7,3.7,1.3,7.5,2,11.2c1.8-0.5,3.5-1,5.3-1.6 c1.3-2.2,2.6-4.4,3.9-6.7c4.3,0.7,8.5,1.4,12.7,2.2c1.8-0.5,3.6-0.9,5.4-1.3c-3-4.2-6.1-8.3-9.3-12.3 C167.2,450.6,168.7,448.1,170.3,445.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M158.5,464.7c3.7,0.6,7.4,1.2,11,1.9c1.8-0.5,3.6-0.9,5.4-1.3c-0.9-1.3-1.9-2.6-2.9-3.9 c-5.3-1.2-10.7-2.2-16.2-3C156.8,460.5,157.7,462.6,158.5,464.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M153.2,438c-1.9,0.6-3.8,1.2-5.7,1.9c-0.7,3.9-1.4,7.7-2,11.5c1.9-0.6,3.7-1.2,5.6-1.8 c0.8-3.7,1.6-7.4,2.5-11.2C153.5,438.2,153.4,438.1,153.2,438z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M139.1,455.3c-1.8,0.6-3.7,1.2-5.5,1.9c4.1,1.4,8.1,2.8,12,4.4c1.8-0.6,3.6-1.1,5.5-1.7 C147.1,458.2,143.1,456.7,139.1,455.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M162.6,446.1c-3.1-2.8-6.2-5.5-9.3-8.1c-0.7,3.9-1.4,7.8-2.1,11.6c-4,1.9-8.1,3.7-12,5.7c4,1.4,8,2.9,12,4.6 c0.6,3.8,1.3,7.6,1.9,11.3c3-2.7,6.1-5.5,9.2-8.2c4.3,0.7,8.6,1.5,12.8,2.4c-1.9-3.6-3.8-7.2-5.7-10.7c2.2-3.5,4.4-6.9,6.7-10.5 C171.5,444.7,167,445.4,162.6,446.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M163.9,446.5c-2.6-2.4-5.3-4.8-8-7.1c-0.6,3.4-1.3,6.7-1.9,10.1c-3.5,1.6-7,3.2-10.4,4.8 c3.5,1.3,6.9,2.6,10.3,4c0.5,3.3,1.1,6.6,1.6,9.9c2.6-2.4,5.3-4.7,8-7.1c3.7,0.6,7.4,1.3,11.1,2.1c-1.6-3.1-3.3-6.2-4.9-9.3 c1.9-3,3.8-6,5.8-9C171.6,445.4,167.7,445.9,163.9,446.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M153.9,458.3c0.4,2.3,0.7,4.6,1.1,6.9c3.6-6.3,7.5-12.6,11.4-19.1c-0.9,0.1-1.7,0.3-2.6,0.4 c-1.4-1.3-2.9-2.6-4.4-3.9c-3,4.9-5.8,9.7-8.6,14.5C151.9,457.5,152.9,457.9,153.9,458.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M172,445.3c-0.4,0-0.7,0.1-1.1,0.2c-4.1,6.6-8,13-11.8,19.4c0.7-0.6,1.3-1.2,2-1.8 C164.7,457.2,168.3,451.3,172,445.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M219.9,434.3c-3.2,0.1-6.4,0.3-9.5,0.5c-2.2-3.6-4.5-7.2-6.8-10.7c-2,0.4-3.9,0.9-5.9,1.4 c-1.1,4.1-2.1,8.2-3.2,12.2c-4.2,1.6-8.4,3.2-12.6,4.9c3.9,1.9,7.8,3.9,11.6,6c0.3,4.1,0.6,8.2,0.9,12.3c1.8-0.4,3.7-0.7,5.5-1.1 c1.5-2.3,3-4.5,4.5-6.8c4.2,1.2,8.4,2.4,12.5,3.7c1.8-0.3,3.7-0.6,5.6-0.9c-2.6-4.8-5.3-9.6-8-14.2 C216.3,439.2,218.1,436.8,219.9,434.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M206.2,453.5c3.6,1,7.2,2.1,10.8,3.3c1.8-0.3,3.7-0.6,5.6-0.9c-0.8-1.5-1.6-3-2.5-4.5 c-5.2-1.8-10.5-3.5-15.9-5C204.8,448.8,205.5,451.2,206.2,453.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M203.6,424.2c-2,0.4-3.9,0.9-5.9,1.4c-1.1,4.1-2.1,8.2-3.2,12.2c1.9-0.4,3.8-0.9,5.7-1.3 c1.2-3.9,2.4-7.8,3.6-11.8C203.8,424.5,203.7,424.3,203.6,424.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M187.6,441.2c-1.9,0.5-3.8,0.9-5.7,1.4c3.9,1.9,7.8,3.9,11.6,6c1.9-0.4,3.7-0.8,5.6-1.2 C195.4,445.3,191.5,443.2,187.6,441.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M212.1,433.9c-2.8-3.3-5.6-6.6-8.5-9.8c-1.1,4.1-2.2,8.2-3.3,12.3c-4.2,1.6-8.4,3.1-12.6,4.8 c3.9,2,7.8,4.1,11.6,6.2c0.3,4.1,0.5,8.3,0.8,12.4c3.3-2.6,6.6-5.2,10-7.9c4.2,1.2,8.4,2.5,12.6,3.9c-1.5-4.1-3-8.1-4.6-12.1 c2.5-3.5,5.1-7,7.8-10.5C221.1,433.4,216.6,433.6,212.1,433.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M213.3,434.5c-2.4-2.9-4.8-5.7-7.3-8.5c-1,3.6-1.9,7.1-2.9,10.6c-3.7,1.3-7.3,2.7-10.9,4 c3.4,1.8,6.7,3.6,9.9,5.5c0.2,3.6,0.4,7.2,0.6,10.8c2.9-2.3,5.8-4.5,8.7-6.8c3.7,1.1,7.3,2.2,10.9,3.4c-1.3-3.5-2.6-7-4-10.5 c2.2-3,4.4-6,6.7-9.1C221.2,434.1,217.2,434.3,213.3,434.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M202.1,446.2c0.1,2.5,0.3,5,0.4,7.5c4.3-6.4,8.7-12.8,13.4-19.3c-0.9,0-1.7,0.1-2.6,0.1 c-1.3-1.6-2.6-3.1-4-4.7c-3.5,4.9-6.8,9.8-10.1,14.7C200.2,445,201.2,445.6,202.1,446.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M221.6,434.1c-0.4,0-0.7,0-1.1,0c-4.8,6.6-9.4,13.2-13.8,19.6c0.7-0.6,1.5-1.1,2.2-1.7 C213.1,446.1,217.3,440.1,221.6,434.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M270.8,427.2c-3.2-0.2-6.4-0.3-9.6-0.4c-1.9-4.1-3.8-8.1-5.7-12.1c-2,0.3-4,0.6-6.1,0.9 c-1.5,4.3-3,8.5-4.4,12.7c-4.4,1.3-8.8,2.6-13.1,3.9c3.7,2.5,7.4,5,11,7.7c-0.1,4.4-0.2,8.9-0.4,13.3c1.9-0.2,3.7-0.4,5.6-0.6 c1.7-2.3,3.5-4.5,5.2-6.8c4.1,1.7,8.2,3.4,12.2,5.2c1.9-0.1,3.8-0.3,5.7-0.4c-2.1-5.4-4.3-10.7-6.6-16 C266.7,432.1,268.7,429.6,270.8,427.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M255,446.4c3.5,1.5,7.1,3,10.5,4.5c1.9-0.1,3.8-0.3,5.7-0.4c-0.7-1.7-1.3-3.4-2-5 c-5.1-2.4-10.2-4.7-15.5-6.9C254.2,441.2,254.6,443.8,255,446.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M255.4,414.7c-2,0.3-4,0.6-6.1,0.9c-1.5,4.3-3,8.5-4.4,12.7c2-0.3,3.9-0.6,5.9-0.8 c1.6-4.1,3.2-8.2,4.8-12.3C255.6,415,255.5,414.9,255.4,414.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M237.7,431.3c-2,0.3-3.9,0.6-5.8,0.9c3.7,2.5,7.4,5,11,7.7c1.9-0.3,3.8-0.5,5.8-0.7 C245.1,436.4,241.4,433.8,237.7,431.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M263,426c-2.5-3.8-5-7.6-7.5-11.3c-1.6,4.3-3.1,8.5-4.6,12.8c-4.4,1.2-8.8,2.5-13.2,3.8 c3.7,2.5,7.4,5.2,11,7.9c-0.2,4.5-0.3,8.9-0.5,13.4c3.6-2.5,7.2-5,10.9-7.4c4.1,1.7,8.2,3.5,12.2,5.4c-1.1-4.5-2.2-9-3.4-13.4 c2.9-3.5,5.9-7,8.9-10.5C272.2,426.4,267.6,426.1,263,426z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M264.2,426.7c-2.1-3.3-4.3-6.6-6.5-9.8c-1.4,3.7-2.7,7.4-4,11.1c-3.8,1-7.6,2.1-11.4,3.2 c3.2,2.2,6.3,4.5,9.4,6.9c-0.2,3.9-0.3,7.7-0.5,11.6c3.1-2.1,6.3-4.3,9.5-6.4c3.6,1.5,7.1,3.1,10.6,4.7c-1-3.9-1.9-7.7-2.9-11.6 c2.5-3,5.1-6,7.7-9.1C272.1,427.1,268.2,426.9,264.2,426.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M251.8,438.1c-0.1,2.7-0.2,5.4-0.4,8.1c5-6.4,10.1-12.8,15.4-19.3c-0.9,0-1.8-0.1-2.6-0.1 c-1.2-1.8-2.3-3.6-3.5-5.4c-4,4.9-7.9,9.8-11.7,14.7C249.9,436.7,250.9,437.4,251.8,438.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M272.6,427.1c-0.4,0-0.7,0-1.1-0.1c-5.5,6.6-10.8,13.1-15.9,19.6c0.8-0.5,1.6-1.1,2.4-1.6 C262.7,439.1,267.6,433.1,272.6,427.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M322.9,424.5c-3.2-0.5-6.5-0.9-9.7-1.3c-1.5-4.5-3-9-4.5-13.4c-2.1,0.1-4.1,0.2-6.2,0.3 c-2,4.4-3.9,8.8-5.8,13.1c-4.6,0.9-9.1,1.9-13.6,2.9c3.5,3,6.9,6.1,10.3,9.3c-0.6,4.7-1.2,9.4-1.7,14.1c1.9-0.1,3.8-0.1,5.7-0.1 c2-2.3,4-4.5,6-6.8c4,2.1,7.9,4.4,11.7,6.7c1.9,0,3.8,0,5.8,0.1c-1.6-5.9-3.3-11.8-5-17.6C318.2,429.3,320.5,426.9,322.9,424.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M305,443.5c3.4,1.9,6.8,3.8,10.2,5.8c1.9,0,3.8,0,5.8,0.1c-0.5-1.9-1-3.7-1.5-5.6c-4.9-3.1-9.8-6-14.9-8.8 C304.7,437.8,304.8,440.6,305,443.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M308.7,409.7c-2.1,0.1-4.1,0.2-6.2,0.3c-2,4.4-3.9,8.8-5.8,13.1c2-0.1,4-0.2,6-0.3c2-4.2,4.1-8.4,6.2-12.6 C308.8,410.1,308.8,409.9,308.7,409.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M289.1,425.7c-2,0.1-4,0.3-6,0.4c3.5,3,6.9,6.1,10.3,9.3c2-0.1,3.9-0.2,5.9-0.2 C296,431.9,292.6,428.8,289.1,425.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M315.1,422.5c-2.1-4.3-4.2-8.6-6.4-12.8c-2,4.4-4,8.8-5.9,13.2c-4.6,0.9-9.1,1.8-13.7,2.8 c3.5,3.1,6.9,6.2,10.2,9.4c-0.6,4.7-1.3,9.5-1.9,14.2c3.9-2.3,7.8-4.6,11.7-6.9c4,2.2,7.9,4.5,11.8,6.9c-0.6-4.9-1.3-9.7-2-14.6 c3.3-3.4,6.7-6.9,10.1-10.3C324.4,423.8,319.8,423.1,315.1,422.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M316.3,423.4c-1.8-3.7-3.6-7.4-5.5-11.1c-1.8,3.8-3.5,7.6-5.2,11.4c-4,0.7-7.9,1.5-11.8,2.3 c3,2.7,5.9,5.4,8.8,8.3c-0.6,4.1-1.2,8.2-1.7,12.3c3.4-2,6.8-4,10.2-6c3.4,1.9,6.9,3.9,10.2,6c-0.6-4.2-1.1-8.4-1.8-12.6 c2.9-3,5.8-5.9,8.7-8.9C324.2,424.5,320.3,423.9,316.3,423.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M302.5,434.3c-0.4,2.9-0.8,5.7-1.2,8.6c5.7-6.3,11.5-12.7,17.6-19.1c-0.9-0.1-1.8-0.2-2.7-0.4 c-1-2-2-4.1-3-6.1c-4.5,4.9-9,9.7-13.3,14.5C300.8,432.7,301.7,433.5,302.5,434.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M324.7,424.6c-0.4-0.1-0.7-0.1-1.1-0.2c-6.2,6.5-12.2,13-18,19.4c0.9-0.5,1.7-1,2.6-1.5 C313.5,436.4,319,430.5,324.7,424.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M375.9,426.4c-3.2-0.8-6.5-1.5-9.7-2.3c-1-4.9-2.1-9.8-3.2-14.7c-2.1-0.1-4.2-0.2-6.3-0.2 c-2.4,4.5-4.9,9-7.2,13.4c-4.7,0.6-9.4,1.2-14.1,1.8c3.2,3.5,6.4,7.1,9.5,10.8c-1.1,4.9-2.2,9.9-3.2,14.8c1.9,0.1,3.9,0.2,5.8,0.4 c2.2-2.2,4.5-4.4,6.8-6.6c3.8,2.6,7.5,5.3,11.2,8.1c1.9,0.2,3.9,0.4,5.8,0.6c-1-6.4-2.1-12.8-3.2-19.1 C370.6,431.1,373.2,428.8,375.9,426.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M355.7,444.9c3.3,2.3,6.5,4.7,9.7,7.1c1.9,0.2,3.9,0.4,5.8,0.6c-0.3-2-0.6-4-1-6 c-4.6-3.7-9.3-7.2-14.2-10.6C356,438.9,355.9,441.9,355.7,444.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M363,409.5c-2.1-0.1-4.2-0.2-6.3-0.2c-2.4,4.5-4.9,9-7.2,13.4c2,0.1,4.1,0.2,6.1,0.2 c2.5-4.2,5-8.5,7.5-12.8C363.1,409.9,363.1,409.7,363,409.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M341.5,424.6c-2,0-4.1-0.1-6.1-0.1c3.2,3.5,6.4,7.1,9.5,10.8c2,0.1,4,0.2,6,0.3 C347.8,431.9,344.7,428.2,341.5,424.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M368.2,423.6c-1.7-4.8-3.4-9.5-5.2-14.1c-2.5,4.5-5,9-7.4,13.4c-4.7,0.5-9.4,1.1-14.1,1.7 c3.2,3.6,6.3,7.2,9.4,11c-1.1,5-2.3,9.9-3.4,14.9c4.1-2.1,8.3-4.2,12.6-6.3c3.8,2.7,7.5,5.5,11.2,8.3c-0.1-5.2-0.3-10.4-0.5-15.6 c3.7-3.3,7.5-6.7,11.3-10C377.4,425.8,372.8,424.7,368.2,423.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M369.3,424.7c-1.4-4.1-2.9-8.2-4.4-12.3c-2.2,3.9-4.3,7.7-6.4,11.6c-4.1,0.4-8.2,0.9-12.2,1.4 c2.7,3.1,5.4,6.3,8,9.6c-1,4.3-2,8.6-3,12.9c3.6-1.8,7.3-3.6,11-5.4c3.3,2.4,6.5,4.8,9.7,7.2c-0.1-4.5-0.3-9-0.5-13.5 c3.2-2.9,6.5-5.8,9.8-8.6C377.2,426.6,373.3,425.6,369.3,424.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M354.2,435c-0.7,3-1.4,6-2.1,9c6.4-6.2,13-12.4,19.8-18.7c-0.9-0.2-1.8-0.4-2.7-0.6 c-0.8-2.3-1.6-4.5-2.4-6.7c-5.1,4.7-10.1,9.5-15,14.2C352.7,433.1,353.5,434,354.2,435z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M377.7,426.7c-0.4-0.1-0.7-0.2-1.1-0.3c-7,6.3-13.8,12.6-20.3,18.9c0.9-0.5,1.8-0.9,2.7-1.4 C365.1,438.2,371.3,432.5,377.7,426.7z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.2361,
    y1: 190.1509,
    x2: 530.4003,
    y2: 190.1509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2206,
    style: {
      stopColor: "#021355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#09185C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    style: {
      stopColor: "#152168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4185,
    style: {
      stopColor: "#262F79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4622,
    style: {
      stopColor: "#3C4190"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    style: {
      stopColor: "#5756AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5356,
    style: {
      stopColor: "#776FCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#8178D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#716BC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    style: {
      stopColor: "#5252A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7104,
    style: {
      stopColor: "#3A3F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#29327D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    style: {
      stopColor: "#1F2A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#1C276F"
    }
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M502.6,185.2l-16-18.6l-5.3-26.5v-9.6l-10,10c-2,19.1-12.5,35.6-27.7,45.7l-11.4-0.9l-10,10 c26.2,5.6,46.3,27.6,49.1,54.7l10-10l1.8-20.4c8.9-12.2,22.1-21,37.4-24.3l10-10H502.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.2192,
    y1: 185.1595,
    x2: 530.4003,
    y2: 185.1595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7889E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2385,
    style: {
      stopColor: "#7B84DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8178D6"
    }
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M508.6,175.8c-0.7-0.5-1.3-1-2-1.4c-1.8-1.3-3.5-2.7-5.2-4.2c-0.8-0.7-1.5-1.4-2.3-2.2 c-0.5-0.5-0.9-0.9-1.3-1.4c-0.7-0.8-1.4-1.6-2.1-2.4c-0.4-0.5-0.8-0.9-1.1-1.4c-0.7-0.9-1.4-1.9-2.1-2.8c-0.3-0.4-0.6-0.8-0.9-1.3 c-0.7-1.1-1.4-2.2-2.1-3.4c-4.3-7.5-7.2-15.9-8.1-24.9c-2.8,27.1-22.9,49.1-49.1,54.7c7,1.5,13.6,4.2,19.5,7.9 c1.2,0.7,2.3,1.4,3.4,2.2c0.4,0.3,0.8,0.6,1.2,0.9c0.9,0.7,1.9,1.4,2.8,2.2c0.4,0.4,0.9,0.8,1.3,1.1c0.8,0.7,1.6,1.5,2.4,2.2 c0.4,0.4,0.9,0.9,1.3,1.3c0.7,0.8,1.5,1.6,2.2,2.4c1.5,1.7,2.9,3.5,4.2,5.4c0.6,0.8,1.1,1.6,1.7,2.5c4.9,7.9,8.2,16.9,9.2,26.6 c2.8-27.1,22.9-49.1,49.1-54.7C522.5,183.4,515.1,180.2,508.6,175.8z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M439.1,135.2l-8-9.3l-2.7-13.2v-4.8l-5,5c-1,9.5-6.3,17.8-13.9,22.8l-5.7-0.5l-5,5 C412,143,422,154,423.4,167.5l5-5l0.9-10.2c4.5-6.1,11-10.5,18.7-12.1l5-5H439.1z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M442.1,130.5c-0.3-0.2-0.7-0.5-1-0.7c-0.9-0.7-1.8-1.4-2.6-2.1c-0.4-0.4-0.8-0.7-1.1-1.1 c-0.2-0.2-0.5-0.5-0.7-0.7c-0.4-0.4-0.7-0.8-1.1-1.2c-0.2-0.2-0.4-0.5-0.6-0.7c-0.4-0.5-0.7-0.9-1-1.4c-0.1-0.2-0.3-0.4-0.4-0.6 c-0.4-0.6-0.7-1.1-1.1-1.7c-2.2-3.7-3.6-7.9-4.1-12.4c-1.4,13.6-11.5,24.5-24.5,27.4c3.5,0.8,6.8,2.1,9.7,3.9 c0.6,0.4,1.1,0.7,1.7,1.1c0.2,0.1,0.4,0.3,0.6,0.5c0.5,0.4,0.9,0.7,1.4,1.1c0.2,0.2,0.4,0.4,0.7,0.6c0.4,0.4,0.8,0.7,1.2,1.1 c0.2,0.2,0.4,0.4,0.6,0.7c0.4,0.4,0.7,0.8,1.1,1.2c0.7,0.9,1.4,1.7,2.1,2.7c0.3,0.4,0.6,0.8,0.8,1.2c2.5,3.9,4.1,8.5,4.6,13.3 c1.4-13.6,11.5-24.5,24.5-27.4C449,134.3,445.3,132.7,442.1,130.5z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M400.2,83.1l-6.7-7.8l-2.2-11.1v-4l-4.2,4.2c-0.8,8-5.2,14.9-11.6,19.1l-4.8-0.4l-4.2,4.2 c11,2.4,19.4,11.6,20.5,22.9l4.2-4.2l0.7-8.5c3.7-5.1,9.2-8.8,15.6-10.2l4.2-4.2H400.2z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M402.7,79.2c-0.3-0.2-0.6-0.4-0.8-0.6c-0.8-0.6-1.5-1.1-2.2-1.8c-0.3-0.3-0.6-0.6-0.9-0.9 c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.3-0.6-0.7-0.9-1c-0.2-0.2-0.3-0.4-0.5-0.6c-0.3-0.4-0.6-0.8-0.9-1.2c-0.1-0.2-0.3-0.3-0.4-0.5 c-0.3-0.5-0.6-0.9-0.9-1.4c-1.8-3.1-3-6.6-3.4-10.4c-1.2,11.3-9.6,20.5-20.5,22.9c2.9,0.6,5.7,1.8,8.2,3.3c0.5,0.3,1,0.6,1.4,0.9 c0.2,0.1,0.3,0.3,0.5,0.4c0.4,0.3,0.8,0.6,1.2,0.9c0.2,0.2,0.4,0.3,0.5,0.5c0.3,0.3,0.7,0.6,1,0.9c0.2,0.2,0.4,0.4,0.5,0.6 c0.3,0.3,0.6,0.6,0.9,1c0.6,0.7,1.2,1.5,1.7,2.2c0.2,0.3,0.5,0.7,0.7,1c2.1,3.3,3.4,7.1,3.9,11.1c1.2-11.3,9.6-20.5,20.5-22.9 C408.5,82.4,405.4,81.1,402.7,79.2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M218.1,185.2l16-18.6l5.3-26.5v-9.6l10,10c2,19.1,12.5,35.6,27.7,45.7l11.4-0.9l10,10 c-26.2,5.6-46.3,27.6-49.1,54.7l-10-10l-1.8-20.4c-8.9-12.2-22.1-21-37.4-24.3l-10-10H218.1z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M212.1,175.8c0.7-0.5,1.3-1,2-1.4c1.8-1.3,3.5-2.7,5.2-4.2c0.8-0.7,1.5-1.4,2.3-2.2c0.5-0.5,0.9-0.9,1.3-1.4 c0.7-0.8,1.4-1.6,2.1-2.4c0.4-0.5,0.8-0.9,1.1-1.4c0.7-0.9,1.4-1.9,2.1-2.8c0.3-0.4,0.6-0.8,0.9-1.3c0.7-1.1,1.4-2.2,2.1-3.4 c4.3-7.5,7.2-15.9,8.1-24.9c2.8,27.1,22.9,49.1,49.1,54.7c-7,1.5-13.6,4.2-19.5,7.9c-1.2,0.7-2.3,1.4-3.4,2.2 c-0.4,0.3-0.8,0.6-1.2,0.9c-0.9,0.7-1.9,1.4-2.8,2.2c-0.4,0.4-0.9,0.8-1.3,1.1c-0.8,0.7-1.6,1.5-2.4,2.2c-0.4,0.4-0.9,0.9-1.3,1.3 c-0.7,0.8-1.5,1.6-2.2,2.4c-1.5,1.7-2.9,3.5-4.2,5.4c-0.6,0.8-1.1,1.6-1.7,2.5c-4.9,7.9-8.2,16.9-9.2,26.6 c-2.8-27.1-22.9-49.1-49.1-54.7C198.2,183.4,205.6,180.2,212.1,175.8z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M391.1,167.5l-16-18.6l-5.3-26.5v-9.6l-10,10c-2,19.1-12.5,35.6-27.7,45.7l-11.4-0.9l-10,10 c26.2,5.6,46.3,27.6,49.1,54.7l10-10l1.8-20.4c8.9-12.2,22.1-21,37.4-24.3l10-10H391.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.6709,
    y1: 167.5307,
    x2: 418.852,
    y2: 167.5307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#83B83B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07434362,
    style: {
      stopColor: "#86C045"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2209,
    style: {
      stopColor: "#89CA50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4272,
    style: {
      stopColor: "#8BD057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CD259"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st65",
    cx: 369.8,
    cy: 167.5,
    rx: 49.1,
    ry: 54.7
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M282.8,132.7l8-9.3l2.7-13.2v-4.8l5,5c1,9.5,6.3,17.8,13.9,22.8l5.7-0.5l5,5c-13.1,2.8-23.1,13.8-24.5,27.4 l-5-5l-0.9-10.2c-4.5-6.1-11-10.5-18.7-12.1l-5-5H282.8z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M279.8,128c0.3-0.2,0.7-0.5,1-0.7c0.9-0.7,1.8-1.4,2.6-2.1c0.4-0.4,0.8-0.7,1.1-1.1c0.2-0.2,0.5-0.5,0.7-0.7 c0.4-0.4,0.7-0.8,1.1-1.2c0.2-0.2,0.4-0.5,0.6-0.7c0.4-0.5,0.7-0.9,1-1.4c0.1-0.2,0.3-0.4,0.4-0.6c0.4-0.6,0.7-1.1,1.1-1.7 c2.2-3.7,3.6-7.9,4.1-12.4c1.4,13.6,11.5,24.5,24.5,27.4c-3.5,0.8-6.8,2.1-9.7,3.9c-0.6,0.4-1.1,0.7-1.7,1.1 c-0.2,0.1-0.4,0.3-0.6,0.5c-0.5,0.4-0.9,0.7-1.4,1.1c-0.2,0.2-0.4,0.4-0.7,0.6c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.4,0.4-0.6,0.7 c-0.4,0.4-0.7,0.8-1.1,1.2c-0.7,0.9-1.4,1.7-2.1,2.7c-0.3,0.4-0.6,0.8-0.8,1.2c-2.5,3.9-4.1,8.5-4.6,13.3 c-1.4-13.6-11.5-24.5-24.5-27.4C272.8,131.8,276.5,130.2,279.8,128z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M320.5,83.1l6.7-7.8l2.2-11.1v-4l4.2,4.2c0.8,8,5.2,14.9,11.6,19.1l4.8-0.4l4.2,4.2 c-11,2.4-19.4,11.6-20.5,22.9l-4.2-4.2l-0.7-8.5c-3.7-5.1-9.2-8.8-15.6-10.2l-4.2-4.2H320.5z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M318,79.2c0.3-0.2,0.6-0.4,0.8-0.6c0.8-0.6,1.5-1.1,2.2-1.8c0.3-0.3,0.6-0.6,0.9-0.9c0.2-0.2,0.4-0.4,0.6-0.6 c0.3-0.3,0.6-0.7,0.9-1c0.2-0.2,0.3-0.4,0.5-0.6c0.3-0.4,0.6-0.8,0.9-1.2c0.1-0.2,0.3-0.3,0.4-0.5c0.3-0.5,0.6-0.9,0.9-1.4 c1.8-3.1,3-6.6,3.4-10.4c1.2,11.3,9.6,20.5,20.5,22.9c-2.9,0.6-5.7,1.8-8.2,3.3c-0.5,0.3-1,0.6-1.4,0.9c-0.2,0.1-0.3,0.3-0.5,0.4 c-0.4,0.3-0.8,0.6-1.2,0.9c-0.2,0.2-0.4,0.3-0.5,0.5c-0.3,0.3-0.7,0.6-1,0.9c-0.2,0.2-0.4,0.4-0.5,0.6c-0.3,0.3-0.6,0.6-0.9,1 c-0.6,0.7-1.2,1.5-1.7,2.2c-0.2,0.3-0.5,0.7-0.7,1c-2.1,3.3-3.4,7.1-3.9,11.1c-1.2-11.3-9.6-20.5-20.5-22.9 C312.2,82.4,315.2,81.1,318,79.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70519ba554b92eed374aaeda157a432b.svg";
export { ForwardRef as ReactComponent };